_N_E =
(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[101],{

/***/ "+Mso":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.default = void 0;

var _inherits = _interopRequireDefault(__webpack_require__("rokF"));

var _mixed = _interopRequireDefault(__webpack_require__("tNma"));

var _default = BooleanSchema;
exports.default = _default;

function BooleanSchema() {
  var _this = this;

  if (!(this instanceof BooleanSchema)) return new BooleanSchema();

  _mixed.default.call(this, {
    type: 'boolean'
  });

  this.withMutation(function () {
    _this.transform(function (value) {
      if (!this.isType(value)) {
        if (/^(true|1)$/i.test(value)) return true;
        if (/^(false|0)$/i.test(value)) return false;
      }

      return value;
    });
  });
}

(0, _inherits.default)(BooleanSchema, _mixed.default, {
  _typeCheck: function _typeCheck(v) {
    if (v instanceof Boolean) v = v.valueOf();
    return typeof v === 'boolean';
  }
});
module.exports = exports["default"];

/***/ }),

/***/ "+VQP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.default = void 0;

var _mixed = _interopRequireDefault(__webpack_require__("tNma"));

var _inherits = _interopRequireDefault(__webpack_require__("rokF"));

var _isodate = _interopRequireDefault(__webpack_require__("y/CH"));

var _locale = __webpack_require__("qr7w");

var _isAbsent = _interopRequireDefault(__webpack_require__("kMkq"));

var _Reference = _interopRequireDefault(__webpack_require__("hLcx"));

var invalidDate = new Date('');

var isDate = function isDate(obj) {
  return Object.prototype.toString.call(obj) === '[object Date]';
};

var _default = DateSchema;
exports.default = _default;

function DateSchema() {
  var _this = this;

  if (!(this instanceof DateSchema)) return new DateSchema();

  _mixed.default.call(this, {
    type: 'date'
  });

  this.withMutation(function () {
    _this.transform(function (value) {
      if (this.isType(value)) return value;
      value = (0, _isodate.default)(value);
      return value ? new Date(value) : invalidDate;
    });
  });
}

(0, _inherits.default)(DateSchema, _mixed.default, {
  _typeCheck: function _typeCheck(v) {
    return isDate(v) && !isNaN(v.getTime());
  },
  min: function min(_min, message) {
    if (message === void 0) {
      message = _locale.date.min;
    }

    var limit = _min;

    if (!_Reference.default.isRef(limit)) {
      limit = this.cast(_min);
      if (!this._typeCheck(limit)) throw new TypeError('`min` must be a Date or a value that can be `cast()` to a Date');
    }

    return this.test({
      message: message,
      name: 'min',
      exclusive: true,
      params: {
        min: _min
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value >= this.resolve(limit);
      }
    });
  },
  max: function max(_max, message) {
    if (message === void 0) {
      message = _locale.date.max;
    }

    var limit = _max;

    if (!_Reference.default.isRef(limit)) {
      limit = this.cast(_max);
      if (!this._typeCheck(limit)) throw new TypeError('`max` must be a Date or a value that can be `cast()` to a Date');
    }

    return this.test({
      message: message,
      name: 'max',
      exclusive: true,
      params: {
        max: _max
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value <= this.resolve(limit);
      }
    });
  }
});
module.exports = exports["default"];

/***/ }),

/***/ "/HC4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ FormikInput_FormikInput; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: /opt/webapp/node_modules/formik/dist/formik.esm.js + 78 modules
var formik_esm = __webpack_require__("ljKo");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: /opt/webapp/node_modules/yup/lib/index.js
var lib = __webpack_require__("luEP");

// EXTERNAL MODULE: ./src/client/components/frameworks/formik/inputsUtils.js
var inputsUtils = __webpack_require__("vpua");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.every.js
var es_array_every = __webpack_require__("DfhM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__("vrRf");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.sort.js
var es_array_sort = __webpack_require__("tQbP");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("KqXw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("MvUL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/pick.js
var pick = __webpack_require__("//nZ");
var pick_default = /*#__PURE__*/__webpack_require__.n(pick);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/kebabCase.js
var kebabCase = __webpack_require__("s2Gj");
var kebabCase_default = /*#__PURE__*/__webpack_require__.n(kebabCase);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/frameworks/image-validation-status/ImageValidationStatus.jsx
var __jsx = react_default.a.createElement;




var ImageValidationStatus_ImageValidationStatus = function ImageValidationStatus(_ref) {
  var className = _ref.className,
      isErrored = _ref.isErrored,
      isValidated = _ref.isValidated;
  return __jsx(react["Fragment"], null, isErrored && __jsx(Icon["a" /* Icon */], {
    className: Object(classnames_utils["a" /* classnames */])('pointer-events-none text-red', className),
    name: icons["a" /* ICONS */].CROSS,
    width: "0.8125rem"
  }), isValidated && __jsx(Icon["a" /* Icon */], {
    className: Object(classnames_utils["a" /* classnames */])('pointer-events-none text-success', className),
    name: icons["a" /* ICONS */].CHECK,
    width: "0.8125rem"
  }));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/formik/formik-input/BirthDateInputSeparator.jsx
var BirthDateInputSeparator_jsx = react_default.a.createElement;


var BirthDateInputSeparator_BirthDateInputSeparator = function BirthDateInputSeparator(_ref) {
  var isDisabled = _ref.isDisabled,
      isErrored = _ref.isErrored,
      isValidated = _ref.isValidated,
      position = _ref.position;
  return BirthDateInputSeparator_jsx("span", {
    className: Object(classnames_utils["a" /* classnames */])('pointer-events-none absolute flex h-full items-center', {
      'text-success': isValidated && !isDisabled,
      'text-red': isErrored && !isDisabled
    }),
    style: {
      left: "".concat(position / 3 * 100, "%")
    }
  }, "/");
};
// EXTERNAL MODULE: ./src/client/components/frameworks/formik/formik-input/ErrorNote.jsx
var ErrorNote = __webpack_require__("TuHz");

// EXTERNAL MODULE: ./src/client/components/frameworks/formik/formik-input/Legend.jsx
var Legend = __webpack_require__("hUUf");

// CONCATENATED MODULE: ./src/client/components/frameworks/formik/formik-input/DateInput.jsx























var DateInput_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









var DateInput_DateInput = function DateInput(_ref) {
  var air360ClassName = _ref.air360ClassName,
      className = _ref.className,
      dataTestId = _ref.dataTestId,
      dateFormat = _ref.dateFormat,
      dayPlaceholder = _ref.dayPlaceholder,
      field = _ref.field,
      form = _ref.form,
      hideErrorMessage = _ref.hideErrorMessage,
      isDisabled = _ref.isDisabled,
      isRequired = _ref.isRequired,
      label = _ref.label,
      labelAdditionalInfo = _ref.labelAdditionalInfo,
      monthPlaceholder = _ref.monthPlaceholder,
      onKeyDown = _ref.onKeyDown,
      yearPlaceholder = _ref.yearPlaceholder,
      errorMessage = _ref.errorMessage,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["air360ClassName", "className", "dataTestId", "dateFormat", "dayPlaceholder", "field", "form", "hideErrorMessage", "isDisabled", "isRequired", "label", "labelAdditionalInfo", "monthPlaceholder", "onKeyDown", "yearPlaceholder", "errorMessage"]);

  var _getValidationStatus = Object(inputsUtils["d" /* getValidationStatus */])(field, form, isDisabled),
      isValidated = _getValidationStatus.isValidated,
      isErrored = _getValidationStatus.isErrored,
      isDefaultState = _getValidationStatus.isDefaultState;

  var _useRef = Object(react["useRef"])("dateInput-".concat(field.name)),
      uniqIdentifier = _useRef.current;

  var refFirstInput = Object(react["useRef"])(null);
  var errorNoteId = "error-".concat(kebabCase_default()(field.name)); // Form state (global)

  var date = Object(react["useMemo"])(function () {
    return field.value ? moment_default()(field.value) : null;
  }, [field.value]);
  var dateDay = date && date.isValid() ? date.format('DD') : '';
  var dateMonth = date && date.isValid() ? date.format('MM') : '';
  var dateYear = date && date.isValid() ? date.format('YYYY') : ''; // Field state (local)

  var _useState = Object(react["useState"])(dateDay),
      day = _useState[0],
      setDay = _useState[1];

  var _useState2 = Object(react["useState"])(dateMonth),
      month = _useState2[0],
      setMonth = _useState2[1];

  var _useState3 = Object(react["useState"])(dateYear),
      year = _useState3[0],
      setYear = _useState3[1];

  var onChangeDay = function onChangeDay(_ref2) {
    var target = _ref2.target;
    setDay(target.value);
    Object(inputsUtils["a" /* focusNextInput */])(target);
  };

  var onChangeMonth = function onChangeMonth(_ref3) {
    var target = _ref3.target;
    setMonth(target.value);
    Object(inputsUtils["a" /* focusNextInput */])(target);
  };

  var onChangeYear = function onChangeYear(_ref4) {
    var target = _ref4.target;
    setYear(target.value);
    Object(inputsUtils["a" /* focusNextInput */])(target);
  };

  var structure = [{
    keyPos: 'd',
    name: "".concat(field.name, "-BirthdateInput-day"),
    value: day || dateDay,
    title: 'Day',
    length: 2,
    handleChange: onChangeDay,
    placeholder: dayPlaceholder
  }, {
    keyPos: 'm',
    name: "".concat(field.name, "-BirthdateInput-month"),
    value: month || dateMonth,
    title: 'Month',
    length: 2,
    handleChange: onChangeMonth,
    placeholder: monthPlaceholder
  }, {
    keyPos: 'y',
    name: "".concat(field.name, "-BirthdateInput-year"),
    value: year || dateYear,
    title: 'Year',
    length: 4,
    handleChange: onChangeYear,
    placeholder: yearPlaceholder
  }].sort( // sort each input to respect the locale format (DD/MM/YYYY or YYYY/MM/DD ...)
  // Normalize format: JJ -> DD, AAAA -> YYYY to support both formats
  function (i1, i2) {
    var normalizedFormat = dateFormat.toLowerCase().replace(/j/g, 'd') // Replace 'j' (JJ) with 'd' (DD)
    .replace(/a/g, 'y'); // Replace 'a' (AAAA) with 'y' (YYYY)

    return normalizedFormat.indexOf(i1.keyPos) - normalizedFormat.indexOf(i2.keyPos);
  }); // Update form state on field change

  Object(react["useEffect"])(function () {
    if (structure.every(function (_ref5) {
      var value = _ref5.value,
          length = _ref5.length;
      return value.length === length;
    })) {
      var birthdate = moment_default()([+year, +month - 1, +day]).valueOf();
      form.setFieldValue(field.name, birthdate);
    } else {
      form.setFieldValue(field.name, null);
    }
  }, [day, month, year]);
  Object(react["useEffect"])(function () {
    if (day !== dateDay) {
      setDay(dateDay);
    }

    if (month !== dateMonth) {
      setMonth(dateMonth);
    }

    if (year !== dateYear) {
      setYear(dateYear);
    }
  }, [dateDay, dateMonth, dateYear]);

  var handleBlur = function handleBlur(_ref6) {
    var relatedTarget = _ref6.relatedTarget;

    if (!relatedTarget || !relatedTarget.dataset.dateinputidentifier || !relatedTarget.dataset.dateinputidentifier.includes('uniqIdentifier')) {
      form.setFieldTouched(field.name);
    }
  };

  var handleFocus = function handleFocus(_ref7) {
    var target = _ref7.target;

    if (structure.every(function (_ref8) {
      var value = _ref8.value;
      return value === '';
    }) && refFirstInput.current && target !== refFirstInput.current) {
      refFirstInput.current.focus();
    }
  };

  var dataCsMask = pick_default()(props, 'data-cs-mask');

  var classes = Object(inputsUtils["b" /* getInputClasses */])({
    hasHeight: true,
    hasValidationStatus: true,
    isDefaultState: isDefaultState,
    isDisabled: isDisabled,
    isErrored: isErrored,
    isValidated: isValidated
  });
  return DateInput_jsx("fieldset", {
    className: className
  }, !!label && DateInput_jsx(Legend["a" /* Legend */], {
    className: "mx-15 mb-5",
    isDisabled: isDisabled,
    isRequired: isRequired,
    label: label,
    labelAdditionalInfo: labelAdditionalInfo
  }), DateInput_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(classes, 'direction-ltr relative isolate flex w-full items-center'),
    "data-testid": dataTestId ? "wrapper-".concat(dataTestId) : undefined
  }, DateInput_jsx("div", {
    className: "relative isolate flex flex-1 items-stretch"
  }, structure.map(function (_ref9, key) {
    var name = _ref9.name,
        handleChange = _ref9.handleChange,
        value = _ref9.value,
        length = _ref9.length,
        placeholder = _ref9.placeholder,
        title = _ref9.title;
    return DateInput_jsx("input", Object(esm_extends["a" /* default */])({
      "aria-describedby": errorNoteId,
      autoComplete: "off",
      className: Object(classnames_utils["a" /* classnames */])(air360ClassName, 'h-48 w-full overflow-hidden bg-transparent py-10 text-center text-16 leading-normal outline-none sm:text-14', {
        'cursor-not-allowed opacity-100': isDisabled
      }),
      "data-dateinputidentifier": uniqIdentifier
    }, dataCsMask, {
      "data-testid": "".concat(dataTestId || kebabCase_default()(field.name), "-").concat(title.toLowerCase()),
      disabled: isDisabled,
      key: name,
      maxLength: length,
      name: name,
      onBlur: handleBlur,
      onChange: handleChange,
      onFocus: handleFocus,
      onKeyDown: onKeyDown,
      placeholder: placeholder,
      ref: key === 0 ? refFirstInput : undefined,
      style: _objectSpread({}, isDisabled ? {
        WebkitTextFillColor: '#a0a0a0'
      } : {}),
      title: title,
      type: "tel",
      value: value
    }));
  }), DateInput_jsx(BirthDateInputSeparator_BirthDateInputSeparator, {
    isDisabled: isDisabled,
    isErrored: isErrored,
    isValidated: isValidated,
    position: 1
  }), DateInput_jsx(BirthDateInputSeparator_BirthDateInputSeparator, {
    isDisabled: isDisabled,
    isErrored: isErrored,
    isValidated: isValidated,
    position: 2
  })), !isDisabled && DateInput_jsx(ImageValidationStatus_ImageValidationStatus, {
    className: "absolute end-0 mx-20",
    isErrored: isErrored,
    isValidated: isValidated
  })), !hideErrorMessage && DateInput_jsx(ErrorNote["a" /* ErrorNote */], {
    className: "mx-15",
    errorMessage: errorMessage !== null && errorMessage !== void 0 ? errorMessage : get_default()(form.errors, field.name),
    errorNoteId: errorNoteId,
    isErrored: isErrored
  }));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("lTEL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("kYxP");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/formik/formik-input/Checkbox.jsx















var Checkbox_jsx = react_default.a.createElement;

function Checkbox_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function Checkbox_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Checkbox_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Checkbox_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var Checkbox_Checkbox = function Checkbox(_ref) {
  var ariaDescribedBy = _ref.ariaDescribedBy,
      className = _ref.className,
      dataTestId = _ref.dataTestId,
      field = _ref.field,
      form = _ref.form,
      _ref$iconColor = _ref.iconColor,
      iconColor = _ref$iconColor === void 0 ? colors["a" /* COLORS */].BLACK : _ref$iconColor,
      iconName = _ref.iconName,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      _ref$isRequired = _ref.isRequired,
      isRequired = _ref$isRequired === void 0 ? false : _ref$isRequired,
      label = _ref.label,
      _ref$isFlex = _ref.isFlex,
      isFlex = _ref$isFlex === void 0 ? true : _ref$isFlex,
      _onChange = _ref.onChange,
      onClick = _ref.onClick,
      placeholderComponent = _ref.placeholderComponent;

  // Checkbox value defaults to false
  var value = get_default()(form.values, field.name, false);

  var _getValidationStatus = Object(inputsUtils["d" /* getValidationStatus */])(Checkbox_objectSpread(Checkbox_objectSpread({}, field), {}, {
    value: value
  }), form, isDisabled),
      isValidated = _getValidationStatus.isValidated,
      isErrored = _getValidationStatus.isErrored;

  var checkboxId = "checkbox-".concat(kebabCase_default()(field.name));
  return Checkbox_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('gap-10 text-14', {
      'formik-errored': isErrored && isRequired,
      'flex items-center justify-between': isFlex
    }, className)
  }, iconName && Checkbox_jsx(Icon["a" /* Icon */], {
    className: "shrink-0 text-".concat(iconColor),
    name: iconName,
    width: "1em"
  }), Checkbox_jsx("label", {
    className: Object(classnames_utils["a" /* classnames */])('flex w-full items-start gap-10', {
      'cursor-pointer': !isDisabled,
      'cursor-not-allowed': isDisabled,
      'leading-0': !placeholderComponent
    }),
    htmlFor: checkboxId
  }, Checkbox_jsx("input", Object(esm_extends["a" /* default */])({
    "aria-describedby": ariaDescribedBy,
    className: "sr-only",
    "data-testid": dataTestId,
    disabled: isDisabled,
    id: checkboxId,
    type: "checkbox"
  }, field, {
    checked: value,
    onChange: function onChange(e) {
      field.onChange(e);

      if (_onChange) {
        _onChange(e);
      }
    },
    onClick: onClick ? onClick : field.onClick
  })), !placeholderComponent && Checkbox_jsx("span", {
    className: Object(classnames_utils["a" /* classnames */])('outline-custom-sibling flex h-24 w-24 shrink-0 items-center justify-center rounded-8 border p-2', {
      'border-black': !isDisabled,
      'border-grey bg-pearl': isDisabled,
      'text-success': isValidated && isRequired,
      'formik-errored text-red': isErrored && isRequired
    })
  }, !!value && Checkbox_jsx(Icon["a" /* Icon */], {
    className: "text-black",
    name: icons["a" /* ICONS */].CHECK,
    width: "1em"
  })), label && Checkbox_jsx("span", {
    className: "mt-1 inline-block text-14 font-bold leading-normal text-black"
  }, Checkbox_jsx("span", null, label), isRequired && '*'), placeholderComponent && placeholderComponent(value)));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/shortid/index.js
var shortid = __webpack_require__("MIfU");
var shortid_default = /*#__PURE__*/__webpack_require__.n(shortid);

// CONCATENATED MODULE: ./src/client/components/frameworks/formik/formik-input/CreditCardExpiryInput.jsx








var CreditCardExpiryInput_jsx = react_default.a.createElement;






var CreditCardExpiryInput_CreditCardExpiryInput = function CreditCardExpiryInput(_ref) {
  var className = _ref.className,
      label = _ref.label,
      field = _ref.field,
      isRequired = _ref.isRequired,
      isDisabled = _ref.isDisabled,
      form = _ref.form,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["className", "label", "field", "isRequired", "isDisabled", "form"]);

  var _getValidationStatus = Object(inputsUtils["d" /* getValidationStatus */])(field, form),
      isDefaultState = _getValidationStatus.isDefaultState,
      isErrored = _getValidationStatus.isErrored,
      isValidated = _getValidationStatus.isValidated;

  var _useRef = Object(react["useRef"])("dateInput-".concat(shortid_default.a.generate())),
      uniqIdentifier = _useRef.current;

  var refFirstInput = Object(react["useRef"])(null);

  var _useState = Object(react["useState"])(''),
      month = _useState[0],
      setMonth = _useState[1];

  var _useState2 = Object(react["useState"])(''),
      year = _useState2[0],
      setYear = _useState2[1];

  var onChangeMonth = function onChangeMonth(_ref2) {
    var target = _ref2.target;
    setMonth(target.value);
    Object(inputsUtils["a" /* focusNextInput */])(target);
  };

  var onChangeYear = function onChangeYear(_ref3) {
    var target = _ref3.target;
    setYear(target.value);
    Object(inputsUtils["a" /* focusNextInput */])(target);
  };

  var structure = [{
    keyPos: 'm',
    name: "".concat(field.name, "-CreditCardExpiryInput-month"),
    value: month,
    length: 2,
    handleChange: onChangeMonth,
    placeholder: props.monthPlaceholder
  }, {
    keyPos: 'y',
    name: "".concat(field.name, "-CreditCardExpiryInput-year"),
    value: year,
    length: 2,
    handleChange: onChangeYear,
    placeholder: props.yearPlaceholder
  }].sort( // sort each input to respect the locale format (MM/YYYY or YYYY/MM ...)
  function (i1, i2) {
    return props.dateFormat.toLowerCase().indexOf(i1.keyPos) - props.dateFormat.toLowerCase().indexOf(i2.keyPos);
  });
  Object(react["useEffect"])(function () {
    // if no value is entered, no need to set fields to null
    if (!month && !year) {
      return;
    } // when the date is incomplete erase the stored birth date to null to not store an invalid date


    if (!structure.every(function (_ref4) {
      var value = _ref4.value,
          length = _ref4.length;
      return value.length === length;
    })) {
      /**
       * setFieldValue returns a promise even if the doc says the opposite
       * https://github.com/jaredpalmer/formik/blob/f117c04738ed218b5eb8916d7189e0849962d50d/packages/formik/src/Formik.tsx#L602
       * BUT useEffect does not allow a promise as return...
       */
      form.setFieldValue(field.name, null);
      return;
    }

    var expiryDate = moment_default()([+year, +month], 'YY-MM');
    form.setFieldValue(field.name, expiryDate.valueOf());
  }, [month, year]);

  var handleBlur = function handleBlur(_ref5) {
    var relatedTarget = _ref5.relatedTarget;

    if (!relatedTarget || !relatedTarget.dataset.dateinputidentifier || !relatedTarget.dataset.dateinputidentifier.includes('uniqIdentifier')) {
      form.setFieldTouched(field.name);
    }
  };

  var handleFocus = function handleFocus(_ref6) {
    var target = _ref6.target;

    if (structure.every(function (_ref7) {
      var value = _ref7.value;
      return value === '';
    }) && refFirstInput.current && target !== refFirstInput.current) {
      refFirstInput.current.focus();
    }
  };

  var classes = Object(inputsUtils["b" /* getInputClasses */])({
    hasHeight: true,
    isDefaultState: isDefaultState,
    isDisabled: isDisabled,
    isErrored: isErrored,
    isValidated: isValidated
  });
  return CreditCardExpiryInput_jsx(react_default.a.Fragment, null, CreditCardExpiryInput_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(classes, 'flex isolate relative', className)
  }, structure.map(function (_ref8, key) {
    var name = _ref8.name,
        handleChange = _ref8.handleChange,
        value = _ref8.value,
        length = _ref8.length,
        placeholder = _ref8.placeholder;
    return CreditCardExpiryInput_jsx("input", {
      autoComplete: "off",
      className: "outline-none",
      ref: key === 0 ? refFirstInput : undefined,
      key: name,
      name: name,
      type: "tel",
      onChange: handleChange,
      onBlur: handleBlur,
      onFocus: handleFocus,
      maxLength: length,
      value: value,
      placeholder: placeholder,
      disabled: isDisabled,
      "data-dateinputidentifier": uniqIdentifier
    });
  }), CreditCardExpiryInput_jsx("span", {
    className: Object(classnames_utils["a" /* classnames */])('absolute flex items-center left-1/2 pointer-events-none -mx-20', {
      'text-success': isValidated,
      'text-red': form.touched[field.name] && isErrored
    })
  }, "/")), CreditCardExpiryInput_jsx(ErrorNote["a" /* ErrorNote */], {
    className: "mx-15",
    isErrored: isErrored,
    errorMessage: form.errors[field.name]
  }));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("M+/F");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// CONCATENATED MODULE: ./src/client/components/frameworks/formik/formik-input/useStateRef.js


var useStateRef_useStateRef = function useStateRef(initalState) {
  var _useState = Object(react["useState"])(initalState),
      state = _useState[0],
      setState = _useState[1];

  var ref = Object(react["useRef"])(initalState);

  var setStateRef = function setStateRef(newState) {
    setState(newState);
    ref.current = newState;
  };

  return [state, setStateRef, ref];
};

/* harmony default export */ var formik_input_useStateRef = (useStateRef_useStateRef);
// CONCATENATED MODULE: ./src/client/components/frameworks/formik/formik-input/DatalistInput.jsx









var DatalistInput_jsx = react_default.a.createElement;




var labelMatch = function labelMatch(currentInput, item) {
  return item.label.substr(0, currentInput.length).toLowerCase() === currentInput.toLowerCase();
};

var indexOfMatch = function indexOfMatch(currentInput, item) {
  return item.label.toLowerCase().indexOf(currentInput.toLowerCase());
};

var indexOfItem = function indexOfItem(item, items) {
  return items.indexOf(items.find(function (i) {
    return i.key === item.key;
  }));
};

var DatalistInput_DataListInput = function DataListInput(_ref) {
  var className = _ref.className,
      dataTestId = _ref.dataTestId,
      activeItemClassName = _ref.activeItemClassName,
      dropdownClassName = _ref.dropdownClassName,
      dropDownLength = _ref.dropDownLength,
      value = _ref.value,
      inputClassName = _ref.inputClassName,
      itemClassName = _ref.itemClassName,
      onSelect = _ref.onSelect,
      onBlur = _ref.onBlur,
      placeholder = _ref.placeholder,
      _ref$requiredInputLen = _ref.requiredInputLength,
      requiredInputLength = _ref$requiredInputLen === void 0 ? 1 : _ref$requiredInputLen,
      items = _ref.items,
      field = _ref.field;

  var _useState = Object(react["useState"])(),
      lastValidItem = _useState[0],
      setLastValidItem = _useState[1];

  var _useStateRef = formik_input_useStateRef(value !== undefined ? value : ''),
      _useStateRef2 = Object(slicedToArray["a" /* default */])(_useStateRef, 3),
      currentInput = _useStateRef2[0],
      setCurrentInput = _useStateRef2[1],
      currentInputRef = _useStateRef2[2];

  var _useState2 = Object(react["useState"])([]),
      matchingItems = _useState2[0],
      setMatchingItems = _useState2[1];

  var _useStateRef3 = formik_input_useStateRef(false),
      _useStateRef4 = Object(slicedToArray["a" /* default */])(_useStateRef3, 3),
      visible = _useStateRef4[0],
      setVisible = _useStateRef4[1],
      visibleRef = _useStateRef4[2];

  var _useState3 = Object(react["useState"])(0),
      focusIndex = _useState3[0],
      setFocusIndex = _useState3[1];

  var interactionHappenedRef = Object(react["useRef"])(false);

  var _useState4 = Object(react["useState"])(false),
      isMatchingDebounced = _useState4[0],
      setIsMatchingDebounced = _useState4[1];

  var menu = Object(react["useRef"])();
  var inputField = Object(react["useRef"])();
  Object(react["useEffect"])(function () {
    var onClickCloseMenu = function onClickCloseMenu(event) {
      if (!menu.current) {
        return;
      } // if rerender, items inside might change, allow one click without further checking


      if (interactionHappenedRef.current) {
        interactionHappenedRef.current = false;
        return;
      } // do not do anything if input is clicked, as we have a dedicated func for that


      if (!inputField.current) {
        return;
      }

      var targetIsInput = event.target === inputField.current;
      var targetInInput = inputField.current.contains(event.target);

      if (targetIsInput || targetInInput) {
        return;
      } // do not close menu if user clicked inside


      var targetInMenu = menu.current.contains(event.target);
      var targetIsMenu = event.target === menu.current;

      if (targetInMenu || targetIsMenu) {
        return;
      }

      if (visibleRef.current) {
        setVisible(false);
        setFocusIndex(-1);
      }
    };

    window.addEventListener('click', onClickCloseMenu, false);
    return function () {
      window.removeEventListener('click', onClickCloseMenu);
    };
  }, [setVisible, visibleRef]);
  Object(react["useEffect"])(function () {
    var isValuePropSet = value !== undefined;
    var isValueDifferent = currentInputRef.current !== value;
    var isMatchingRunning = visible || isMatchingDebounced;

    if (isValuePropSet && isValueDifferent && !isMatchingRunning) {
      setCurrentInput(value);
    }
  }, [visible, isMatchingDebounced, value, setCurrentInput, currentInputRef]);
  var debouncedMatchingUpdateStep = Object(react["useCallback"])(function (nextInput) {
    var reachedRequiredLength = nextInput.length >= requiredInputLength;
    var showMatchingStillLoading = false;
    setCurrentInput(nextInput);
    setIsMatchingDebounced(showMatchingStillLoading); // no matching if we do not reach required input length

    if (!reachedRequiredLength) {
      return;
    }

    var updateMatchingItems = function updateMatchingItems() {
      // matching process to find matching entries in items array
      var updatedMatchingItems = items.filter(function (item) {
        return labelMatch(nextInput, item);
      });
      var displayableItems = updatedMatchingItems.slice(0, dropDownLength);
      var showDragIndex = !!lastValidItem;
      var index = showDragIndex ? indexOfItem(lastValidItem, displayableItems) : 0;

      if (displayableItems.length) {
        setMatchingItems(displayableItems);
        setFocusIndex(index > 0 ? index : 0);
        setIsMatchingDebounced(false);
        setVisible(true);
      } else {
        if (visibleRef.current) {
          setVisible(false);
        }

        setMatchingItems(displayableItems);
        setFocusIndex(-1);
        setIsMatchingDebounced(false);
      }
    };

    updateMatchingItems();
  }, [requiredInputLength, setCurrentInput, items, dropDownLength, lastValidItem, setVisible, visibleRef]);
  var onHandleInput = Object(react["useCallback"])(function (event) {
    var newValue = event.target.value;
    debouncedMatchingUpdateStep(newValue);
  }, [debouncedMatchingUpdateStep]);
  var onClickInput = Object(react["useCallback"])(function () {
    var currentValue = currentInputRef.current;
    var reachedRequiredLength = currentValue.length >= requiredInputLength;

    if (reachedRequiredLength && !visibleRef.current) {
      debouncedMatchingUpdateStep(currentValue);
    }
  }, [currentInputRef, requiredInputLength, visibleRef, debouncedMatchingUpdateStep]);
  var onHandleBlur = Object(react["useCallback"])(function (event) {
    var newValue = event.target.value;
    onBlur(newValue);
  }, [onBlur]);
  var onHandleSelect = Object(react["useCallback"])(function (selectedItem) {
    if (isMatchingDebounced) {
      return;
    }

    setCurrentInput(selectedItem.label);
    setVisible(false);
    setFocusIndex(-1);
    interactionHappenedRef.current = true;
    setLastValidItem((selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.key) || selectedItem);
    onSelect((selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.key) || selectedItem);
  }, [isMatchingDebounced, setCurrentInput, setVisible, lastValidItem, onSelect]);
  var onHandleKeydown = Object(react["useCallback"])(function (event) {
    if (!visibleRef.current) {
      return;
    }

    var currentFocusIndex = focusIndex;

    if (event.keyCode === 40 || event.keyCode === 9) {
      currentFocusIndex += 1;

      if (currentFocusIndex >= matchingItems.length) {
        currentFocusIndex = 0;
      }

      setFocusIndex(currentFocusIndex);
      event.preventDefault();
    } else if (event.keyCode === 38) {
      currentFocusIndex -= 1;

      if (currentFocusIndex <= -1) {
        currentFocusIndex = matchingItems.length - 1;
      }

      setFocusIndex(currentFocusIndex);
    } else if (event.keyCode === 13) {
      if (focusIndex > -1) {
        var selectedItem = matchingItems[currentFocusIndex];
        onHandleSelect(selectedItem);
      }
    }
  }, [focusIndex, matchingItems, onHandleSelect, visibleRef]);
  var renderItemLabel = Object(react["useCallback"])(function (item) {
    var index = indexOfMatch(currentInput, item);
    var inputLength = currentInput.length;
    return index >= 0 && inputLength ? // renders label with matching search string marked
    DatalistInput_jsx(react["Fragment"], null, item.label.substr(0, index), DatalistInput_jsx("strong", null, item.label.substr(index, inputLength)), item.label.substr(index + inputLength, item.label.length)) : item.label;
  }, [currentInput]);
  var renderItems = Object(react["useCallback"])(function () {
    return DatalistInput_jsx(react["Fragment"], null, matchingItems.map(function (item, i) {
      var isActive = focusIndex === i;
      var itemActiveClasses = isActive ? "cursor-pointer ".concat(activeItemClassName || 'bg-saffron text-white border-solid border-grey-light p-10;') : '';
      var itemClasses = "".concat(itemClassName, " ").concat(itemActiveClasses);
      return DatalistInput_jsx("div", {
        onClick: function onClick() {
          return onHandleSelect(item);
        },
        className: itemClasses,
        key: item.key,
        tabIndex: 0,
        role: "button",
        "aria-label": item.label,
        onKeyUp: function onKeyUp(event) {
          return event.preventDefault();
        }
      }, renderItemLabel(item));
    }));
  }, [matchingItems, focusIndex, activeItemClassName, itemClassName, onHandleSelect, renderItemLabel]);
  var dropDown = Object(react["useMemo"])(function () {
    var reachedRequiredLength = currentInputRef.current.length >= requiredInputLength;

    if (reachedRequiredLength && isMatchingDebounced) {
      return DatalistInput_jsx("div", {
        ref: menu,
        className: "absolute inset-x-0 top-full z-1 ".concat(dropdownClassName || 'grey-light cursor-pointer border border-solid bg-white p-10'),
        role: "dialog",
        "aria-label": "Dropdown menu"
      }, DatalistInput_jsx("div", {
        className: itemClassName
      }, "loading..."));
    }

    if (reachedRequiredLength && visible) {
      return DatalistInput_jsx("div", {
        ref: menu,
        className: "absolute inset-x-0 top-full z-1 ".concat(dropdownClassName || 'grey-light cursor-pointer border border-solid bg-white p-10'),
        role: "dialog",
        "aria-label": "Dropdown menu"
      }, renderItems());
    }

    return undefined;
  }, [currentInputRef, requiredInputLength, isMatchingDebounced, visible, dropdownClassName, itemClassName, renderItems]);
  return DatalistInput_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('relative isolate inline-block w-full', className)
  }, DatalistInput_jsx("input", Object(esm_extends["a" /* default */])({}, field, {
    "aria-label": "Search",
    autoComplete: "off",
    className: Object(classnames_utils["a" /* classnames */])(inputClassName, 'w-full'),
    "data-testid": dataTestId,
    id: field.name,
    onBlur: onHandleBlur,
    onChange: onHandleInput,
    onClick: onClickInput,
    onKeyDown: onHandleKeydown,
    placeholder: placeholder,
    ref: inputField,
    type: "text",
    value: currentInput
  })), dropDown);
};
// EXTERNAL MODULE: ./src/client/components/frameworks/formik/formik-input/Label.jsx
var Label = __webpack_require__("vJSV");

// CONCATENATED MODULE: ./src/client/components/frameworks/formik/formik-input/Datalist.jsx














var Datalist_jsx = react_default.a.createElement;

function Datalist_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function Datalist_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Datalist_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Datalist_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var Datalist_Datalist = function Datalist(_ref) {
  var className = _ref.className,
      dataTestId = _ref.dataTestId,
      field = _ref.field,
      form = _ref.form,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      _ref$isRequired = _ref.isRequired,
      isRequired = _ref$isRequired === void 0 ? false : _ref$isRequired,
      label = _ref.label,
      setOrDefault = _ref.setOrDefault,
      options = _ref.options;

  var selectedValue = get_default()(form.values, field.name, '');

  var _getValidationStatus = Object(inputsUtils["d" /* getValidationStatus */])(Datalist_objectSpread(Datalist_objectSpread({}, field), {}, {
    value: selectedValue
  }), form, isDisabled),
      isDefaultState = _getValidationStatus.isDefaultState,
      isErrored = _getValidationStatus.isErrored,
      isValidated = _getValidationStatus.isValidated;

  var classes = Object(inputsUtils["b" /* getInputClasses */])({
    hasHeight: true,
    isDefaultState: isDefaultState,
    isDisabled: isDisabled,
    isErrored: isErrored,
    isValidated: isValidated
  });

  var handleOnSelectOrBlure = function handleOnSelectOrBlure(value) {
    value && form.setFieldValue(field.name, setOrDefault(value));
  };

  return Datalist_jsx(react["Fragment"], null, !!label && Datalist_jsx(Label["a" /* Label */], {
    className: "mb-5 mx-15",
    htmlFor: field.name,
    isErrored: isErrored,
    isRequired: isRequired,
    label: label
  }), Datalist_jsx(DatalistInput_DataListInput, {
    className: className,
    dataTestId: dataTestId,
    field: field,
    inputClassName: classes,
    items: options.map(function (_ref2) {
      var itemLabel = _ref2.label,
          value = _ref2.value;
      return {
        label: itemLabel,
        key: value
      };
    }),
    onSelect: handleOnSelectOrBlure,
    onBlur: handleOnSelectOrBlure
  }));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("7xRU");

// EXTERNAL MODULE: ./src/hooks/use-unmount-delay/useUnmountDelay.js
var useUnmountDelay = __webpack_require__("5C2K");

// EXTERNAL MODULE: ./src/client/components/frameworks/datepicker/Datepicker.jsx + 2 modules
var Datepicker = __webpack_require__("Dm6d");

// CONCATENATED MODULE: ./src/client/components/frameworks/formik/formik-input/DatePickerInput.jsx








var DatePickerInput_jsx = react_default.a.createElement;











var clickedElementIs = function clickedElementIs(element, elementType, dataTestId) {
  return element instanceof Element && element.closest(elementType) && // $FlowFixMe element.closest is not null or void
  element.closest(elementType).matches("[data-testid=\"".concat(dataTestId, "\"]"));
};

var DatePickerInput_DatePickerInput = function DatePickerInput(_ref) {
  var className = _ref.className,
      customClasses = _ref.customClasses,
      dataTestId = _ref.dataTestId,
      _ref$dateFormat = _ref.dateFormat,
      dateFormat = _ref$dateFormat === void 0 ? 'DD/MM/YYYY' : _ref$dateFormat,
      _ref$defaultDuration = _ref.defaultDuration,
      defaultDuration = _ref$defaultDuration === void 0 ? 1 : _ref$defaultDuration,
      disabledDays = _ref.disabledDays,
      field = _ref.field,
      form = _ref.form,
      _ref$hasArrowDown = _ref.hasArrowDown,
      hasArrowDown = _ref$hasArrowDown === void 0 ? false : _ref$hasArrowDown,
      _ref$isDateRange = _ref.isDateRange,
      isDateRange = _ref$isDateRange === void 0 ? false : _ref$isDateRange,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      _ref$isRequired = _ref.isRequired,
      isRequired = _ref$isRequired === void 0 ? false : _ref$isRequired,
      label = _ref.label,
      language = _ref.language,
      maxDate = _ref.maxDate,
      minDate = _ref.minDate,
      placeholder = _ref.placeholder;

  var _useState = Object(react["useState"])(false),
      isActive = _useState[0],
      setIsActive = _useState[1];

  var datePickerReference = Object(react["useRef"])(null);

  var _get2 = get_default()(form.values, field.name, {
    from: null,
    to: null
  }),
      from = _get2.from,
      to = _get2.to;

  var fromInputValue = from ? moment_default()(from).format(dateFormat) : null;
  var toInputValue = to ? moment_default()(to).format(dateFormat) : null;
  var inputValue = [fromInputValue, toInputValue].filter(function (value) {
    return !!value;
  }).join(' — ');

  var _getValidationStatus = Object(inputsUtils["d" /* getValidationStatus */])(field, form, isDisabled),
      isDefaultState = _getValidationStatus.isDefaultState,
      isErrored = _getValidationStatus.isErrored,
      isValidated = _getValidationStatus.isValidated; // Open/Close effect


  Object(react["useEffect"])(function () {
    var onClickOutside = function onClickOutside(e) {
      var datePickerElement = datePickerReference.current;
      var clickedElement = e.target;
      var clickedElementIsPrevArrow = clickedElementIs(clickedElement, 'button', 'datepicker-arrow-prev');
      var clickedElementIsNextArrow = clickedElementIs(clickedElement, 'button', 'datepicker-arrow-next');

      if (datePickerElement && !datePickerElement.contains(clickedElement) && !clickedElementIsPrevArrow && !clickedElementIsNextArrow) {
        // 1. Set "to" date based on default duration if it's not defined
        if (isDateRange && !!from && !to) {
          form.setFieldValue(field.name, {
            from: from,
            to: moment_default()(from).add({
              days: defaultDuration
            }).toDate()
          });
        } // 2. Close DatePicker


        setIsActive(false);
      }
    };

    document.addEventListener('click', onClickOutside);
    document.addEventListener('focus', onClickOutside);
    return function () {
      document.removeEventListener('click', onClickOutside);
      document.removeEventListener('focus', onClickOutside);
    };
  }, [from, to]);

  var onDaySelect = function onDaySelect(_ref2) {
    var fromDate = _ref2.fromDate,
        toDate = _ref2.toDate;

    if (isDateRange && !!fromDate && !toDate) {
      form.setFieldValue(field.name, {
        from: fromDate,
        to: moment_default()(fromDate).add({
          days: defaultDuration
        }).toDate()
      });
    } // 2. Close DatePicker


    setIsActive(false);
  };

  var shouldRenderDatePicker = Object(useUnmountDelay["a" /* useDelayUnmount */])(isActive, 300);
  var classes = Object(inputsUtils["b" /* getInputClasses */])({
    hasHeight: true,
    hasValidationStatus: true,
    isDefaultState: isDefaultState,
    isDisabled: isDisabled,
    isErrored: isErrored,
    isValidated: isValidated
  });
  var datePickerStyle = customClasses ? customClasses : classes;
  return DatePickerInput_jsx(react["Fragment"], null, !!label && DatePickerInput_jsx(Label["a" /* Label */], {
    className: "mx-15 mb-5",
    htmlFor: field.name,
    isErrored: isErrored,
    isRequired: isRequired,
    label: label
  }), DatePickerInput_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('relative isolate w-full', className),
    ref: datePickerReference
  }, DatePickerInput_jsx("div", {
    className: "relative isolate flex w-full items-center"
  }, DatePickerInput_jsx("input", Object(esm_extends["a" /* default */])({
    autoComplete: "off",
    className: Object(classnames_utils["a" /* classnames */])('h-48', datePickerStyle),
    "data-testid": dataTestId,
    disabled: isDisabled
  }, field, {
    onFocus: function onFocus() {
      return setIsActive(true);
    },
    placeholder: placeholder,
    type: "text",
    value: inputValue
  })), hasArrowDown && DatePickerInput_jsx("div", {
    className: "pointer-events-none absolute end-0 mx-20 flex items-center"
  }, DatePickerInput_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].ARROW_DOWN,
    width: ".625rem"
  })), !isDisabled && DatePickerInput_jsx(ImageValidationStatus_ImageValidationStatus, {
    className: Object(classnames_utils["a" /* classnames */])('absolute end-0', {
      'mx-40': hasArrowDown,
      'mx-20': !hasArrowDown
    }),
    isErrored: isErrored,
    isValidated: isValidated
  })), shouldRenderDatePicker && DatePickerInput_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('animation-duration-500 absolute left-1/2 top-full mt-10 min-w-full -translate-x-1/2 transform rounded-12 border-1 border-black bg-white p-10', isActive ? 'animate-fadeIn' : 'animate-fadeOut')
  }, DatePickerInput_jsx(Datepicker["a" /* Datepicker */], {
    field: field,
    form: form,
    isDateRange: isDateRange,
    isFormikInput: true,
    locale: language,
    maxDate: maxDate,
    minDate: minDate,
    disabledDays: disabledDays,
    onSelect: onDaySelect,
    theme: "defaultFormikInput"
  }))));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/formik/formik-input/Hidden.jsx


var Hidden_jsx = react_default.a.createElement;

var Hidden_Hidden = function Hidden(_ref) {
  var field = _ref.field;
  return Hidden_jsx("input", Object(esm_extends["a" /* default */])({
    id: field.name,
    type: "hidden"
  }, field, {
    // to not trigger a React error when the field is initialize to undefined
    value: field.value || ''
  }));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/formik/formik-input/Input.jsx
















var Input_jsx = react_default.a.createElement;

function Input_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function Input_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Input_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Input_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var Input_Input = function Input(_ref) {
  var air360ClassName = _ref.air360ClassName,
      _ref$autoComplete = _ref.autoComplete,
      autoComplete = _ref$autoComplete === void 0 ? 'off' : _ref$autoComplete,
      _ref$customClasses = _ref.customClasses,
      customClasses = _ref$customClasses === void 0 ? '' : _ref$customClasses,
      customId = _ref.customId,
      dataTestId = _ref.dataTestId,
      field = _ref.field,
      form = _ref.form,
      hideErrorMessage = _ref.hideErrorMessage,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      _ref$isRequired = _ref.isRequired,
      isRequired = _ref$isRequired === void 0 ? false : _ref$isRequired,
      label = _ref.label,
      labelAdditionalInfo = _ref.labelAdditionalInfo,
      placeholder = _ref.placeholder,
      type = _ref.type,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["air360ClassName", "autoComplete", "customClasses", "customId", "dataTestId", "field", "form", "hideErrorMessage", "isDisabled", "isRequired", "label", "labelAdditionalInfo", "placeholder", "type"]);

  var isComposingRef = Object(react["useRef"])(false);

  var handleCompositionStart = function handleCompositionStart() {
    isComposingRef.current = true;
  };

  var handleCompositionEnd = function handleCompositionEnd(e) {
    isComposingRef.current = false;
    form.setFieldValue(field.name, e.target.value, true);
  };

  var handleChange = function handleChange(e) {
    if (isComposingRef.current) {
      form.setFieldValue(field.name, e.target.value, false);
      return;
    }

    field.onChange(e);
  }; // Input value defaults to empty string


  var value = get_default()(form.values, field.name, '');

  var _getValidationStatus = Object(inputsUtils["d" /* getValidationStatus */])(Input_objectSpread(Input_objectSpread({}, field), {}, {
    value: value
  }), form, isDisabled),
      isDefaultState = _getValidationStatus.isDefaultState,
      isErrored = _getValidationStatus.isErrored,
      isValidated = _getValidationStatus.isValidated;

  var errorNoteId = "error-".concat(kebabCase_default()(field.name));
  var classes = Object(inputsUtils["b" /* getInputClasses */])({
    hasHeight: true,
    hasValidationStatus: true,
    isDefaultState: isDefaultState,
    isDisabled: isDisabled,
    isErrored: isErrored,
    isValidated: isValidated
  });
  var inputStyle = customClasses ? Object(classnames_utils["a" /* classnames */])(air360ClassName, customClasses) : Object(classnames_utils["a" /* classnames */])(air360ClassName, classes);
  return Input_jsx(react["Fragment"], null, !!label && Input_jsx(Label["a" /* Label */], {
    className: "mx-15 mb-5",
    htmlFor: customId || field.name,
    isErrored: isErrored,
    isRequired: isRequired,
    label: label,
    labelAdditionalInfo: labelAdditionalInfo
  }), Input_jsx("div", {
    className: "relative isolate flex w-full items-center"
  }, Input_jsx("input", Object(esm_extends["a" /* default */])({
    "aria-describedby": errorNoteId,
    "aria-invalid": isErrored,
    "aria-required": isRequired,
    autoComplete: autoComplete,
    className: inputStyle,
    "data-testid": dataTestId,
    disabled: isDisabled,
    id: customId ? customId : field.name,
    type: type
  }, placeholder ? {
    placeholder: placeholder
  } : null, field, {
    onChange: handleChange,
    onCompositionStart: handleCompositionStart,
    onCompositionEnd: handleCompositionEnd // default to '' for prevent react warning on controlled component
    ,
    value: value || ''
  }, props)), !isDisabled && Input_jsx(ImageValidationStatus_ImageValidationStatus, {
    className: "absolute end-0 mx-20",
    isErrored: isErrored,
    isValidated: isValidated
  })), !hideErrorMessage && Input_jsx(ErrorNote["a" /* ErrorNote */], {
    className: "mx-15",
    isErrored: isErrored,
    errorMessage: get_default()(form.errors, "".concat(field.name)),
    errorNoteId: errorNoteId
  }));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/formik/formik-input/Radio.jsx
var Radio = __webpack_require__("yWv5");

// CONCATENATED MODULE: ./src/client/components/frameworks/formik/formik-input/Select.jsx
















var Select_jsx = react_default.a.createElement;

function Select_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function Select_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Select_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Select_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable jsx-a11y/no-onchange */








var Select_Select = function Select(_ref) {
  var _ref$customClasses = _ref.customClasses,
      customClasses = _ref$customClasses === void 0 ? '' : _ref$customClasses,
      dataTestId = _ref.dataTestId,
      field = _ref.field,
      form = _ref.form,
      hideErrorMessage = _ref.hideErrorMessage,
      hideImageValidation = _ref.hideImageValidation,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      _ref$isRequired = _ref.isRequired,
      isRequired = _ref$isRequired === void 0 ? false : _ref$isRequired,
      label = _ref.label,
      labelAdditionalInfo = _ref.labelAdditionalInfo,
      onChange = _ref.onChange,
      onClick = _ref.onClick,
      options = _ref.options,
      placeholder = _ref.placeholder,
      _ref$withOptionGroup = _ref.withOptionGroup,
      withOptionGroup = _ref$withOptionGroup === void 0 ? false : _ref$withOptionGroup;

  if (!options) {
    throw new Error("Can't use select input type without options props");
  } // Select value defaults to empty string


  var selectedValue = get_default()(form.values, field.name, '');

  var _getValidationStatus = Object(inputsUtils["d" /* getValidationStatus */])(Select_objectSpread(Select_objectSpread({}, field), {}, {
    value: selectedValue
  }), form, isDisabled),
      isDefaultState = _getValidationStatus.isDefaultState,
      isErrored = _getValidationStatus.isErrored,
      isValidated = _getValidationStatus.isValidated;

  var errorNoteId = "error-".concat(kebabCase_default()(field.name));
  var onSelectChange = onChange ? onChange : field.onChange;
  var onSelectClick = onClick ? onClick : field.onClick;
  var classes = Object(inputsUtils["b" /* getInputClasses */])({
    hasHeight: true,
    isDefaultState: isDefaultState,
    isDisabled: isDisabled,
    isErrored: isErrored,
    isValidated: isValidated
  });
  var selectStyle = customClasses ? customClasses : classes;
  return Select_jsx(react["Fragment"], null, !!label && Select_jsx(Label["a" /* Label */], {
    className: "mx-15 mb-5",
    htmlFor: field.name,
    isErrored: isErrored,
    isRequired: isRequired,
    label: label,
    labelAdditionalInfo: labelAdditionalInfo
  }), Select_jsx("div", {
    className: "relative isolate flex w-full items-center"
  }, Select_jsx("select", Object(esm_extends["a" /* default */])({
    "aria-describedby": errorNoteId,
    autoComplete: "off",
    className: Object(classnames_utils["a" /* classnames */])('h-48', selectStyle, 'pe-40'),
    "data-testid": dataTestId,
    disabled: isDisabled,
    id: field.name
  }, field, {
    onChange: onSelectChange,
    onClick: onSelectClick
  }), placeholder && Select_jsx("option", {
    value: "",
    disabled: true,
    selected: true
  }, placeholder), withOptionGroup ? options.map(function (_ref2) {
    var groupName = _ref2.groupName,
        groupOptions = _ref2.groupOptions;
    return (groupOptions === null || groupOptions === void 0 ? void 0 : groupOptions.length) && Select_jsx("optgroup", {
      label: groupName,
      key: groupName
    }, groupOptions.map(function (_ref3) {
      var isDisabledOption = _ref3.isDisabled,
          key = _ref3.key,
          name = _ref3.name,
          value = _ref3.value;
      return Select_jsx("option", {
        key: key || value,
        value: value,
        disabled: isDisabledOption
      }, name);
    }));
  }) : options.map(function (_ref4) {
    var isDisabledOption = _ref4.isDisabled,
        key = _ref4.key,
        name = _ref4.name,
        value = _ref4.value;
    return Select_jsx("option", {
      key: key || name + field.name,
      value: value,
      disabled: isDisabledOption
    }, name);
  })), Select_jsx("div", {
    className: "pointer-events-none absolute end-0 mx-20 flex items-center"
  }, Select_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].ARROW_DOWN,
    width: ".625rem"
  })), !isDisabled && !hideImageValidation && Select_jsx(ImageValidationStatus_ImageValidationStatus, {
    className: "absolute end-0 mx-40",
    isErrored: isErrored,
    isValidated: isValidated
  })), !hideErrorMessage && Select_jsx(ErrorNote["a" /* ErrorNote */], {
    className: "mx-15",
    isErrored: isErrored,
    errorMessage: get_default()(form.errors, "".concat(field.name)),
    errorNoteId: errorNoteId
  }));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/formik/formik-input/Textarea.jsx















var Textarea_jsx = react_default.a.createElement;

function Textarea_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function Textarea_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Textarea_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Textarea_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var Textarea_Textarea = function Textarea(_ref) {
  var dataTestId = _ref.dataTestId,
      field = _ref.field,
      form = _ref.form,
      hideErrorMessage = _ref.hideErrorMessage,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      _ref$isRequired = _ref.isRequired,
      isRequired = _ref$isRequired === void 0 ? false : _ref$isRequired,
      label = _ref.label,
      maxLength = _ref.maxLength,
      placeholder = _ref.placeholder;

  // Textarea value defaults to empty string
  var value = get_default()(form.values, field.name, '');

  var _getValidationStatus = Object(inputsUtils["d" /* getValidationStatus */])(Textarea_objectSpread(Textarea_objectSpread({}, field), {}, {
    value: value
  }), form, isDisabled),
      isDefaultState = _getValidationStatus.isDefaultState,
      isErrored = _getValidationStatus.isErrored,
      isValidated = _getValidationStatus.isValidated;

  var errorNoteId = "error-".concat(kebabCase_default()(field.name));
  var classes = Object(inputsUtils["b" /* getInputClasses */])({
    hasRadius: false,
    isDefaultState: isDefaultState,
    isDisabled: isDisabled,
    isErrored: isErrored,
    isValidated: isValidated
  });
  return Textarea_jsx(react["Fragment"], null, !!label && Textarea_jsx(Label["a" /* Label */], {
    className: "mb-5 mx-15",
    htmlFor: field.name,
    isErrored: isErrored,
    isRequired: isRequired,
    label: label
  }), Textarea_jsx("textarea", Object(esm_extends["a" /* default */])({
    "aria-describedby": errorNoteId,
    autoComplete: "off",
    className: Object(classnames_utils["a" /* classnames */])(classes, 'rounded-12'),
    "data-testid": dataTestId,
    disabled: isDisabled,
    id: field.name,
    maxLength: maxLength
  }, placeholder ? {
    placeholder: placeholder
  } : null, field, {
    value: value
  })), !hideErrorMessage && Textarea_jsx(ErrorNote["a" /* ErrorNote */], {
    className: "mx-15",
    errorMessage: form.errors[field.name],
    errorNoteId: errorNoteId,
    isErrored: isErrored
  }));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/formik/formik-input/TelWithCodeInput.jsx




















var TelWithCodeInput_jsx = react_default.a.createElement;

function TelWithCodeInput_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function TelWithCodeInput_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { TelWithCodeInput_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { TelWithCodeInput_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









var TelWithCodeInput_TelWithCodeInput = function TelWithCodeInput(_ref) {
  var air360ClassName = _ref.air360ClassName,
      availableCountryCodes = _ref.availableCountryCodes,
      countryFieldName = _ref.countryFieldName,
      _ref$customClasses = _ref.customClasses,
      customClasses = _ref$customClasses === void 0 ? '' : _ref$customClasses,
      customId = _ref.customId,
      dataTestId = _ref.dataTestId,
      field = _ref.field,
      form = _ref.form,
      hideErrorMessage = _ref.hideErrorMessage,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      _ref$isRequired = _ref.isRequired,
      isRequired = _ref$isRequired === void 0 ? false : _ref$isRequired,
      label = _ref.label,
      labelAdditionalInfo = _ref.labelAdditionalInfo,
      phoneCodeFieldName = _ref.phoneCodeFieldName,
      phoneCodeLabel = _ref.phoneCodeLabel,
      phoneCodeOptions = _ref.phoneCodeOptions,
      phoneCodePlaceholder = _ref.phoneCodePlaceholder,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["air360ClassName", "availableCountryCodes", "countryFieldName", "customClasses", "customId", "dataTestId", "field", "form", "hideErrorMessage", "isDisabled", "isRequired", "label", "labelAdditionalInfo", "phoneCodeFieldName", "phoneCodeLabel", "phoneCodeOptions", "phoneCodePlaceholder"]);

  // Get values
  var phoneValue = get_default()(form.values, field.name, '');

  var phoneCodeValue = get_default()(form.values, phoneCodeFieldName, '');

  var _getValidationStatus = Object(inputsUtils["d" /* getValidationStatus */])(TelWithCodeInput_objectSpread(TelWithCodeInput_objectSpread({}, field), {}, {
    value: phoneValue
  }), form, isDisabled),
      isDefaultState = _getValidationStatus.isDefaultState,
      isErrored = _getValidationStatus.isErrored,
      isValidated = _getValidationStatus.isValidated;

  var errorNoteId = "error-".concat(kebabCase_default()(field.name));
  var classes = Object(inputsUtils["b" /* getInputClasses */])({
    hasHeight: true,
    hasValidationStatus: true,
    isDefaultState: isDefaultState,
    isDisabled: isDisabled,
    isErrored: isErrored,
    isValidated: isValidated
  });
  var inputStyle = customClasses ? Object(classnames_utils["a" /* classnames */])(air360ClassName, customClasses) : Object(classnames_utils["a" /* classnames */])(air360ClassName, classes);
  var selectStyle = customClasses ? customClasses : classes;
  var selectedOption = phoneCodeOptions.find(function (opt) {
    return opt.value === phoneCodeValue;
  });
  var displayValue = (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.shortName) || phoneCodeValue;

  var handlePhoneCodeChange = function handlePhoneCodeChange(e) {
    var selectedValue = e.currentTarget.value;
    var selectedOpt = phoneCodeOptions.find(function (opt) {
      return opt.value === selectedValue;
    });
    form.setFieldValue(phoneCodeFieldName, selectedValue);

    if (countryFieldName) {
      if (selectedOpt === null || selectedOpt === void 0 ? void 0 : selectedOpt.countryCode) {
        // Only update country if it's in the available countries list
        // If not available, keep the existing country value (fallback to default)
        if (!availableCountryCodes || availableCountryCodes.length === 0 || availableCountryCodes.includes(selectedOpt.countryCode)) {
          form.setFieldValue(countryFieldName, selectedOpt.countryCode);
        } // If country is not in available list, do nothing (keep existing value)

      } else if (selectedValue === '') {
        form.setFieldValue(countryFieldName, '');
      }
    }
  };

  var handlePhoneChange = function handlePhoneChange(e) {
    field.onChange(e);
  };

  return TelWithCodeInput_jsx(react["Fragment"], null, TelWithCodeInput_jsx("div", {
    className: "flex w-full items-start gap-10"
  }, TelWithCodeInput_jsx("div", {
    className: "relative isolate flex flex-1 flex-col"
  }, phoneCodeLabel && TelWithCodeInput_jsx(Label["a" /* Label */], {
    className: "mx-15 mb-5",
    htmlFor: phoneCodeFieldName,
    isErrored: false,
    isRequired: false,
    label: phoneCodeLabel
  }), TelWithCodeInput_jsx("div", {
    className: "relative isolate flex items-center"
  }, TelWithCodeInput_jsx("select", {
    "aria-describedby": errorNoteId,
    "aria-invalid": isErrored,
    className: Object(classnames_utils["a" /* classnames */])('h-48 pe-40', selectStyle),
    disabled: isDisabled,
    name: phoneCodeFieldName,
    onChange: handlePhoneCodeChange,
    value: phoneCodeValue || '',
    style: {
      color: phoneCodeValue ? 'transparent' : undefined
    }
  }, phoneCodePlaceholder && TelWithCodeInput_jsx("option", {
    value: "",
    disabled: true
  }, phoneCodePlaceholder), phoneCodeOptions.map(function (_ref2) {
    var name = _ref2.name,
        value = _ref2.value;
    return TelWithCodeInput_jsx("option", {
      key: value,
      value: value,
      style: {
        color: 'initial'
      }
    }, name);
  })), phoneCodeValue && TelWithCodeInput_jsx("div", {
    className: "pointer-events-none absolute inset-0 flex items-center pe-40 ps-15"
  }, TelWithCodeInput_jsx("span", {
    className: Object(classnames_utils["a" /* classnames */])({
      'text-gray-400': isDisabled
    })
  }, displayValue)), TelWithCodeInput_jsx("div", {
    className: "pointer-events-none absolute end-0 mx-20 flex items-center"
  }, TelWithCodeInput_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].ARROW_DOWN,
    width: ".625rem"
  })))), TelWithCodeInput_jsx("div", {
    className: "relative flex flex-2 flex-col"
  }, label && TelWithCodeInput_jsx(Label["a" /* Label */], {
    className: "mx-15 mb-5",
    htmlFor: customId || field.name,
    isErrored: false,
    isRequired: false,
    label: label
  }), TelWithCodeInput_jsx("div", {
    className: "relative flex items-center"
  }, TelWithCodeInput_jsx("input", Object(esm_extends["a" /* default */])({
    "aria-describedby": errorNoteId,
    "aria-invalid": isErrored,
    "aria-required": isRequired,
    autoComplete: "tel",
    className: inputStyle,
    "data-testid": dataTestId,
    disabled: isDisabled,
    id: customId ? customId : field.name,
    type: "tel"
  }, field, {
    onChange: handlePhoneChange,
    value: phoneValue || ''
  }, props)), !isDisabled && TelWithCodeInput_jsx(ImageValidationStatus_ImageValidationStatus, {
    className: "absolute end-0 mx-20",
    isErrored: isErrored,
    isValidated: isValidated
  })))), !hideErrorMessage && TelWithCodeInput_jsx(ErrorNote["a" /* ErrorNote */], {
    className: "mx-15",
    isErrored: isErrored,
    errorMessage: get_default()(form.errors, "".concat(field.name)),
    errorNoteId: errorNoteId
  }));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/formik/FormikInput.jsx


var FormikInput_jsx = react_default.a.createElement;


















var FormikInput_getComponentByType = function getComponentByType(type) {
  switch (type) {
    case 'birthdate':
      return DateInput_DateInput;

    case 'checkbox':
      return Checkbox_Checkbox;

    case 'creditCardExpiry':
      return CreditCardExpiryInput_CreditCardExpiryInput;

    case 'datalist':
      return Datalist_Datalist;

    case 'datepicker':
      return DatePickerInput_DatePickerInput;

    case 'hidden':
      return Hidden_Hidden;

    case 'radio':
      return Radio["a" /* Radio */];

    case 'select':
      return Select_Select;

    case 'telWithCode':
      return TelWithCodeInput_TelWithCodeInput;

    case 'textarea':
      return Textarea_Textarea;

    default:
      return Input_Input;
  }
};

var requiredValidationRule = Object(inputsUtils["c" /* getValidateFieldFunction */])(lib["mixed"]().transform(function (value) {
  return !!value;
}).oneOf([true]).required());

var FormikInput_getValidateFunction = function getValidateFunction(validate, isRequired, context) {
  var isValidate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var locale = arguments.length > 4 ? arguments[4] : undefined;

  if (validate) {
    return Object(inputsUtils["c" /* getValidateFieldFunction */])(validate, context, locale);
  }

  if (isValidate) {
    if (isRequired) {
      return requiredValidationRule;
    }
  }

  return undefined;
};

var FormikInput_FormikInput = function FormikInput(_ref) {
  var customId = _ref.customId,
      _ref$hideErrorMessage = _ref.hideErrorMessage,
      hideErrorMessage = _ref$hideErrorMessage === void 0 ? false : _ref$hideErrorMessage,
      _ref$hideDataFromSess = _ref.hideDataFromSessionRecording,
      hideDataFromSessionRecording = _ref$hideDataFromSess === void 0 ? true : _ref$hideDataFromSess,
      _ref$isRequired = _ref.isRequired,
      isRequired = _ref$isRequired === void 0 ? false : _ref$isRequired,
      _ref$isValidate = _ref.isValidate,
      isValidate = _ref$isValidate === void 0 ? true : _ref$isValidate,
      _ref$optimized = _ref.optimized,
      optimized = _ref$optimized === void 0 ? false : _ref$optimized,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'default' : _ref$type,
      validate = _ref.validate,
      otherProps = Object(objectWithoutProperties["a" /* default */])(_ref, ["customId", "hideErrorMessage", "hideDataFromSessionRecording", "isRequired", "isValidate", "optimized", "type", "validate"]);

  var _useAppContext = Object(ReactAppContext["c" /* useAppContext */])(),
      locale = _useAppContext.locale;

  var context = Object(formik_esm["e" /* useFormikContext */])();
  var FormikField = optimized ? formik_esm["a" /* FastField */] : formik_esm["b" /* Field */];
  var air360ClassName = Object(classnames_utils["a" /* classnames */])({
    'air360-replay-ignore': hideDataFromSessionRecording
  });
  var dataCsMask = hideDataFromSessionRecording ? {
    'data-cs-mask': true
  } : undefined;
  return FormikInput_jsx(FormikField, Object(esm_extends["a" /* default */])({
    air360ClassName: air360ClassName,
    component: FormikInput_getComponentByType(type),
    customId: customId,
    hideErrorMessage: hideErrorMessage,
    isRequired: isRequired,
    type: type,
    validate: FormikInput_getValidateFunction(validate, isRequired, context, isValidate, locale) // $FlowFixMe

  }, otherProps, dataCsMask));
};

/***/ }),

/***/ "1vCq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var _root_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fw2E");


/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? _root_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (cloneBuffer);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("R5gN")(module)))

/***/ }),

/***/ "2B1m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Hero; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("Ysgh");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("tVqn");
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("hBvt");
/* harmony import */ var core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("MwrP");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("C/y5");
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("1JJ2");
/* harmony import */ var _tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("sRdV");
/* harmony import */ var _frameworks_button_Button__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("e0Ti");
/* harmony import */ var _frameworks_countdown_Countdown__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("mmhe");
/* harmony import */ var _frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("i5Mr");
/* harmony import */ var _frameworks_heading_Heading__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("3jv5");
/* harmony import */ var _frameworks_text_Text__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("qqKu");
/* harmony import */ var _tracking_utils__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("zwLB");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("Bkb1");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _tracking_constants__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("829J");
/* harmony import */ var _context_PageContext__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__("EkOT");
/* harmony import */ var _tracking_tracking_api_useTrackEvent__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__("DqI1");
/* harmony import */ var _heroUtils__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__("5xkM");













var __jsx = react__WEBPACK_IMPORTED_MODULE_13___default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable react/no-danger */
















var Hero = function Hero(_ref) {
  var alt = _ref.alt,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? _frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_20__[/* default */ "a"] : _ref$as,
      _ref$backgroundURLDes = _ref.backgroundURLDesktop,
      backgroundURLDesktop = _ref$backgroundURLDes === void 0 ? '' : _ref$backgroundURLDes,
      _ref$backgroundURLMob = _ref.backgroundURLMobile,
      backgroundURLMobile = _ref$backgroundURLMob === void 0 ? '' : _ref$backgroundURLMob,
      className = _ref.className,
      contentPosition = _ref.contentPosition,
      countdown = _ref.countdown,
      hasOverlap = _ref.hasOverlap,
      _ref$hLevel = _ref.hLevel,
      hLevel = _ref$hLevel === void 0 ? 1 : _ref$hLevel,
      link = _ref.link,
      icon = _ref.icon,
      id = _ref.id,
      _ref$isImmersive = _ref.isImmersive,
      isImmersive = _ref$isImmersive === void 0 ? false : _ref$isImmersive,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'large' : _ref$size,
      style = _ref.style,
      subtitle = _ref.subtitle,
      _ref$theming = _ref.theming,
      theming = _ref$theming === void 0 ? {} : _ref$theming,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      trackingData = _ref.trackingData,
      _ref$url = _ref.url,
      url = _ref$url === void 0 ? '' : _ref$url;
  var track = Object(_tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_17__[/* useTracking */ "a"])();

  var _useResponsive = Object(_utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_16__[/* useResponsive */ "b"])(),
      isTablet = _useResponsive.isTablet,
      isDesktop = _useResponsive.isDesktop;

  var _useRouter = Object(next_router__WEBPACK_IMPORTED_MODULE_24__["useRouter"])(),
      asPath = _useRouter.asPath;

  var _useTrackEvent = Object(_tracking_tracking_api_useTrackEvent__WEBPACK_IMPORTED_MODULE_27__[/* useTrackEvent */ "a"])(),
      trackEvent = _useTrackEvent.trackEvent;

  var _usePageContext = Object(_context_PageContext__WEBPACK_IMPORTED_MODULE_26__[/* usePageContext */ "b"])(),
      siteSection = _usePageContext.siteSection; // just in case, you know, someone forgets to set one or something
  // mobile is default because Mobile First™
  // we're keeping the support for the legacy url prop for backwards compat
  // i.e. with ImmersiveSlideshow, as providing only a desktop url or a mobile one is pretty awkward


  var _generateBackgroundSt = Object(_heroUtils__WEBPACK_IMPORTED_MODULE_28__[/* generateBackgroundStylesAndClassName */ "d"])({
    backgroundURLDesktop: backgroundURLDesktop || url,
    backgroundURLMobile: backgroundURLMobile || url
  }),
      styleTag = _generateBackgroundSt.style,
      imageClassName = _generateBackgroundSt.className;

  var _theming$titleColor = theming.titleColor,
      titleColor = _theming$titleColor === void 0 ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_15__[/* COLORS */ "a"].WHITE : _theming$titleColor,
      _theming$subtitleColo = theming.subtitleColor,
      subtitleColor = _theming$subtitleColo === void 0 ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_15__[/* COLORS */ "a"].WHITE : _theming$subtitleColo,
      _theming$countdownCol = theming.countdownColor,
      countdownColor = _theming$countdownCol === void 0 ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_15__[/* COLORS */ "a"].WHITE : _theming$countdownCol,
      _theming$linkColor = theming.linkColor,
      linkColor = _theming$linkColor === void 0 ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_15__[/* COLORS */ "a"].BLACK : _theming$linkColor,
      _theming$linkBackgrou = theming.linkBackgroundColor,
      linkBackgroundColor = _theming$linkBackgrou === void 0 ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_15__[/* COLORS */ "a"].SAFFRON : _theming$linkBackgrou;

  var _getHeroDimensions = Object(_heroUtils__WEBPACK_IMPORTED_MODULE_28__[/* getHeroDimensions */ "e"])(size),
      heightClassName = _getHeroDimensions.heightClassName,
      paddingBottomClassName = _getHeroDimensions.paddingBottomClassName,
      paddingTopClassName = _getHeroDimensions.paddingTopClassName;

  var isHighlight = size === 'highlightSmall' || size === 'highlight';
  var textAlignment = contentPosition ? _heroUtils__WEBPACK_IMPORTED_MODULE_28__[/* TITLE_POSITIONS */ "c"][contentPosition] : _heroUtils__WEBPACK_IMPORTED_MODULE_28__[/* TITLE_POSITIONS */ "c"]['bottom-left'];
  var horizontalAlignment = contentPosition ? contentPosition.split('-')[1] : '';
  var linkSpacing = horizontalAlignment ? _heroUtils__WEBPACK_IMPORTED_MODULE_28__[/* LINK_SPACINGS */ "b"][horizontalAlignment] : '';

  var tracking = _objectSpread({
    actionGA: 'immersive',
    labelGA: "".concat(title).trim()
  }, trackingData);

  var TitleAndSubtitleWrapperTag = (link === null || link === void 0 ? void 0 : link.url) ? as : react__WEBPACK_IMPORTED_MODULE_13__["Fragment"];
  var titleAndSubtitleWrapperProps = (link === null || link === void 0 ? void 0 : link.url) ? {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__[/* classnames */ "a"])('inline-block transform transition-all duration-250 ease-in hover:scale-105', linkSpacing),
    'data-testid': isImmersive ? 'immersive-text' : undefined,
    onClick: function onClick() {
      return track(tracking);
    },
    url: link.url
  } : {};

  var getTitleAndSubtitleWrapperProps = function getTitleAndSubtitleWrapperProps() {
    if (!(link === null || link === void 0 ? void 0 : link.url)) {
      return;
    }

    if (as === 'a') {
      return _objectSpread(_objectSpread({}, titleAndSubtitleWrapperProps), {}, {
        href: link === null || link === void 0 ? void 0 : link.url
      });
    }

    return _objectSpread(_objectSpread({}, titleAndSubtitleWrapperProps), {}, {
      url: link === null || link === void 0 ? void 0 : link.url
    });
  };

  var buttonTrack = function buttonTrack(trackingPayload) {
    var isPBFLanding = Object(_tracking_utils__WEBPACK_IMPORTED_MODULE_23__[/* isPBFLandingPage */ "m"])(asPath);

    if (siteSection === 'Shopping_Landing' && isPBFLanding) {
      trackEvent(_tracking_constants__WEBPACK_IMPORTED_MODULE_25__[/* TRACK_EVENT_NAMES */ "F"].CLICK_PREBOOKING_FORM_PREREG, {
        detail_click: 'check_my_request'
      });
    } else {
      track && track(trackingPayload);
    }
  };

  var displayIcon = isDesktop ? icon === null || icon === void 0 ? void 0 : icon.displayDesktop : icon === null || icon === void 0 ? void 0 : icon.displayMobile;
  var iconLink = (isTablet ? icon === null || icon === void 0 ? void 0 : icon.linkDesktop : icon === null || icon === void 0 ? void 0 : icon.linkMobile) || (icon === null || icon === void 0 ? void 0 : icon.linkMobile) || (icon === null || icon === void 0 ? void 0 : icon.linkDesktop); // hey isn't that the same logic that we used up there for the imageUrl?
  // yes it is!

  return __jsx("div", {
    "aria-label": alt,
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__[/* classnames */ "a"])(heightClassName, className),
    "data-size": size,
    "data-testid": "Hero",
    id: id,
    role: "img",
    style: style
  }, __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__[/* classnames */ "a"])('relative', heightClassName, paddingTopClassName)
  }, __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__[/* classnames */ "a"])('animation-duration-500 absolute inset-x-0 top-0 h-full w-full animate-fadeIn bg-cover bg-center bg-no-repeat', imageClassName, heightClassName)
  }), icon && displayIcon && iconLink && __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__[/* classnames */ "a"])(paddingTopClassName, 'absolute inset-0', {
      'pb-40': hasOverlap
    })
  }, __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__[/* classnames */ "a"])('m-auto flex h-full w-full max-w-site overflow-hidden p-20', isTablet ? _heroUtils__WEBPACK_IMPORTED_MODULE_28__[/* ICON_POSITIONS */ "a"][icon.positionDesktop] : _heroUtils__WEBPACK_IMPORTED_MODULE_28__[/* ICON_POSITIONS */ "a"][icon.positionMobile]),
    dir: "ltr"
  }, __jsx("img", {
    alt: icon.alt || '',
    className: "max-h-full flex-none",
    src: iconLink,
    style: {
      width: isTablet ? "calc(".concat(icon.desktopWidth, " / 1180 * 100vw)") : "calc(".concat(icon.mobileWidth, " / 375 * 100vw)"),
      maxWidth: isTablet ? icon.desktopWidth : icon.mobileWidth
    }
  }))), !!title && __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__[/* classnames */ "a"])(paddingBottomClassName, 'relative z-1 flex h-full flex-col px-20 pt-10 align-bottom')
  }, __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__[/* classnames */ "a"])("mx-auto flex w-full max-w-site flex-col ".concat(textAlignment))
  }, __jsx(TitleAndSubtitleWrapperTag, getTitleAndSubtitleWrapperProps(), __jsx(_frameworks_heading_Heading__WEBPACK_IMPORTED_MODULE_21__[/* Heading */ "a"], {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__[/* classnames */ "a"])("text-".concat(titleColor), {
      'lg:text-48': !isHighlight && size !== 'small',
      'text-shadow-3': titleColor === _utils_color_colors__WEBPACK_IMPORTED_MODULE_15__[/* COLORS */ "a"].WHITE
    }),
    hLevel: hLevel,
    theme: "heading-brand-1"
  }, title), !!subtitle && __jsx(_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_22__[/* Text */ "a"], {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__[/* classnames */ "a"])('mt-5 font-bold text-shadow-3 md:text-16', "text-".concat(subtitleColor)),
    text: subtitle,
    theme: "text-sans-n1"
  })), !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_12___default()(countdown) && __jsx(_frameworks_countdown_Countdown__WEBPACK_IMPORTED_MODULE_19__[/* Countdown */ "a"], {
    className: "py-10",
    color: countdownColor,
    dateTimeEnd: countdown.dateTimeEnd,
    days: countdown.days,
    hours: countdown.hours,
    minutes: countdown.minutes,
    seconds: countdown.seconds
  }), (link === null || link === void 0 ? void 0 : link.label) && __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__[/* classnames */ "a"])({
      'mt-auto': isHighlight
    })
  }, __jsx(_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_18__[/* Button */ "a"], {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__[/* classnames */ "a"])('mt-15 md:mt-0', {
      'w-full': !isDesktop
    }, isHighlight && !isDesktop ? 'max-w-none' : 'max-w-280'),
    color: linkColor,
    colorBg: linkBackgroundColor,
    "data-testid": isImmersive ? 'immersive-button' : undefined,
    isExternalLink: isImmersive,
    onClick: function onClick() {
      return buttonTrack(tracking);
    },
    url: link.url || '#hero-beacon'
  }, link.label)))), __jsx("style", {
    dangerouslySetInnerHTML: {
      __html: styleTag
    }
  }), title && __jsx("div", {
    className: "absolute inset-0 bg-[linear-gradient(to_bottom,rgba(0,0,0,0)_0%,rgba(0,0,0,0.2)_100%)]"
  })), __jsx("div", {
    id: "hero-beacon"
  }));
};

/***/ }),

/***/ "2Kkq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SpinnerHandler; });
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _widgets_loading_async_loader_AsyncLoader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("4A3Y");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;


var SpinnerHandler = function SpinnerHandler(_ref) {
  var children = _ref.children,
      isLoading = _ref.isLoading,
      props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["children", "isLoading"]);

  return isLoading ? __jsx(_widgets_loading_async_loader_AsyncLoader__WEBPACK_IMPORTED_MODULE_3__[/* AsyncLoader */ "a"], null) : __jsx(react__WEBPACK_IMPORTED_MODULE_2__["Fragment"], null, react__WEBPACK_IMPORTED_MODULE_2__["Children"].map(children, function (child) {
    return child && /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_2__["cloneElement"])(child, props);
  }));
};

/***/ }),

/***/ "3jv5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Heading_Heading; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-markdown/lib/react-markdown.js
var react_markdown = __webpack_require__("VqYj");
var react_markdown_default = /*#__PURE__*/__webpack_require__.n(react_markdown);

// EXTERNAL MODULE: /opt/webapp/node_modules/remark-breaks/index.js
var remark_breaks = __webpack_require__("l24s");
var remark_breaks_default = /*#__PURE__*/__webpack_require__.n(remark_breaks);

// EXTERNAL MODULE: ./src/client/components/utils/markdown/markdown.js
var markdown = __webpack_require__("ZMpj");

// CONCATENATED MODULE: ./src/client/components/frameworks/heading/Heading.themes.js
var themes = {
  none: {
    thRoot: ''
  },
  'heading-brand-1': {
    thRoot: 'text-black font-brand text-32 leading-tight'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/heading/Heading.jsx









var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var MARKDOWN_ALLOWED_TYPES = [markdown["a" /* HTML_ELEMENTS */].BREAK.type, markdown["a" /* HTML_ELEMENTS */].EMPHASIS.type, markdown["a" /* HTML_ELEMENTS */].PARAGRAPH.type, markdown["a" /* HTML_ELEMENTS */].STRONG.type, markdown["a" /* HTML_ELEMENTS */].TEXT.type];

var HeadingText = function HeadingText(_ref) {
  var children = _ref.children;
  return children;
};

var Heading_Heading = function Heading(_ref2) {
  var children = _ref2.children,
      className = _ref2.className,
      _ref2$hLevel = _ref2.hLevel,
      hLevel = _ref2$hLevel === void 0 ? 1 : _ref2$hLevel,
      _ref2$theme = _ref2.theme,
      theme = _ref2$theme === void 0 ? 'heading-brand-1' : _ref2$theme,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref2, ["children", "className", "hLevel", "theme"]);

  if (!react["Children"].count(children)) {
    return null;
  }

  var thRoot = themes[theme].thRoot;
  return __jsx(react_markdown_default.a, {
    allowedTypes: MARKDOWN_ALLOWED_TYPES,
    className: Object(classnames_utils["a" /* classnames */])(thRoot, className),
    plugins: [remark_breaks_default.a],
    renderers: {
      root: Object(markdown["c" /* markdownRootHeadingRenderer */])(_objectSpread(_objectSpread({}, rest), {}, {
        hLevel: hLevel
      })),
      paragraph: HeadingText
    }
  }, children);
};

/***/ }),

/***/ "4A3Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ AsyncLoader_AsyncLoader; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/Spinner.jsx
var Spinner = __webpack_require__("7amT");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/label/SpinnerLabel.jsx
var SpinnerLabel = __webpack_require__("4SQ0");

// CONCATENATED MODULE: ./src/client/components/widgets/loading/async-loader/AsyncLoader.themes.js
var themes = {
  "default": {
    thRoot: 'flex justify-center h-full items-center'
  },
  labeled: {
    thRoot: 'flex flex-col justify-center items-center my-0 mx-auto text-center w-320',
    thLabel: 'inline'
  }
};
// CONCATENATED MODULE: ./src/client/components/widgets/loading/async-loader/AsyncLoader.jsx


var __jsx = react_default.a.createElement;







var AsyncLoader_AsyncLoader = function AsyncLoader(_ref) {
  var className = _ref.className,
      label = _ref.label,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? icons["a" /* ICONS */].TRIDENT1 : _ref$icon,
      iconSize = _ref.iconSize,
      size = _ref.size,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["className", "label", "icon", "iconSize", "size", "theme"]);

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isAppMounted = _useResponsive.isAppMounted;

  if (!isAppMounted) {
    return null;
  }

  var _themes$theme = themes[theme],
      thLabel = _themes$theme.thLabel,
      thRoot = _themes$theme.thRoot;
  return __jsx("div", Object(esm_extends["a" /* default */])({}, rest, {
    className: Object(classnames_utils["a" /* classnames */])(thRoot, className)
  }), __jsx(Spinner["a" /* Spinner */], {
    iconName: icon,
    iconSize: iconSize,
    size: size
  }), __jsx(SpinnerLabel["a" /* SpinnerLabel */], {
    className: thLabel,
    label: label
  }));
};

/***/ }),

/***/ "4SQ0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SpinnerLabel; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("C/y5");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;


var SpinnerLabel = function SpinnerLabel(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__[/* classnames */ "a"])('text-center font-brand leading-normal max-w-4/5 sm:max-w-3/5 mt-20 text-black text-20', {
      'sr-only': !label
    }, className),
    "aria-live": "polite"
  }, label ? label : 'Loading');
};

/***/ }),

/***/ "4XSA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.default = NumberSchema;

var _inherits = _interopRequireDefault(__webpack_require__("rokF"));

var _mixed = _interopRequireDefault(__webpack_require__("tNma"));

var _locale = __webpack_require__("qr7w");

var _isAbsent = _interopRequireDefault(__webpack_require__("kMkq"));

var isNaN = function isNaN(value) {
  return value != +value;
};

var isInteger = function isInteger(val) {
  return (0, _isAbsent.default)(val) || val === (val | 0);
};

function NumberSchema() {
  var _this = this;

  if (!(this instanceof NumberSchema)) return new NumberSchema();

  _mixed.default.call(this, {
    type: 'number'
  });

  this.withMutation(function () {
    _this.transform(function (value) {
      var parsed = value;

      if (typeof parsed === 'string') {
        parsed = parsed.replace(/\s/g, '');
        if (parsed === '') return NaN; // don't use parseFloat to avoid positives on alpha-numeric strings

        parsed = +parsed;
      }

      if (this.isType(parsed)) return parsed;
      return parseFloat(parsed);
    });
  });
}

(0, _inherits.default)(NumberSchema, _mixed.default, {
  _typeCheck: function _typeCheck(value) {
    if (value instanceof Number) value = value.valueOf();
    return typeof value === 'number' && !isNaN(value);
  },
  min: function min(_min, message) {
    if (message === void 0) {
      message = _locale.number.min;
    }

    return this.test({
      message: message,
      name: 'min',
      exclusive: true,
      params: {
        min: _min
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value >= this.resolve(_min);
      }
    });
  },
  max: function max(_max, message) {
    if (message === void 0) {
      message = _locale.number.max;
    }

    return this.test({
      message: message,
      name: 'max',
      exclusive: true,
      params: {
        max: _max
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value <= this.resolve(_max);
      }
    });
  },
  lessThan: function lessThan(less, message) {
    if (message === void 0) {
      message = _locale.number.lessThan;
    }

    return this.test({
      message: message,
      name: 'max',
      exclusive: true,
      params: {
        less: less
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value < this.resolve(less);
      }
    });
  },
  moreThan: function moreThan(more, message) {
    if (message === void 0) {
      message = _locale.number.moreThan;
    }

    return this.test({
      message: message,
      name: 'min',
      exclusive: true,
      params: {
        more: more
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value > this.resolve(more);
      }
    });
  },
  positive: function positive(msg) {
    if (msg === void 0) {
      msg = _locale.number.positive;
    }

    return this.moreThan(0, msg);
  },
  negative: function negative(msg) {
    if (msg === void 0) {
      msg = _locale.number.negative;
    }

    return this.lessThan(0, msg);
  },
  integer: function integer(message) {
    if (message === void 0) {
      message = _locale.number.integer;
    }

    return this.test({
      name: 'integer',
      message: message,
      test: isInteger
    });
  },
  truncate: function truncate() {
    return this.transform(function (value) {
      return !(0, _isAbsent.default)(value) ? value | 0 : value;
    });
  },
  round: function round(method) {
    var avail = ['ceil', 'floor', 'round', 'trunc'];
    method = method && method.toLowerCase() || 'round'; // this exists for symemtry with the new Math.trunc

    if (method === 'trunc') return this.truncate();
    if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError('Only valid options for round() are: ' + avail.join(', '));
    return this.transform(function (value) {
      return !(0, _isAbsent.default)(value) ? Math[method](value) : value;
    });
  }
});
module.exports = exports["default"];

/***/ }),

/***/ "5r8v":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__("yWCo");

var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.default = ObjectSchema;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(__webpack_require__("c8jO"));

var _extends2 = _interopRequireDefault(__webpack_require__("97Jx"));

var _has = _interopRequireDefault(__webpack_require__("1mr4"));

var _snakeCase2 = _interopRequireDefault(__webpack_require__("CzFL"));

var _camelCase2 = _interopRequireDefault(__webpack_require__("S0cN"));

var _mapKeys = _interopRequireDefault(__webpack_require__("A0Zq"));

var _mapValues = _interopRequireDefault(__webpack_require__("y2Ah"));

var _propertyExpr = __webpack_require__("dFUt");

var _mixed = _interopRequireDefault(__webpack_require__("tNma"));

var _locale = __webpack_require__("qr7w");

var _sortFields = _interopRequireDefault(__webpack_require__("7pmY"));

var _sortByKeyOrder = _interopRequireDefault(__webpack_require__("OhDV"));

var _inherits = _interopRequireDefault(__webpack_require__("rokF"));

var _makePath = _interopRequireDefault(__webpack_require__("raDx"));

var _runValidations = _interopRequireWildcard(__webpack_require__("wM5X"));

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["", ".", ""]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["", ".", ""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var isObject = function isObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
};

function unknown(ctx, value) {
  var known = Object.keys(ctx.fields);
  return Object.keys(value).filter(function (key) {
    return known.indexOf(key) === -1;
  });
}

function ObjectSchema(spec) {
  var _this2 = this;

  if (!(this instanceof ObjectSchema)) return new ObjectSchema(spec);

  _mixed.default.call(this, {
    type: 'object',
    default: function _default() {
      var _this = this;

      if (!this._nodes.length) return undefined;
      var dft = {};

      this._nodes.forEach(function (key) {
        dft[key] = _this.fields[key].default ? _this.fields[key].default() : undefined;
      });

      return dft;
    }
  });

  this.fields = Object.create(null);
  this._nodes = [];
  this._excludedEdges = [];
  this.withMutation(function () {
    _this2.transform(function coerce(value) {
      if (typeof value === 'string') {
        try {
          value = JSON.parse(value);
        } catch (err) {
          value = null;
        }
      }

      if (this.isType(value)) return value;
      return null;
    });

    if (spec) {
      _this2.shape(spec);
    }
  });
}

(0, _inherits.default)(ObjectSchema, _mixed.default, {
  _typeCheck: function _typeCheck(value) {
    return isObject(value) || typeof value === 'function';
  },
  _cast: function _cast(_value, options) {
    var _this3 = this;

    if (options === void 0) {
      options = {};
    }

    var value = _mixed.default.prototype._cast.call(this, _value, options); //should ignore nulls here


    if (value === undefined) return this.default();
    if (!this._typeCheck(value)) return value;
    var fields = this.fields;
    var strip = this._option('stripUnknown', options) === true;

    var props = this._nodes.concat(Object.keys(value).filter(function (v) {
      return _this3._nodes.indexOf(v) === -1;
    }));

    var intermediateValue = {}; // is filled during the transform below

    var innerOptions = (0, _extends2.default)({}, options, {
      parent: intermediateValue,
      __validating: false
    });
    var isChanged = false;
    props.forEach(function (prop) {
      var field = fields[prop];
      var exists = (0, _has.default)(value, prop);

      if (field) {
        var fieldValue;
        var strict = field._options && field._options.strict; // safe to mutate since this is fired in sequence

        innerOptions.path = (0, _makePath.default)(_templateObject(), options.path, prop);
        innerOptions.value = value[prop];
        field = field.resolve(innerOptions);

        if (field._strip === true) {
          isChanged = isChanged || prop in value;
          return;
        }

        fieldValue = !options.__validating || !strict ? field.cast(value[prop], innerOptions) : value[prop];
        if (fieldValue !== undefined) intermediateValue[prop] = fieldValue;
      } else if (exists && !strip) intermediateValue[prop] = value[prop];

      if (intermediateValue[prop] !== value[prop]) isChanged = true;
    });
    return isChanged ? intermediateValue : value;
  },
  _validate: function _validate(_value, opts) {
    var _this4 = this;

    if (opts === void 0) {
      opts = {};
    }

    var endEarly, recursive;
    var sync = opts.sync;
    var errors = [];
    var originalValue = opts.originalValue != null ? opts.originalValue : _value;
    endEarly = this._option('abortEarly', opts);
    recursive = this._option('recursive', opts);
    opts = (0, _extends2.default)({}, opts, {
      __validating: true,
      originalValue: originalValue
    });
    return _mixed.default.prototype._validate.call(this, _value, opts).catch((0, _runValidations.propagateErrors)(endEarly, errors)).then(function (value) {
      if (!recursive || !isObject(value)) {
        // only iterate though actual objects
        if (errors.length) throw errors[0];
        return value;
      }

      originalValue = originalValue || value;

      var validations = _this4._nodes.map(function (key) {
        var path = (0, _makePath.default)(_templateObject2(), opts.path, key);
        var field = _this4.fields[key];
        var innerOptions = (0, _extends2.default)({}, opts, {
          path: path,
          parent: value,
          originalValue: originalValue[key]
        });

        if (field && field.validate) {
          // inner fields are always strict:
          // 1. this isn't strict so the casting will also have cast inner values
          // 2. this is strict in which case the nested values weren't cast either
          innerOptions.strict = true;
          return field.validate(value[key], innerOptions);
        }

        return Promise.resolve(true);
      });

      return (0, _runValidations.default)({
        sync: sync,
        validations: validations,
        value: value,
        errors: errors,
        endEarly: endEarly,
        path: opts.path,
        sort: (0, _sortByKeyOrder.default)(_this4.fields)
      });
    });
  },
  concat: function concat(schema) {
    var next = _mixed.default.prototype.concat.call(this, schema);

    next._nodes = (0, _sortFields.default)(next.fields, next._excludedEdges);
    return next;
  },
  shape: function shape(schema, excludes) {
    if (excludes === void 0) {
      excludes = [];
    }

    var next = this.clone();
    var fields = (0, _extends2.default)(next.fields, schema);
    next.fields = fields;

    if (excludes.length) {
      if (!Array.isArray(excludes[0])) excludes = [excludes];
      var keys = excludes.map(function (_ref) {
        var first = _ref[0],
            second = _ref[1];
        return first + "-" + second;
      });
      next._excludedEdges = next._excludedEdges.concat(keys);
    }

    next._nodes = (0, _sortFields.default)(fields, next._excludedEdges);
    return next;
  },
  from: function from(_from, to, alias) {
    var fromGetter = (0, _propertyExpr.getter)(_from, true);
    return this.transform(function (obj) {
      if (obj == null) return obj;
      var newObj = obj;

      if ((0, _has.default)(obj, _from)) {
        newObj = (0, _extends2.default)({}, obj);
        if (!alias) delete newObj[_from];
        newObj[to] = fromGetter(obj);
      }

      return newObj;
    });
  },
  noUnknown: function noUnknown(noAllow, message) {
    if (noAllow === void 0) {
      noAllow = true;
    }

    if (message === void 0) {
      message = _locale.object.noUnknown;
    }

    if (typeof noAllow === 'string') {
      message = noAllow;
      noAllow = true;
    }

    var next = this.test({
      name: 'noUnknown',
      exclusive: true,
      message: message,
      test: function test(value) {
        return value == null || !noAllow || unknown(this.schema, value).length === 0;
      }
    });
    next._options.stripUnknown = noAllow;
    return next;
  },
  unknown: function unknown(allow, message) {
    if (allow === void 0) {
      allow = true;
    }

    if (message === void 0) {
      message = _locale.object.noUnknown;
    }

    return this.noUnknown(!allow, message);
  },
  transformKeys: function transformKeys(fn) {
    return this.transform(function (obj) {
      return obj && (0, _mapKeys.default)(obj, function (_, key) {
        return fn(key);
      });
    });
  },
  camelCase: function camelCase() {
    return this.transformKeys(_camelCase2.default);
  },
  snakeCase: function snakeCase() {
    return this.transformKeys(_snakeCase2.default);
  },
  constantCase: function constantCase() {
    return this.transformKeys(function (key) {
      return (0, _snakeCase2.default)(key).toUpperCase();
    });
  },
  describe: function describe() {
    var base = _mixed.default.prototype.describe.call(this);

    base.fields = (0, _mapValues.default)(this.fields, function (value) {
      return value.describe();
    });
    return base;
  }
});
module.exports = exports["default"];

/***/ }),

/***/ "5xkM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ICON_POSITIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LINK_SPACINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TITLE_POSITIONS; });
/* unused harmony export SIZES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getHeroDimensions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return generateBackgroundStylesAndClassName; });
/* unused harmony export getBackgroundImageUrl */
/* unused harmony export getBackgroundRule */
/* unused harmony export getAllBackgroundRules */
/* unused harmony export AUTO */
/* unused harmony export PREFIXES */
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("zjfJ");
/* harmony import */ var _utils_media_server__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("FLQK");
/* harmony import */ var _utils_media_server_dictionary__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("lDxO");
/* harmony import */ var _utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("m1JM");











function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}




var AUTO = '_AUTOFORMAT_';
var PREFIXES = ['webkit', 'moz', 'o', 'ms'];

var getBackgroundImageUrl = function getBackgroundImageUrl(url, width) {
  var options = {
    format: AUTO,
    url: url,
    width: width,
    height: 'auto',
    transform: 'resize',
    quality: 70
  };
  return _utils_media_server__WEBPACK_IMPORTED_MODULE_10__[/* getUrl */ "a"](options);
};

var getBackgroundRule = function getBackgroundRule(params) {
  return function (getUrlFunction) {
    return function (prefixes) {
      var id = params.id,
          url = params.url,
          width1x = params.width1x,
          width2x = params.width2x;
      return ".".concat(id, " {\n        background-image:url(").concat(getUrlFunction(url, width1x), ");\n        ").concat(prefixes.reduce(function (acc, prefix) {
        return "".concat(acc, "\n        background-image: -").concat(prefix, "-image-set(url(").concat(getUrlFunction(url, width1x), ") 1x, url(").concat(getUrlFunction(url, width2x), ") 2x);\n        ");
      }, ''), "\n      }");
    };
  };
};

var getAllBackgroundRules = function getAllBackgroundRules(params) {
  return function (getRuleFunction) {
    return "".concat(getRuleFunction(params)(getBackgroundImageUrl)(PREFIXES));
  };
};

var ICON_POSITIONS = {
  'top-left': 'items-start justify-start',
  'top-middle': 'items-start justify-center',
  'top-right': 'items-start justify-end',
  'center-left': 'items-center justify-start',
  'center-middle': 'items-center justify-center',
  'center-right': 'items-center justify-end',
  'bottom-left': 'items-end justify-start',
  'bottom-middle': 'items-end justify-center',
  'bottom-right': 'items-end justify-end'
};
var LINK_SPACINGS = {
  left: 'md:p-30 md:-ms-30',
  middle: 'md:p-30',
  right: 'md:p-30 md:-me-30'
};
var TITLE_POSITIONS = {
  'top-left': 'mb-auto items-start text-start',
  'top-middle': 'mb-auto items-center text-center',
  'top-right': 'mb-auto items-end text-end',
  'center-left': 'my-auto items-start text-start',
  'center-middle': 'my-auto items-center text-center',
  'center-right': 'my-auto items-end text-end',
  'bottom-left': 'mt-auto items-start text-start',
  'bottom-middle': 'mt-auto items-center text-center',
  'bottom-right': 'mt-auto items-end text-end'
};
var SIZES = {
  small: {
    mobile: {
      height: '220px',
      paddingBottom: '60px'
    },
    desktop: {
      height: '340px',
      paddingBottom: '80px'
    }
  },
  highlightSmall: {
    mobile: {
      height: '220px',
      paddingBottom: '60px'
    },
    desktop: {
      height: '340px',
      paddingBottom: '80px'
    }
  },
  medium: {
    mobile: {
      height: '320px',
      paddingBottom: '60px'
    },
    desktop: {
      height: '440px',
      paddingBottom: '100px'
    }
  },
  large: {
    mobile: {
      height: '420px',
      paddingBottom: '60px'
    },
    desktop: {
      height: '540px',
      paddingBottom: '115px'
    }
  },
  highlight: {
    mobile: {
      height: '480px',
      paddingBottom: '40px'
    },
    desktop: {
      height: '480px',
      paddingBottom: '70px'
    }
  },
  full: {
    mobile: {
      height: '100%',
      paddingBottom: '60px'
    },
    desktop: {
      height: '100%',
      paddingBottom: '115px'
    }
  }
};
var getHeroDimensions = function getHeroDimensions(sizeProp) {
  var isHighlight = sizeProp === 'highlightSmall' || sizeProp === 'highlight';
  return {
    heightClassName: "immersiveHeight--".concat(sizeProp),
    paddingBottomClassName: "immersivePaddingBottom--".concat(sizeProp),
    paddingTopClassName: isHighlight ? 'immersivePaddingTop--highlight' : 'immersivePaddingTop'
  };
};
var generateBackgroundStylesAndClassName = function generateBackgroundStylesAndClassName(_ref) {
  var backgroundURLDesktop = _ref.backgroundURLDesktop,
      backgroundURLMobile = _ref.backgroundURLMobile;

  if (!backgroundURLDesktop && !backgroundURLMobile) {
    return {
      style: '',
      className: ''
    };
  }

  var url = backgroundURLDesktop || backgroundURLMobile;
  var componentId = Object(_utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_12__[/* generateUniqueId */ "b"])([url]);
  var widths = _utils_media_server_dictionary__WEBPACK_IMPORTED_MODULE_11__[/* defaultDictionnary */ "a"].getWidthRanges();
  var params = {
    id: componentId,
    url: url
  };
  var mobileUrl = backgroundURLMobile || backgroundURLDesktop;
  return {
    className: componentId,
    style: "".concat(getAllBackgroundRules(_objectSpread(_objectSpread({}, params), {}, {
      url: mobileUrl,
      width1x: widths[1],
      width2x: widths[2]
    }))(getBackgroundRule), "\n      @media all and (min-width: 22.51em) {\n        ").concat(getAllBackgroundRules(_objectSpread(_objectSpread({}, params), {}, {
      url: mobileUrl,
      width1x: widths[2],
      width2x: widths[5]
    }))(getBackgroundRule), "\n      }\n      @media all and (min-width: 40.01em) {\n        ").concat(getAllBackgroundRules(_objectSpread(_objectSpread({}, params), {}, {
      width1x: widths[3],
      width2x: widths[5]
    }))(getBackgroundRule), "\n      }\n      @media all and (min-width: 64.01em) {\n        ").concat(getAllBackgroundRules(_objectSpread(_objectSpread({}, params), {}, {
      width1x: widths[5],
      width2x: widths[6]
    }))(getBackgroundRule), "\n      }\n      @media all and (min-width: 76.26em) {\n        ").concat(getAllBackgroundRules(_objectSpread(_objectSpread({}, params), {}, {
      width1x: widths[6],
      width2x: widths[6]
    }))(getBackgroundRule), "\n      }")
  };
};


/***/ }),

/***/ "786X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Card_Card; });

// NAMESPACE OBJECT: ./src/client/components/frameworks/card/Card.layouts.jsx
var Card_layouts_namespaceObject = {};
__webpack_require__.r(Card_layouts_namespaceObject);
__webpack_require__.d(Card_layouts_namespaceObject, "Inline1", function() { return Card_layouts_Inline1; });
__webpack_require__.d(Card_layouts_namespaceObject, "Inline2", function() { return Card_layouts_Inline2; });
__webpack_require__.d(Card_layouts_namespaceObject, "Column1", function() { return Card_layouts_Column1; });
__webpack_require__.d(Card_layouts_namespaceObject, "Column2", function() { return Column2; });
__webpack_require__.d(Card_layouts_namespaceObject, "Composite1", function() { return Card_layouts_Composite1; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.link.js
var es_string_link = __webpack_require__("hBvt");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/text-link/TextLink.jsx + 1 modules
var TextLink = __webpack_require__("jD8k");

// EXTERNAL MODULE: ./src/client/components/frameworks/text-see-more/TextSeeMore.jsx
var TextSeeMore = __webpack_require__("VBBE");

// EXTERNAL MODULE: ./src/client/components/frameworks/card/Card.constants.js
var Card_constants = __webpack_require__("syQ6");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/card/card-body/CardBody.themes.js

var defaultTheme = {
  thCta: 'font-bold underline',
  thCtaDefaultColor: colors["a" /* COLORS */].BLACK
};
var themes = {
  "default": defaultTheme,
  thumbnail: defaultTheme
};
// CONCATENATED MODULE: ./src/client/components/frameworks/card/card-body/CardBody.jsx




var __jsx = react_default.a.createElement;







var CardBody_CardBody = function CardBody(_ref) {
  var ctaLabel = _ref.ctaLabel,
      dataTestIdPrefix = _ref.dataTestIdPrefix,
      _ref$displayLoadMore = _ref.displayLoadMore,
      displayLoadMore = _ref$displayLoadMore === void 0 ? true : _ref$displayLoadMore,
      isTablet = _ref.isTablet,
      layout = _ref.layout,
      _ref$link = _ref.link,
      link = _ref$link === void 0 ? {} : _ref$link,
      seeLessLabel = _ref.seeLessLabel,
      seeMoreLabel = _ref.seeMoreLabel,
      _ref$text = _ref.text,
      text = _ref$text === void 0 ? {} : _ref$text,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var _themes$theme = themes[theme],
      thCta = _themes$theme.thCta,
      thCtaDefaultColor = _themes$theme.thCtaDefaultColor;
  var isCollapsable = displayLoadMore && (!isTablet || [Card_constants["a" /* COLUMN_1 */], Card_constants["b" /* COLUMN_2 */]].includes(layout));
  return __jsx(react["Fragment"], null, __jsx(TextSeeMore["a" /* TextSeeMore */], Object(esm_extends["a" /* default */])({}, text, {
    dataTestIdPrefix: dataTestIdPrefix,
    hasNoScrollOnCollapse: true,
    isCollapseEnabled: isCollapsable,
    seeLessLabel: seeLessLabel,
    seeMoreLabel: seeMoreLabel
  })), __jsx(TextLink["a" /* TextLink */], Object(esm_extends["a" /* default */])({}, link, {
    className: Object(classnames_utils["a" /* classnames */])(thCta, {
      'mt-20': text === null || text === void 0 ? void 0 : text.text
    }),
    color: thCtaDefaultColor,
    iconName: icons["a" /* ICONS */].ARROW_TAIL_RIGHT,
    label: ctaLabel
  })));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.small.js
var es_string_small = __webpack_require__("uFXj");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLink.jsx
var DynamicLink = __webpack_require__("i5Mr");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// CONCATENATED MODULE: ./src/client/components/frameworks/card/card-header/card-heading/CardHeading.themes.js
var CardHeading_themes_themes = {
  "default": {
    thTitleTheme: 'title-brand-n2',
    thSmall: 'font-normal font-sans text-12',
    thSubtitle: 'text-sienna',
    thSubtitleTheme: 'title-sans-n2'
  },
  thumbnail: {
    thTitleTheme: 'title-brand-n3',
    thSmall: 'font-normal font-sans text-10',
    thSubtitle: 'text-sienna',
    thSubtitleTheme: 'title-sans-n2'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/card/card-header/card-heading/CardHeading.jsx



var CardHeading_jsx = react_default.a.createElement;





var CardHeading_CardHeading = function CardHeading(_ref) {
  var color = _ref.color,
      _ref$dataTestIdPrefix = _ref.dataTestIdPrefix,
      dataTestIdPrefix = _ref$dataTestIdPrefix === void 0 ? 'CardHeading' : _ref$dataTestIdPrefix,
      _ref$hLevel = _ref.hLevel,
      hLevel = _ref$hLevel === void 0 ? 2 : _ref$hLevel,
      iconName = _ref.iconName,
      link = _ref.link,
      small = _ref.small,
      subtitle = _ref.subtitle,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      title = _ref.title;

  if (!title) {
    return null;
  }

  var _themes$theme = CardHeading_themes_themes[theme],
      thSmall = _themes$theme.thSmall,
      thSubtitle = _themes$theme.thSubtitle,
      thSubtitleTheme = _themes$theme.thSubtitleTheme,
      thTitleTheme = _themes$theme.thTitleTheme; // eslint-disable-next-line clubmed/no-fake-component

  var withLink = function withLink(node) {
    return (link === null || link === void 0 ? void 0 : link.url) ? CardHeading_jsx(DynamicLink["a" /* default */], Object(esm_extends["a" /* default */])({}, link, {
      className: "block"
    }), node) : node;
  };

  return withLink(CardHeading_jsx(react["Fragment"], null, CardHeading_jsx(Title["a" /* Title */], {
    dataTestId: "".concat(dataTestIdPrefix, "-title"),
    hLevel: hLevel,
    iconName: iconName,
    theme: thTitleTheme
  }, title, !!small && CardHeading_jsx("small", {
    className: thSmall
  }, small)), !!subtitle && CardHeading_jsx(Title["a" /* Title */], {
    className: Object(classnames_utils["a" /* classnames */])(thSubtitle, "text-".concat(color || 'black')),
    dataTestId: "".concat(dataTestIdPrefix, "-subtitle"),
    hLevel: hLevel < 6 ? hLevel + 1 : 6,
    theme: thSubtitleTheme
  }, subtitle)));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/card/card-header/CardHeader.themes.js
var CardHeader_themes_defaultTheme = {
  thIntro: 'mt-20'
};
var CardHeader_themes_themes = {
  "default": CardHeader_themes_defaultTheme,
  thumbnail: CardHeader_themes_defaultTheme
};
// CONCATENATED MODULE: ./src/client/components/frameworks/card/card-header/CardHeader.jsx


var CardHeader_jsx = react_default.a.createElement;




var CardHeader_CardHeader = function CardHeader(_ref) {
  var color = _ref.color,
      _ref$dataTestIdPrefix = _ref.dataTestIdPrefix,
      dataTestIdPrefix = _ref$dataTestIdPrefix === void 0 ? 'CardHeader' : _ref$dataTestIdPrefix,
      heading = _ref.heading,
      introduction = _ref.introduction,
      link = _ref.link,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var thIntro = CardHeader_themes_themes[theme].thIntro;
  return CardHeader_jsx("header", null, CardHeader_jsx(CardHeading_CardHeading, Object(esm_extends["a" /* default */])({}, heading, {
    color: color,
    dataTestIdPrefix: dataTestIdPrefix,
    link: link,
    theme: theme
  })), !!introduction && CardHeader_jsx(Text["a" /* Text */], Object(esm_extends["a" /* default */])({}, introduction, {
    className: thIntro,
    "data-testid": "".concat(dataTestIdPrefix, "-introduction")
  })));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/is-image/index.js
var is_image = __webpack_require__("JFtY");
var is_image_default = /*#__PURE__*/__webpack_require__.n(is_image);

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Img.jsx + 1 modules
var Img = __webpack_require__("X6TF");

// EXTERNAL MODULE: ./src/client/components/frameworks/video/Video.utils.js
var Video_utils = __webpack_require__("JhHq");

// EXTERNAL MODULE: ./src/client/components/frameworks/backdrop/Backdrop.jsx + 1 modules
var Backdrop = __webpack_require__("NZxu");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/video/Video.jsx
var Video = __webpack_require__("akds");

// CONCATENATED MODULE: ./src/client/components/frameworks/video-with-full-screen/VideoWithFullScreen.themes.js
var VideoWithFullScreen_themes_themes = {
  "default": {
    thThumbnailButton: 'hover:opacity-75 relative transition-opacity duration-250 ease-in w-full',
    thThumbnailButtonLabel: 'sr-only',
    thThumbnailIcon: 'absolute bg-black/60 leading-0 m-10 top-0 p-10 right-0 text-white',
    thThumbnailIconSize: '1.5625rem',
    thVideo: 'w-full'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/video-with-full-screen/VideoWithFullScreen.jsx
var VideoWithFullScreen_jsx = react_default.a.createElement;









function VideoWithFullScreen(props) {
  var buttonLabel = props.buttonLabel,
      className = props.className,
      closeLabel = props.closeLabel,
      ratioKey = props.ratioKey,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'default' : _props$theme,
      thumbnail = props.thumbnail,
      title = props.title,
      url = props.url;

  var _useState = Object(react["useState"])(false),
      isExpanded = _useState[0],
      setExpanded = _useState[1];

  if (!Object(Video_utils["b" /* isVideoUrl */])(url)) {
    return null;
  }

  if (!thumbnail) {
    return VideoWithFullScreen_jsx(Video["a" /* Video */], {
      className: className,
      ratioKey: ratioKey,
      url: url
    });
  }

  var _themes$theme = VideoWithFullScreen_themes_themes[theme],
      thIframe = _themes$theme.thIframe,
      thThumbnailButton = _themes$theme.thThumbnailButton,
      thThumbnailIcon = _themes$theme.thThumbnailIcon,
      thThumbnailIconSize = _themes$theme.thThumbnailIconSize,
      thThumbnailButtonLabel = _themes$theme.thThumbnailButtonLabel,
      thVideo = _themes$theme.thVideo;
  return VideoWithFullScreen_jsx(react["Fragment"], null, VideoWithFullScreen_jsx("button", {
    className: Object(classnames_utils["a" /* classnames */])(thThumbnailButton, className),
    onClick: function onClick() {
      return setExpanded(!isExpanded);
    },
    type: "button"
  }, VideoWithFullScreen_jsx("span", {
    classnames: thThumbnailButtonLabel
  }, buttonLabel), VideoWithFullScreen_jsx(Image["a" /* Image */], {
    imageUrl: thumbnail,
    ratioKey: ratioKey
  }), VideoWithFullScreen_jsx("div", {
    className: thThumbnailIcon
  }, VideoWithFullScreen_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].MEDIA_VIDEO,
    width: thThumbnailIconSize
  }))), isExpanded && VideoWithFullScreen_jsx(Backdrop["a" /* Backdrop */], {
    ariaLabel: title,
    closeLabel: closeLabel,
    hasCloseButton: true,
    onClose: function onClose() {
      return setExpanded(!isExpanded);
    }
  }, VideoWithFullScreen_jsx(Video["a" /* Video */], {
    className: thVideo,
    iFrameClassName: thIframe,
    ratioKey: ratioKey,
    url: url
  })));
}
// EXTERNAL MODULE: ./src/client/components/utils/ratios/ratios.utils.js
var ratios_utils = __webpack_require__("u/u4");

// CONCATENATED MODULE: ./src/client/components/frameworks/card/card-media/CardMedia.themes.js

var CardMedia_themes_defaultTheme = {
  thImageRatio: ratios_utils["c" /* default */].M,
  thVideo: 'bg-black'
};
var CardMedia_themes_themes = {
  "default": CardMedia_themes_defaultTheme,
  thumbnail: CardMedia_themes_defaultTheme
};
// CONCATENATED MODULE: ./src/client/components/frameworks/card/card-media/CardMedia.jsx


var CardMedia_jsx = react_default.a.createElement;











var CardMedia_CardMedia = function CardMedia(_ref) {
  var children = _ref.children,
      closeLabel = _ref.closeLabel,
      hasFullScreenMode = _ref.hasFullScreenMode,
      _ref$link = _ref.link,
      link = _ref$link === void 0 ? {} : _ref$link,
      _ref$media = _ref.media,
      media = _ref$media === void 0 ? {} : _ref$media,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title;
  var _themes$theme = CardMedia_themes_themes[theme],
      thVideo = _themes$theme.thVideo,
      thImageRatio = _themes$theme.thImageRatio;
  var track = Object(useTracking["a" /* useTracking */])({
    actionGA: 'fullScreen',
    labelGA: "blockTitle_".concat(title)
  });

  var _useState = Object(react["useState"])(false),
      shouldDisplayFullScreen = _useState[0],
      setShouldDisplayFullScreen = _useState[1];

  var _useState2 = Object(react["useState"])(0),
      zoomLevel = _useState2[0],
      setZoomLevel = _useState2[1]; // eslint-disable-next-line clubmed/no-fake-component


  var withLink = function withLink(node) {
    return node && link && link.url ? CardMedia_jsx(DynamicLink["a" /* default */], Object(esm_extends["a" /* default */])({}, link, {
      className: "block"
    }), node) : node;
  };

  return CardMedia_jsx(react["Fragment"], null, is_image_default()(media.url || '') ? withLink(CardMedia_jsx(react["Fragment"], null, hasFullScreenMode && CardMedia_jsx(react["Fragment"], null, CardMedia_jsx("button", {
    onClick: function onClick() {
      setShouldDisplayFullScreen(true);
      track();
    },
    className: "absolute end-0 top-0 m-15 rounded-2 bg-white p-5 leading-0 text-black shadow-sm transition-bg-color duration-250 ease-in hocus:bg-black/60 hocus:text-white",
    type: "button"
  }, CardMedia_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].EXPAND,
    width: "1.25rem"
  })), shouldDisplayFullScreen && CardMedia_jsx(Backdrop["a" /* Backdrop */], {
    onClose: function onClose() {
      setShouldDisplayFullScreen(false);
      setZoomLevel(0);
    },
    hasCloseButton: true
  }, zoomLevel === 0 ? CardMedia_jsx(Img["a" /* Img */], {
    dontChangeAnything: true,
    altMsg: media.alt,
    url: media.url,
    ratioDisplay: 1
  }) : CardMedia_jsx("div", {
    className: "max-h-full overflow-scroll"
  }, CardMedia_jsx(Img["a" /* Img */], {
    dontChangeAnything: true,
    altMsg: media.alt,
    url: media.url,
    ratioDisplay: 1,
    className: "mx-auto block",
    style: {
      maxWidth: "".concat(100 + zoomLevel * 100, "%")
    }
  })), CardMedia_jsx("div", {
    className: "absolute bottom-0 flex gap-x-10 p-20"
  }, CardMedia_jsx("button", {
    className: "animation-duration-500 relative top-0 z-3 flex size-26 items-center justify-center rounded-2 bg-white text-12 leading-0 text-black shadow transition-colors duration-250 ease-in ltr:animate-slideInRight rtl:animate-slideInLeft",
    onClick: function onClick() {
      zoomLevel <= 4 ? setZoomLevel(zoomLevel + 1) : setZoomLevel(5);
    },
    type: "button"
  }, CardMedia_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].PLUS
  })), CardMedia_jsx("button", {
    className: "animation-duration-500 relative top-0 z-3 flex size-26 items-center justify-center rounded-2 bg-white text-12 leading-0 text-black shadow transition-colors duration-250 ease-in ltr:animate-slideInRight rtl:animate-slideInLeft",
    onClick: function onClick() {
      zoomLevel >= 1 ? setZoomLevel(zoomLevel - 1) : setZoomLevel(0);
    },
    type: "button"
  }, CardMedia_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].MINUS
  }))))), CardMedia_jsx(Image["b" /* default */], {
    altMsg: media.alt,
    imageUrl: media.url,
    ratioKey: media.ratioKey || thImageRatio,
    ratioDisplay: media.ratioDisplay || 1 / 2
  }))) : CardMedia_jsx(VideoWithFullScreen, {
    buttonLabel: media.thumbnailLabel,
    className: thVideo,
    closeLabel: closeLabel,
    thumbnail: media.thumbnail || '',
    title: media.title,
    url: media.url
  }), withLink(children));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/card/Card.layouts.jsx
var Card_layouts_jsx = react_default.a.createElement;


var mediaClasses = 'overflow-hidden relative';
var Card_layouts_Inline1 = function Inline1(header, body, media, dataTestIdForTextDiv) {
  return Card_layouts_jsx("div", {
    className: "flex flex-col sm:flex-row sm:items-start gap-20 sm:justify-between"
  }, media && Card_layouts_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(mediaClasses, 'rounded-12 sm:w-1/2')
  }, media), (header || body) && Card_layouts_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])({
      'sm:w-1/2': media
    }),
    "data-testid": dataTestIdForTextDiv
  }, header, body && Card_layouts_jsx("div", {
    className: header && 'mt-20'
  }, body)));
};
var Card_layouts_Inline2 = function Inline2(header, body, media, dataTestIdForTextDiv) {
  return Card_layouts_jsx("div", {
    className: "flex flex-col sm:flex-row-reverse sm:items-start gap-20 sm:justify-between"
  }, media && Card_layouts_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(mediaClasses, 'rounded-12 sm:w-1/2')
  }, media), (header || body) && Card_layouts_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])({
      'sm:w-1/2': media
    }),
    "data-testid": dataTestIdForTextDiv
  }, header, body && Card_layouts_jsx("div", {
    className: header && 'mt-20'
  }, body)));
};
var Card_layouts_Column1 = function Column1(header, body, media) {
  return Card_layouts_jsx(react["Fragment"], null, media && Card_layouts_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(mediaClasses, 'rounded-12')
  }, media), header && Card_layouts_jsx("div", {
    className: media && 'mt-20'
  }, header), body && Card_layouts_jsx("div", {
    className: (media || header) && 'mt-20'
  }, body));
};
var Column2 = function Column2(header, body, media) {
  return Card_layouts_jsx("div", {
    className: "h-full overflow-hidden rounded-12 shadow-subtle"
  }, media && Card_layouts_jsx("div", {
    className: "-mx-1 -mt-1"
  }, media), (header || body) && Card_layouts_jsx("div", {
    className: "p-20"
  }, header, body && Card_layouts_jsx("div", {
    className: header && 'mt-20'
  }, body)));
};
var Card_layouts_Composite1 = function Composite1(header, body, media) {
  return Card_layouts_jsx(react["Fragment"], null, media && Card_layouts_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(mediaClasses, 'rounded-12')
  }, media), (header || body) && Card_layouts_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('flex flex-col sm:flex-row gap-20', {
      'mt-20': media
    })
  }, header && Card_layouts_jsx("div", {
    className: "sm:flex-1"
  }, header), body && Card_layouts_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('sm:flex-1', {
      'mt-20': header
    })
  }, body)));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/card/Card.jsx

var Card_jsx = react_default.a.createElement;







var Card_Card = function Card(_ref) {
  var className = _ref.className,
      closeLabel = _ref.closeLabel,
      color = _ref.color,
      ctaLabel = _ref.ctaLabel,
      customMedia = _ref.customMedia,
      dataTestIdPrefix = _ref.dataTestIdPrefix,
      displayLoadMore = _ref.displayLoadMore,
      hasFullScreenMode = _ref.hasFullScreenMode,
      heading = _ref.heading,
      id = _ref.id,
      introduction = _ref.introduction,
      _ref$layout = _ref.layout,
      layout = _ref$layout === void 0 ? Card_constants["d" /* INLINE_1 */] : _ref$layout,
      link = _ref.link,
      media = _ref.media,
      seeLessLabel = _ref.seeLessLabel,
      seeMoreLabel = _ref.seeMoreLabel,
      text = _ref.text,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var hasTitle = Boolean(heading === null || heading === void 0 ? void 0 : heading.title);
  var hasCta = Boolean(ctaLabel);
  var header = !(introduction === null || introduction === void 0 ? void 0 : introduction.text) && !hasTitle ? null : Card_jsx(CardHeader_CardHeader, {
    color: color,
    dataTestIdPrefix: dataTestIdPrefix,
    heading: heading,
    introduction: introduction,
    link: hasCta ? null : link,
    theme: theme
  });
  var body = !(text === null || text === void 0 ? void 0 : text.text) && !hasCta ? null : Card_jsx(CardBody_CardBody, {
    ctaLabel: ctaLabel,
    dataTestIdPrefix: dataTestIdPrefix,
    displayLoadMore: displayLoadMore,
    isTablet: isTablet,
    layout: layout,
    link: link,
    seeLessLabel: seeLessLabel,
    seeMoreLabel: seeMoreLabel,
    text: text,
    theme: theme
  });
  var picture = !(media === null || media === void 0 ? void 0 : media.url) && !customMedia ? null : Card_jsx(CardMedia_CardMedia, {
    closeLabel: closeLabel,
    hasFullScreenMode: hasFullScreenMode,
    link: hasCta || hasTitle ? null : link,
    media: media,
    theme: theme,
    title: heading === null || heading === void 0 ? void 0 : heading.title
  }, customMedia);
  return body || header || picture ? Card_jsx("article", {
    className: className,
    id: id
  }, Card_layouts_namespaceObject[layout](header, body, picture, dataTestIdPrefix)) : null;
};

/***/ }),

/***/ "7pmY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.default = sortFields;

var _has = _interopRequireDefault(__webpack_require__("1mr4"));

var _toposort = _interopRequireDefault(__webpack_require__("VNI2"));

var _propertyExpr = __webpack_require__("dFUt");

var _Reference = _interopRequireDefault(__webpack_require__("hLcx"));

var _isSchema = _interopRequireDefault(__webpack_require__("kZEO"));

function sortFields(fields, excludes) {
  if (excludes === void 0) {
    excludes = [];
  }

  var edges = [],
      nodes = [];

  function addNode(depPath, key) {
    var node = (0, _propertyExpr.split)(depPath)[0];
    if (!~nodes.indexOf(node)) nodes.push(node);
    if (!~excludes.indexOf(key + "-" + node)) edges.push([key, node]);
  }

  for (var key in fields) {
    if ((0, _has.default)(fields, key)) {
      var value = fields[key];
      if (!~nodes.indexOf(key)) nodes.push(key);
      if (_Reference.default.isRef(value) && value.isSibling) addNode(value.path, key);else if ((0, _isSchema.default)(value) && value._deps) value._deps.forEach(function (path) {
        return addNode(path, key);
      });
    }
  }

  return _toposort.default.array(nodes, edges).reverse();
}

module.exports = exports["default"];

/***/ }),

/***/ "8K1b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _inherits; });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("XcBm");

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) Object(_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(subClass, superClass);
}

/***/ }),

/***/ "97Jx":
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _extends.apply(this, arguments);
}
module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "9fIP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _classCallCheck; });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ "A0Zq":
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__("wC3K"),
    baseForOwn = __webpack_require__("zKkv"),
    baseIteratee = __webpack_require__("S3pA");

/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */
function mapKeys(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, iteratee(value, key, object), value);
  });
  return result;
}

module.exports = mapKeys;


/***/ }),

/***/ "A6++":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GreatMembersIcon; });
/* harmony import */ var lodash_upperFirst__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("TYRa");
/* harmony import */ var lodash_upperFirst__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_upperFirst__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("qBqs");

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;


var GreatMembersIcon = function GreatMembersIcon(_ref) {
  var className = _ref.className,
      status = _ref.status,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '4rem' : _ref$width;
  return __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_2__[/* Icon */ "a"], {
    className: className,
    isNotMonoChrome: true,
    isNotSquare: true,
    name: "GreatMembers".concat(lodash_upperFirst__WEBPACK_IMPORTED_MODULE_0___default()(status)),
    width: width
  });
};

/***/ }),

/***/ "AdY7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__("yWCo");

var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__("97Jx"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(__webpack_require__("c8jO"));

var _inherits = _interopRequireDefault(__webpack_require__("rokF"));

var _isAbsent = _interopRequireDefault(__webpack_require__("kMkq"));

var _isSchema = _interopRequireDefault(__webpack_require__("kZEO"));

var _makePath = _interopRequireDefault(__webpack_require__("raDx"));

var _printValue = _interopRequireDefault(__webpack_require__("i0Sy"));

var _mixed = _interopRequireDefault(__webpack_require__("tNma"));

var _locale = __webpack_require__("qr7w");

var _runValidations = _interopRequireWildcard(__webpack_require__("wM5X"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["", "[", "]"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var _default = ArraySchema;
exports.default = _default;

function ArraySchema(type) {
  var _this = this;

  if (!(this instanceof ArraySchema)) return new ArraySchema(type);

  _mixed.default.call(this, {
    type: 'array'
  }); // `undefined` specifically means uninitialized, as opposed to
  // "no subtype"


  this._subType = undefined;
  this.withMutation(function () {
    _this.transform(function (values) {
      if (typeof values === 'string') try {
        values = JSON.parse(values);
      } catch (err) {
        values = null;
      }
      return this.isType(values) ? values : null;
    });

    if (type) _this.of(type);
  });
}

(0, _inherits.default)(ArraySchema, _mixed.default, {
  _typeCheck: function _typeCheck(v) {
    return Array.isArray(v);
  },
  _cast: function _cast(_value, _opts) {
    var _this2 = this;

    var value = _mixed.default.prototype._cast.call(this, _value, _opts); //should ignore nulls here


    if (!this._typeCheck(value) || !this._subType) return value;
    var isChanged = false;
    var castArray = value.map(function (v) {
      var castElement = _this2._subType.cast(v, _opts);

      if (castElement !== v) {
        isChanged = true;
      }

      return castElement;
    });
    return isChanged ? castArray : value;
  },
  _validate: function _validate(_value, options) {
    var _this3 = this;

    if (options === void 0) {
      options = {};
    }

    var errors = [];
    var sync = options.sync;
    var path = options.path;
    var subType = this._subType;

    var endEarly = this._option('abortEarly', options);

    var recursive = this._option('recursive', options);

    var originalValue = options.originalValue != null ? options.originalValue : _value;
    return _mixed.default.prototype._validate.call(this, _value, options).catch((0, _runValidations.propagateErrors)(endEarly, errors)).then(function (value) {
      if (!recursive || !subType || !_this3._typeCheck(value)) {
        if (errors.length) throw errors[0];
        return value;
      }

      originalValue = originalValue || value;
      var validations = value.map(function (item, idx) {
        var path = (0, _makePath.default)(_templateObject(), options.path, idx); // object._validate note for isStrict explanation

        var innerOptions = (0, _extends2.default)({}, options, {
          path: path,
          strict: true,
          parent: value,
          originalValue: originalValue[idx]
        });
        if (subType.validate) return subType.validate(item, innerOptions);
        return true;
      });
      return (0, _runValidations.default)({
        sync: sync,
        path: path,
        value: value,
        errors: errors,
        endEarly: endEarly,
        validations: validations
      });
    });
  },
  _isPresent: function _isPresent(value) {
    return _mixed.default.prototype._cast.call(this, value) && value.length > 0;
  },
  of: function of(schema) {
    var next = this.clone();
    if (schema !== false && !(0, _isSchema.default)(schema)) throw new TypeError('`array.of()` sub-schema must be a valid yup schema, or `false` to negate a current sub-schema. ' + 'not: ' + (0, _printValue.default)(schema));
    next._subType = schema;
    return next;
  },
  min: function min(_min, message) {
    message = message || _locale.array.min;
    return this.test({
      message: message,
      name: 'min',
      exclusive: true,
      params: {
        min: _min
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value.length >= this.resolve(_min);
      }
    });
  },
  max: function max(_max, message) {
    message = message || _locale.array.max;
    return this.test({
      message: message,
      name: 'max',
      exclusive: true,
      params: {
        max: _max
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value.length <= this.resolve(_max);
      }
    });
  },
  ensure: function ensure() {
    var _this4 = this;

    return this.default(function () {
      return [];
    }).transform(function (val) {
      if (_this4.isType(val)) return val;
      return val === null ? [] : [].concat(val);
    });
  },
  compact: function compact(rejector) {
    var reject = !rejector ? function (v) {
      return !!v;
    } : function (v, i, a) {
      return !rejector(v, i, a);
    };
    return this.transform(function (values) {
      return values != null ? values.filter(reject) : values;
    });
  },
  describe: function describe() {
    var base = _mixed.default.prototype.describe.call(this);

    if (this._subType) base.innerType = this._subType.describe();
    return base;
  }
});
module.exports = exports["default"];

/***/ }),

/***/ "BDDS":
/***/ (function(module, exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/great-members",
      function () {
        return __webpack_require__("ZPhW");
      }
    ]);
  

/***/ }),

/***/ "CzFL":
/***/ (function(module, exports, __webpack_require__) {

var createCompounder = __webpack_require__("4ygQ");

/**
 * Converts `string` to
 * [snake case](https://en.wikipedia.org/wiki/Snake_case).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the snake cased string.
 * @example
 *
 * _.snakeCase('Foo Bar');
 * // => 'foo_bar'
 *
 * _.snakeCase('fooBar');
 * // => 'foo_bar'
 *
 * _.snakeCase('--FOO-BAR--');
 * // => 'foo_bar'
 */
var snakeCase = createCompounder(function(result, word, index) {
  return result + (index ? '_' : '') + word.toLowerCase();
});

module.exports = snakeCase;


/***/ }),

/***/ "DSo7":
/***/ (function(module, exports) {

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

module.exports = _iterableToArray;

/***/ }),

/***/ "E8R/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.default = StringSchema;

var _inherits = _interopRequireDefault(__webpack_require__("rokF"));

var _mixed = _interopRequireDefault(__webpack_require__("tNma"));

var _locale = __webpack_require__("qr7w");

var _isAbsent = _interopRequireDefault(__webpack_require__("kMkq"));

// eslint-disable-next-line
var rEmail = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i; // eslint-disable-next-line

var rUrl = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;

var isTrimmed = function isTrimmed(value) {
  return (0, _isAbsent.default)(value) || value === value.trim();
};

function StringSchema() {
  var _this = this;

  if (!(this instanceof StringSchema)) return new StringSchema();

  _mixed.default.call(this, {
    type: 'string'
  });

  this.withMutation(function () {
    _this.transform(function (value) {
      if (this.isType(value)) return value;
      return value != null && value.toString ? value.toString() : value;
    });
  });
}

(0, _inherits.default)(StringSchema, _mixed.default, {
  _typeCheck: function _typeCheck(value) {
    if (value instanceof String) value = value.valueOf();
    return typeof value === 'string';
  },
  _isPresent: function _isPresent(value) {
    return _mixed.default.prototype._cast.call(this, value) && value.length > 0;
  },
  length: function length(_length, message) {
    if (message === void 0) {
      message = _locale.string.length;
    }

    return this.test({
      message: message,
      name: 'length',
      exclusive: true,
      params: {
        length: _length
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value.length === this.resolve(_length);
      }
    });
  },
  min: function min(_min, message) {
    if (message === void 0) {
      message = _locale.string.min;
    }

    return this.test({
      message: message,
      name: 'min',
      exclusive: true,
      params: {
        min: _min
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value.length >= this.resolve(_min);
      }
    });
  },
  max: function max(_max, message) {
    if (message === void 0) {
      message = _locale.string.max;
    }

    return this.test({
      name: 'max',
      exclusive: true,
      message: message,
      params: {
        max: _max
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value.length <= this.resolve(_max);
      }
    });
  },
  matches: function matches(regex, options) {
    var excludeEmptyString = false;
    var message;

    if (options) {
      if (options.message || options.hasOwnProperty('excludeEmptyString')) {
        excludeEmptyString = options.excludeEmptyString;
        message = options.message;
      } else message = options;
    }

    return this.test({
      message: message || _locale.string.matches,
      params: {
        regex: regex
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value === '' && excludeEmptyString || regex.test(value);
      }
    });
  },
  email: function email(message) {
    if (message === void 0) {
      message = _locale.string.email;
    }

    return this.matches(rEmail, {
      message: message,
      excludeEmptyString: true
    });
  },
  url: function url(message) {
    if (message === void 0) {
      message = _locale.string.url;
    }

    return this.matches(rUrl, {
      message: message,
      excludeEmptyString: true
    });
  },
  //-- transforms --
  ensure: function ensure() {
    return this.default('').transform(function (val) {
      return val === null ? '' : val;
    });
  },
  trim: function trim(message) {
    if (message === void 0) {
      message = _locale.string.trim;
    }

    return this.transform(function (val) {
      return val != null ? val.trim() : val;
    }).test({
      message: message,
      name: 'trim',
      test: isTrimmed
    });
  },
  lowercase: function lowercase(message) {
    if (message === void 0) {
      message = _locale.string.lowercase;
    }

    return this.transform(function (value) {
      return !(0, _isAbsent.default)(value) ? value.toLowerCase() : value;
    }).test({
      message: message,
      name: 'string_case',
      exclusive: true,
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value === value.toLowerCase();
      }
    });
  },
  uppercase: function uppercase(message) {
    if (message === void 0) {
      message = _locale.string.uppercase;
    }

    return this.transform(function (value) {
      return !(0, _isAbsent.default)(value) ? value.toUpperCase() : value;
    }).test({
      message: message,
      name: 'string_case',
      exclusive: true,
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value === value.toUpperCase();
      }
    });
  }
});
module.exports = exports["default"];

/***/ }),

/***/ "F0GY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isArray = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;
var hasElementType = typeof Element !== 'undefined';

function equal(a, b) {
  // fast-deep-equal index.js 2.0.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    var arrA = isArray(a)
      , arrB = isArray(b)
      , i
      , length
      , key;

    if (arrA && arrB) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    if (arrA != arrB) return false;

    var dateA = a instanceof Date
      , dateB = b instanceof Date;
    if (dateA != dateB) return false;
    if (dateA && dateB) return a.getTime() == b.getTime();

    var regexpA = a instanceof RegExp
      , regexpB = b instanceof RegExp;
    if (regexpA != regexpB) return false;
    if (regexpA && regexpB) return a.toString() == b.toString();

    var keys = keyList(a);
    length = keys.length;

    if (length !== keyList(b).length)
      return false;

    for (i = length; i-- !== 0;)
      if (!hasProp.call(b, keys[i])) return false;
    // end fast-deep-equal

    // start react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element && b instanceof Element)
      return a === b;

    // custom handling for React
    for (i = length; i-- !== 0;) {
      key = keys[i];
      if (key === '_owner' && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner.
        //  _owner contains circular references
        // and is not needed when comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of a react element
        continue;
      } else {
        // all other properties should be traversed as usual
        if (!equal(a[key], b[key])) return false;
      }
    }
    // end react-fast-compare

    // fast-deep-equal index.js 2.0.1
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

module.exports = function exportedEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if ((error.message && error.message.match(/stack|recursion/i)) || (error.number === -2146828260)) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};


/***/ }),

/***/ "HbGN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _objectWithoutProperties; });
/* harmony import */ var _objectWithoutPropertiesLoose_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("+wNj");

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = Object(_objectWithoutPropertiesLoose_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

/***/ }),

/***/ "I/kN":
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__("w7mb");

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits;

/***/ }),

/***/ "IGGJ":
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "Iev9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useAuthentication; });
/* harmony import */ var _client_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("Ub5k");

function useAuthentication() {
  var appContext = Object(_client_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_0__[/* useAppContext */ "c"])();
  return {
    isLogged: appContext.isUserLogged,
    isQuickLogged: appContext.isUserQuickLogged
  };
}

/***/ }),

/***/ "J9Yr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("7x/C");

__webpack_require__("OZaJ");

__webpack_require__("DZ+c");

var _toConsumableArray = __webpack_require__("iN+R");

var _classCallCheck = __webpack_require__("zQIG");

var _createClass = __webpack_require__("8mBC");

var _assertThisInitialized = __webpack_require__("N7I1");

var _inherits = __webpack_require__("I/kN");

var _possibleConstructorReturn = __webpack_require__("cMav");

var _getPrototypeOf = __webpack_require__("pSQP");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

exports.__esModule = true;
exports.default = void 0;

var _react = __webpack_require__("ERkP");

var isServer = false;

var _default = /*#__PURE__*/function (_react$Component) {
  _inherits(_default, _react$Component);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);
    _this._hasHeadManager = void 0;

    _this.emitChange = function () {
      if (_this._hasHeadManager) {
        _this.props.headManager.updateHead(_this.props.reduceComponentsToState(_toConsumableArray(_this.props.headManager.mountedInstances), _this.props));
      }
    };

    _this._hasHeadManager = _this.props.headManager && _this.props.headManager.mountedInstances;

    if (isServer && _this._hasHeadManager) {
      _this.props.headManager.mountedInstances.add(_assertThisInitialized(_this));

      _this.emitChange();
    }

    return _this;
  }

  _createClass(_default, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this._hasHeadManager) {
        this.props.headManager.mountedInstances.add(this);
      }

      this.emitChange();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.emitChange();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._hasHeadManager) {
        this.props.headManager.mountedInstances.delete(this);
      }

      this.emitChange();
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return _default;
}(_react.Component);

exports.default = _default;

/***/ }),

/***/ "JFtY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var path = __webpack_require__("oNVP");
var imageExtensions = __webpack_require__("y147");
var exts = Object.create(null);

imageExtensions.forEach(function (el) {
	exts[el] = true;
});

module.exports = function (filepath) {
	return path.extname(filepath).slice(1).toLowerCase() in exts;
};


/***/ }),

/***/ "JeoY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.createErrorFactory = createErrorFactory;
exports.default = createValidation;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__("LdEA"));

var _extends2 = _interopRequireDefault(__webpack_require__("97Jx"));

var _mapValues = _interopRequireDefault(__webpack_require__("y2Ah"));

var _ValidationError = _interopRequireDefault(__webpack_require__("fnDY"));

var _Reference = _interopRequireDefault(__webpack_require__("hLcx"));

var _synchronousPromise = __webpack_require__("V5RX");

var formatError = _ValidationError.default.formatError;

var thenable = function thenable(p) {
  return p && typeof p.then === 'function' && typeof p.catch === 'function';
};

function runTest(testFn, ctx, value, sync) {
  var result = testFn.call(ctx, value);
  if (!sync) return Promise.resolve(result);

  if (thenable(result)) {
    throw new Error("Validation test of type: \"" + ctx.type + "\" returned a Promise during a synchronous validate. " + "This test will finish after the validate call has returned");
  }

  return _synchronousPromise.SynchronousPromise.resolve(result);
}

function resolveParams(oldParams, newParams, resolve) {
  return (0, _mapValues.default)((0, _extends2.default)({}, oldParams, newParams), resolve);
}

function createErrorFactory(_ref) {
  var value = _ref.value,
      label = _ref.label,
      resolve = _ref.resolve,
      originalValue = _ref.originalValue,
      opts = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["value", "label", "resolve", "originalValue"]);
  return function createError(_temp) {
    var _ref2 = _temp === void 0 ? {} : _temp,
        _ref2$path = _ref2.path,
        path = _ref2$path === void 0 ? opts.path : _ref2$path,
        _ref2$message = _ref2.message,
        message = _ref2$message === void 0 ? opts.message : _ref2$message,
        _ref2$type = _ref2.type,
        type = _ref2$type === void 0 ? opts.name : _ref2$type,
        params = _ref2.params;

    params = (0, _extends2.default)({
      path: path,
      value: value,
      originalValue: originalValue,
      label: label
    }, resolveParams(opts.params, params, resolve));
    return (0, _extends2.default)(new _ValidationError.default(formatError(message, params), value, path, type), {
      params: params
    });
  };
}

function createValidation(options) {
  var name = options.name,
      message = options.message,
      test = options.test,
      params = options.params;

  function validate(_ref3) {
    var value = _ref3.value,
        path = _ref3.path,
        label = _ref3.label,
        options = _ref3.options,
        originalValue = _ref3.originalValue,
        sync = _ref3.sync,
        rest = (0, _objectWithoutPropertiesLoose2.default)(_ref3, ["value", "path", "label", "options", "originalValue", "sync"]);
    var parent = options.parent;

    var resolve = function resolve(item) {
      return _Reference.default.isRef(item) ? item.getValue({
        value: value,
        parent: parent,
        context: options.context
      }) : item;
    };

    var createError = createErrorFactory({
      message: message,
      path: path,
      value: value,
      originalValue: originalValue,
      params: params,
      label: label,
      resolve: resolve,
      name: name
    });
    var ctx = (0, _extends2.default)({
      path: path,
      parent: parent,
      type: name,
      createError: createError,
      resolve: resolve,
      options: options
    }, rest);
    return runTest(test, ctx, value, sync).then(function (validOrError) {
      if (_ValidationError.default.isError(validOrError)) throw validOrError;else if (!validOrError) throw createError();
    });
  }

  validate.OPTIONS = options;
  return validate;
}

/***/ }),

/***/ "JhHq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getVideoUrl; });
/* unused harmony export getVideoThumbnail */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isVideoUrl; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("iKE+");
/* harmony import */ var core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("rOcY");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_4__);





var youtubeRegEx = new RegExp('https://(?:youtu.be/|www.youtube.com/(?:watch\\?v=|embed/))([a-zA-Z0-9_-]+)');
var youkuRegEx = new RegExp('https?://(?:player.youku.com/embed/|player.youku.com/player.php/sid/)([a-zA-Z0-9]+)');

function getYoutubeVideoUrl(url) {
  var urlId = youtubeRegEx.exec(url);
  return urlId ? "https://www.youtube.com/embed/".concat(urlId[1]) : null;
}

function getYoutubeThumbnail(url) {
  var urlId = youtubeRegEx.exec(url);
  return urlId ? "https://img.youtube.com/vi/".concat(urlId[1], "/sddefault.jpg") : null;
}

function getYoukuVideoUrl(url) {
  var urlId = youkuRegEx.exec(url);
  var clientId = _config__WEBPACK_IMPORTED_MODULE_4___default.a.get('youku.clientId');
  return urlId ? "https://player.youku.com/embed/".concat(urlId[1], "?client_id=").concat(clientId) : null;
}

function getVideoUrl(url) {
  return getYoutubeVideoUrl(url) || getYoukuVideoUrl(url);
}

function getVideoThumbnail(url) {
  return getYoutubeThumbnail(url);
}

function isVideoUrl(url) {
  return youtubeRegEx.test(url) || youkuRegEx.test(url);
}



/***/ }),

/***/ "K/z8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _possibleConstructorReturn; });
/* harmony import */ var _typeof_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4wDe");
/* harmony import */ var _assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("pWxA");


function _possibleConstructorReturn(self, call) {
  if (call && (Object(_typeof_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return Object(_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(self);
}

/***/ }),

/***/ "LdEA":
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "Lo6J":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.default = setLocale;

var _locale = _interopRequireDefault(__webpack_require__("qr7w"));

function setLocale(custom) {
  Object.keys(custom).forEach(function (type) {
    Object.keys(custom[type]).forEach(function (method) {
      _locale.default[type][method] = custom[type][method];
    });
  });
}

module.exports = exports["default"];

/***/ }),

/***/ "MMYH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _createClass; });
/* harmony import */ var _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("DAgO");

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, Object(_toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/***/ }),

/***/ "N7I1":
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;

/***/ }),

/***/ "NdXQ":
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__("kn3Q");

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.cloneWith` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @param {Function} [customizer] The function to customize cloning.
 * @returns {*} Returns the deep cloned value.
 * @see _.cloneWith
 * @example
 *
 * function customizer(value) {
 *   if (_.isElement(value)) {
 *     return value.cloneNode(true);
 *   }
 * }
 *
 * var el = _.cloneDeepWith(document.body, customizer);
 *
 * console.log(el === document.body);
 * // => false
 * console.log(el.nodeName);
 * // => 'BODY'
 * console.log(el.childNodes.length);
 * // => 20
 */
function cloneDeepWith(value, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
}

module.exports = cloneDeepWith;


/***/ }),

/***/ "OhDV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = sortByKeyOrder;

function findIndex(arr, err) {
  var idx = Infinity;
  arr.some(function (key, ii) {
    if (err.path.indexOf(key) !== -1) {
      idx = ii;
      return true;
    }
  });
  return idx;
}

function sortByKeyOrder(fields) {
  var keys = Object.keys(fields);
  return function (a, b) {
    return findIndex(keys, a) - findIndex(keys, b);
  };
}

module.exports = exports["default"];

/***/ }),

/***/ "Ohju":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TemplateString; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("lTEL");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_match__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("WNMA");
/* harmony import */ var core_js_modules_es_string_match__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_match__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("Ysgh");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("kYxP");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_9__);









var __jsx = react__WEBPACK_IMPORTED_MODULE_9___default.a.createElement;

var TEMPLATE_REGEXP = /{\w+}/g;

function escapeCurlyBrackets(string) {
  return (string.match(/\w+/) || [''])[0];
}

function generateTemplateNodes(_ref) {
  var staticClassName = _ref.staticClassName,
      _ref$template = _ref.template,
      template = _ref$template === void 0 ? '' : _ref$template,
      _ref$values = _ref.values,
      values = _ref$values === void 0 ? {} : _ref$values,
      _ref$valuesClassName = _ref.valuesClassName,
      valuesClassName = _ref$valuesClassName === void 0 ? {} : _ref$valuesClassName;
  var templateWithoutVariables = template.split(TEMPLATE_REGEXP) || [];
  var templateVariables = template.match(TEMPLATE_REGEXP) || [];
  return templateWithoutVariables.reduce(function (templateNodes, staticValue, index, array) {
    if (index === array.length - 1) {
      return templateNodes.concat([staticClassName && staticValue ? __jsx("span", {
        className: staticClassName,
        key: staticValue
      }, staticValue) : staticValue]);
    }

    var variableName = escapeCurlyBrackets(templateVariables[index]);
    return templateNodes.concat([staticClassName && staticValue ? __jsx("span", {
      className: staticClassName,
      key: staticValue
    }, staticValue) : staticValue, encapsulateWithClassName(values[variableName], variableName, valuesClassName[variableName])]);
  }, []);
}

function encapsulateWithClassName() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var keyName = arguments.length > 1 ? arguments[1] : undefined;
  var className = arguments.length > 2 ? arguments[2] : undefined;
  var v = value ? value.toString() : '';
  return className && v ? __jsx("span", {
    key: keyName,
    className: className
  }, v) : v;
}

var TemplateString = function TemplateString(_ref2) {
  var className = _ref2.className,
      dataTestId = _ref2.dataTestId,
      staticClassName = _ref2.staticClassName,
      _ref2$template = _ref2.template,
      template = _ref2$template === void 0 ? '' : _ref2$template,
      _ref2$values = _ref2.values,
      values = _ref2$values === void 0 ? {} : _ref2$values,
      valuesClassName = _ref2.valuesClassName;
  return template ? __jsx("span", {
    className: className,
    "data-testid": dataTestId
  }, generateTemplateNodes({
    staticClassName: staticClassName,
    template: template,
    values: values,
    valuesClassName: valuesClassName
  })) : null;
};

/***/ }),

/***/ "RYcy":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("m2YG");

/**
 * Checks if `value` is an integer.
 *
 * **Note:** This method is based on
 * [`Number.isInteger`](https://mdn.io/Number/isInteger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
 * @example
 *
 * _.isInteger(3);
 * // => true
 *
 * _.isInteger(Number.MIN_VALUE);
 * // => false
 *
 * _.isInteger(Infinity);
 * // => false
 *
 * _.isInteger('3');
 * // => false
 */
function isInteger(value) {
  return typeof value == 'number' && value == toInteger(value);
}

module.exports = isInteger;


/***/ }),

/***/ "TZT2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.AmpStateContext = void 0;

var _react = _interopRequireDefault(__webpack_require__("ERkP"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var AmpStateContext = /*#__PURE__*/_react.default.createContext({});

exports.AmpStateContext = AmpStateContext;

if (false) {}

/***/ }),

/***/ "TuHz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ErrorNote; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("C/y5");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;


var ErrorNote = function ErrorNote(_ref) {
  var className = _ref.className,
      errorMessage = _ref.errorMessage,
      _ref$errorNoteId = _ref.errorNoteId,
      errorNoteId = _ref$errorNoteId === void 0 ? 'error-note' : _ref$errorNoteId,
      _ref$isErrored = _ref.isErrored,
      isErrored = _ref$isErrored === void 0 ? false : _ref$isErrored;
  return __jsx("div", {
    "aria-live": "assertive",
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__[/* classnames */ "a"])('text-12 text-red', className),
    id: errorNoteId
  }, isErrored && errorMessage && __jsx("p", {
    className: "pt-5 pb-10"
  }, errorMessage));
};

/***/ }),

/***/ "U7t3":
/***/ (function(module, exports) {

/**
 * Converts `iterator` to an array.
 *
 * @private
 * @param {Object} iterator The iterator to convert.
 * @returns {Array} Returns the converted array.
 */
function iteratorToArray(iterator) {
  var data,
      result = [];

  while (!(data = iterator.next()).done) {
    result.push(data.value);
  }
  return result;
}

module.exports = iteratorToArray;


/***/ }),

/***/ "V5RX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node: true */


function makeArrayFrom(obj) {
  return Array.prototype.slice.apply(obj);
}

var
  PENDING = "pending",
  RESOLVED = "resolved",
  REJECTED = "rejected";

function SynchronousPromise(handler) {
  this.status = PENDING;
  this._continuations = [];
  this._parent = null;
  this._paused = false;
  if (handler) {
    handler.call(
      this,
      this._continueWith.bind(this),
      this._failWith.bind(this)
    );
  }
}

function looksLikeAPromise(obj) {
  return obj && typeof (obj.then) === "function";
}

function passThrough(value) {
  return value;
}

SynchronousPromise.prototype = {
  then: function (nextFn, catchFn) {
    var next = SynchronousPromise.unresolved()._setParent(this);
    if (this._isRejected()) {
      if (this._paused) {
        this._continuations.push({
          promise: next,
          nextFn: nextFn,
          catchFn: catchFn
        });
        return next;
      }
      if (catchFn) {
        try {
          var catchResult = catchFn(this._error);
          if (looksLikeAPromise(catchResult)) {
            this._chainPromiseData(catchResult, next);
            return next;
          } else {
            return SynchronousPromise.resolve(catchResult)._setParent(this);
          }
        } catch (e) {
          return SynchronousPromise.reject(e)._setParent(this);
        }
      }
      return SynchronousPromise.reject(this._error)._setParent(this);
    }
    this._continuations.push({
      promise: next,
      nextFn: nextFn,
      catchFn: catchFn
    });
    this._runResolutions();
    return next;
  },
  catch: function (handler) {
    if (this._isResolved()) {
      return SynchronousPromise.resolve(this._data)._setParent(this);
    }
    var next = SynchronousPromise.unresolved()._setParent(this);
    this._continuations.push({
      promise: next,
      catchFn: handler
    });
    this._runRejections();
    return next;
  },
  finally: function (callback) {
    var ran = false;

    function runFinally(result, err) {
      if (!ran) {
        ran = true;
        if (!callback) {
          callback = passThrough;
        }
        var callbackResult = callback(result);
        if (looksLikeAPromise(callbackResult)) {
          return callbackResult.then(function () {
            if (err) {
              throw err;
            }
            return result;
          });
        } else {
          return result;
        }
      }
    }

    return this
      .then(function (result) {
        return runFinally(result);
      })
      .catch(function (err) {
        return runFinally(null, err);
      });
  },
  pause: function () {
    this._paused = true;
    return this;
  },
  resume: function () {
    var firstPaused = this._findFirstPaused();
    if (firstPaused) {
      firstPaused._paused = false;
      firstPaused._runResolutions();
      firstPaused._runRejections();
    }
    return this;
  },
  _findAncestry: function () {
    return this._continuations.reduce(function (acc, cur) {
      if (cur.promise) {
        var node = {
          promise: cur.promise,
          children: cur.promise._findAncestry()
        };
        acc.push(node);
      }
      return acc;
    }, []);
  },
  _setParent: function (parent) {
    if (this._parent) {
      throw new Error("parent already set");
    }
    this._parent = parent;
    return this;
  },
  _continueWith: function (data) {
    var firstPending = this._findFirstPending();
    if (firstPending) {
      firstPending._data = data;
      firstPending._setResolved();
    }
  },
  _findFirstPending: function () {
    return this._findFirstAncestor(function (test) {
      return test._isPending && test._isPending();
    });
  },
  _findFirstPaused: function () {
    return this._findFirstAncestor(function (test) {
      return test._paused;
    });
  },
  _findFirstAncestor: function (matching) {
    var test = this;
    var result;
    while (test) {
      if (matching(test)) {
        result = test;
      }
      test = test._parent;
    }
    return result;
  },
  _failWith: function (error) {
    var firstRejected = this._findFirstPending();
    if (firstRejected) {
      firstRejected._error = error;
      firstRejected._setRejected();
    }
  },
  _takeContinuations: function () {
    return this._continuations.splice(0, this._continuations.length);
  },
  _runRejections: function () {
    if (this._paused || !this._isRejected()) {
      return;
    }
    var
      error = this._error,
      continuations = this._takeContinuations(),
      self = this;
    continuations.forEach(function (cont) {
      if (cont.catchFn) {
        try {
          var catchResult = cont.catchFn(error);
          self._handleUserFunctionResult(catchResult, cont.promise);
        } catch (e) {
          cont.promise.reject(e);
        }
      } else {
        cont.promise.reject(error);
      }
    });
  },
  _runResolutions: function () {
    if (this._paused || !this._isResolved() || this._isPending()) {
      return;
    }
    var continuations = this._takeContinuations();
    var data = this._data;
    var self = this;
    continuations.forEach(function (cont) {
      if (cont.nextFn) {
        try {
          var result = cont.nextFn(data);
          self._handleUserFunctionResult(result, cont.promise);
        } catch (e) {
          self._handleResolutionError(e, cont);
        }
      } else if (cont.promise) {
        cont.promise.resolve(data);
      }
    });
    if (looksLikeAPromise(this._data)) {
      return this._handleWhenResolvedDataIsPromise(this._data);
    }
  },
  _handleResolutionError: function (e, continuation) {
    this._setRejected();
    if (continuation.catchFn) {
      try {
        continuation.catchFn(e);
        return;
      } catch (e2) {
        e = e2;
      }
    }
    if (continuation.promise) {
      continuation.promise.reject(e);
    }
  },
  _handleWhenResolvedDataIsPromise: function (data) {
    var self = this;
    return data.then(function (result) {
      self._data = result;
      self._runResolutions();
    }).catch(function (error) {
      self._error = error;
      self._setRejected();
      self._runRejections();
    });
  },
  _handleUserFunctionResult: function (data, nextSynchronousPromise) {
    if (looksLikeAPromise(data)) {
      this._chainPromiseData(data, nextSynchronousPromise);
    } else {
      nextSynchronousPromise.resolve(data);
    }
  },
  _chainPromiseData: function (promiseData, nextSynchronousPromise) {
    promiseData.then(function (newData) {
      nextSynchronousPromise.resolve(newData);
    }).catch(function (newError) {
      nextSynchronousPromise.reject(newError);
    });
  },
  _setResolved: function () {
    this.status = RESOLVED;
    if (!this._paused) {
      this._runResolutions();
    }
  },
  _setRejected: function () {
    this.status = REJECTED;
    if (!this._paused) {
      this._runRejections();
    }
  },
  _isPending: function () {
    return this.status === PENDING;
  },
  _isResolved: function () {
    return this.status === RESOLVED;
  },
  _isRejected: function () {
    return this.status === REJECTED;
  }
};

SynchronousPromise.resolve = function (result) {
  return new SynchronousPromise(function (resolve, reject) {
    if (looksLikeAPromise(result)) {
      result.then(function (newResult) {
        resolve(newResult);
      }).catch(function (error) {
        reject(error);
      });
    } else {
      resolve(result);
    }
  });
};

SynchronousPromise.reject = function (result) {
  return new SynchronousPromise(function (resolve, reject) {
    reject(result);
  });
};

SynchronousPromise.unresolved = function () {
  return new SynchronousPromise(function (resolve, reject) {
    this.resolve = resolve;
    this.reject = reject;
  });
};

SynchronousPromise.all = function () {
  var args = makeArrayFrom(arguments);
  if (Array.isArray(args[0])) {
    args = args[0];
  }
  if (!args.length) {
    return SynchronousPromise.resolve([]);
  }
  return new SynchronousPromise(function (resolve, reject) {
    var
      allData = [],
      numResolved = 0,
      doResolve = function () {
        if (numResolved === args.length) {
          resolve(allData);
        }
      },
      rejected = false,
      doReject = function (err) {
        if (rejected) {
          return;
        }
        rejected = true;
        reject(err);
      };
    args.forEach(function (arg, idx) {
      SynchronousPromise.resolve(arg).then(function (thisResult) {
        allData[idx] = thisResult;
        numResolved += 1;
        doResolve();
      }).catch(function (err) {
        doReject(err);
      });
    });
  });
};

function createAggregateErrorFrom(errors) {
  /* jshint ignore:start */
  if (typeof window !== "undefined" && "AggregateError" in window) {
    return new window.AggregateError(errors);
  }
  /* jshint ignore:end */

  return { errors: errors };
}

SynchronousPromise.any = function () {
  var args = makeArrayFrom(arguments);
  if (Array.isArray(args[0])) {
    args = args[0];
  }
  if (!args.length) {
    return SynchronousPromise.reject(createAggregateErrorFrom([]));
  }
  return new SynchronousPromise(function (resolve, reject) {
    var
      allErrors = [],
      numRejected = 0,
      doReject = function () {
        if (numRejected === args.length) {
          reject(createAggregateErrorFrom(allErrors));
        }
      },
      resolved = false,
      doResolve = function (result) {
        if (resolved) {
          return;
        }
        resolved = true;
        resolve(result);
      };
    args.forEach(function (arg, idx) {
      SynchronousPromise.resolve(arg).then(function (thisResult) {
        doResolve(thisResult);
      }).catch(function (err) {
        allErrors[idx] = err;
        numRejected += 1;
        doReject();
      });
    });
  });
};

SynchronousPromise.allSettled = function () {
  var args = makeArrayFrom(arguments);
  if (Array.isArray(args[0])) {
    args = args[0];
  }
  if (!args.length) {
    return SynchronousPromise.resolve([]);
  }
  return new SynchronousPromise(function (resolve) {
    var
      allData = [],
      numSettled = 0,
      doSettled = function () {
        numSettled += 1;
        if (numSettled === args.length) {
          resolve(allData);
        }
      };
    args.forEach(function (arg, idx) {
      SynchronousPromise.resolve(arg).then(function (thisResult) {
        allData[idx] = {
          status: "fulfilled",
          value: thisResult
        };
        doSettled();
      }).catch(function (err) {
        allData[idx] = {
          status: "rejected",
          reason: err
        };
        doSettled();
      });
    });
  });
};

/* jshint ignore:start */
if (Promise === SynchronousPromise) {
  throw new Error("Please use SynchronousPromise.installGlobally() to install globally");
}
var RealPromise = Promise;
SynchronousPromise.installGlobally = function (__awaiter) {
  if (Promise === SynchronousPromise) {
    return __awaiter;
  }
  var result = patchAwaiterIfRequired(__awaiter);
  Promise = SynchronousPromise;
  return result;
};

SynchronousPromise.uninstallGlobally = function () {
  if (Promise === SynchronousPromise) {
    Promise = RealPromise;
  }
};

function patchAwaiterIfRequired(__awaiter) {
  if (typeof (__awaiter) === "undefined" || __awaiter.__patched) {
    return __awaiter;
  }
  var originalAwaiter = __awaiter;
  __awaiter = function () {
    var Promise = RealPromise;
    originalAwaiter.apply(this, makeArrayFrom(arguments));
  };
  __awaiter.__patched = true;
  return __awaiter;
}

/* jshint ignore:end */

module.exports = {
  SynchronousPromise: SynchronousPromise
};


/***/ }),

/***/ "VBBE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TextSeeMore; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _see_more_SeeMore__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("NPTU");
/* harmony import */ var _text_Text__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("qqKu");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;



var TextSeeMore = function TextSeeMore(_ref) {
  var className = _ref.className,
      _ref$dataTestIdPrefix = _ref.dataTestIdPrefix,
      dataTestIdPrefix = _ref$dataTestIdPrefix === void 0 ? 'TextSeeMore' : _ref$dataTestIdPrefix,
      hasNoScrollOnCollapse = _ref.hasNoScrollOnCollapse,
      isCollapseEnabled = _ref.isCollapseEnabled,
      offsetScrollSelector = _ref.offsetScrollSelector,
      onClick = _ref.onClick,
      seeMoreColor = _ref.seeMoreColor,
      seeLessLabel = _ref.seeLessLabel,
      seeMoreLabel = _ref.seeMoreLabel,
      seeMoreSize = _ref.seeMoreSize,
      textProps = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["className", "dataTestIdPrefix", "hasNoScrollOnCollapse", "isCollapseEnabled", "offsetScrollSelector", "onClick", "seeMoreColor", "seeLessLabel", "seeMoreLabel", "seeMoreSize"]);

  return __jsx(_see_more_SeeMore__WEBPACK_IMPORTED_MODULE_3__[/* SeeMore */ "a"], {
    className: className,
    color: seeMoreColor,
    hasNoScrollOnCollapse: hasNoScrollOnCollapse,
    isCollapseEnabled: isCollapseEnabled,
    offsetScrollSelector: offsetScrollSelector,
    onClick: onClick,
    seeLessLabel: seeLessLabel,
    seeMoreLabel: seeMoreLabel,
    seeMoreSize: seeMoreSize
  }, __jsx(_text_Text__WEBPACK_IMPORTED_MODULE_4__[/* Text */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, textProps, {
    "data-testid": "".concat(dataTestIdPrefix, "-text")
  })));
};

/***/ }),

/***/ "VNI2":
/***/ (function(module, exports) {


/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */

module.exports = function(edges) {
  return toposort(uniqueNodes(edges), edges)
}

module.exports.array = toposort

function toposort(nodes, edges) {
  var cursor = nodes.length
    , sorted = new Array(cursor)
    , visited = {}
    , i = cursor
    // Better data structures make algorithm much faster.
    , outgoingEdges = makeOutgoingEdges(edges)
    , nodesHash = makeNodesHash(nodes)

  // check for unknown nodes
  edges.forEach(function(edge) {
    if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) {
      throw new Error('Unknown node. There is an unknown node in the supplied edges.')
    }
  })

  while (i--) {
    if (!visited[i]) visit(nodes[i], i, new Set())
  }

  return sorted

  function visit(node, i, predecessors) {
    if(predecessors.has(node)) {
      var nodeRep
      try {
        nodeRep = ", node was:" + JSON.stringify(node)
      } catch(e) {
        nodeRep = ""
      }
      throw new Error('Cyclic dependency' + nodeRep)
    }

    if (!nodesHash.has(node)) {
      throw new Error('Found unknown node. Make sure to provided all involved nodes. Unknown node: '+JSON.stringify(node))
    }

    if (visited[i]) return;
    visited[i] = true

    var outgoing = outgoingEdges.get(node) || new Set()
    outgoing = Array.from(outgoing)

    if (i = outgoing.length) {
      predecessors.add(node)
      do {
        var child = outgoing[--i]
        visit(child, nodesHash.get(child), predecessors)
      } while (i)
      predecessors.delete(node)
    }

    sorted[--cursor] = node
  }
}

function uniqueNodes(arr){
  var res = new Set()
  for (var i = 0, len = arr.length; i < len; i++) {
    var edge = arr[i]
    res.add(edge[0])
    res.add(edge[1])
  }
  return Array.from(res)
}

function makeOutgoingEdges(arr){
  var edges = new Map()
  for (var i = 0, len = arr.length; i < len; i++) {
    var edge = arr[i]
    if (!edges.has(edge[0])) edges.set(edge[0], new Set())
    if (!edges.has(edge[1])) edges.set(edge[1], new Set())
    edges.get(edge[0]).add(edge[1])
  }
  return edges
}

function makeNodesHash(arr){
  var res = new Map()
  for (var i = 0, len = arr.length; i < len; i++) {
    res.set(arr[i], i)
  }
  return res
}


/***/ }),

/***/ "Vk6K":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("Syyo"),
    copyArray = __webpack_require__("QT01"),
    getTag = __webpack_require__("kkM+"),
    isArrayLike = __webpack_require__("9y2L"),
    isString = __webpack_require__("nDih"),
    iteratorToArray = __webpack_require__("U7t3"),
    mapToArray = __webpack_require__("aURW"),
    setToArray = __webpack_require__("XlL0"),
    stringToArray = __webpack_require__("f2p0"),
    values = __webpack_require__("0iyY");

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Built-in value references. */
var symIterator = Symbol ? Symbol.iterator : undefined;

/**
 * Converts `value` to an array.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Array} Returns the converted array.
 * @example
 *
 * _.toArray({ 'a': 1, 'b': 2 });
 * // => [1, 2]
 *
 * _.toArray('abc');
 * // => ['a', 'b', 'c']
 *
 * _.toArray(1);
 * // => []
 *
 * _.toArray(null);
 * // => []
 */
function toArray(value) {
  if (!value) {
    return [];
  }
  if (isArrayLike(value)) {
    return isString(value) ? stringToArray(value) : copyArray(value);
  }
  if (symIterator && value[symIterator]) {
    return iteratorToArray(value[symIterator]());
  }
  var tag = getTag(value),
      func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

  return func(value);
}

module.exports = toArray;


/***/ }),

/***/ "ZPhW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/routes/constants.js
var constants = __webpack_require__("dNxv");

// EXTERNAL MODULE: ./src/client/store/user-info/userInfo.selectors.js
var userInfo_selectors = __webpack_require__("apzf");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var tracking_constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/utils/graphql-client/use-gql/useGQL.js
var useGQL = __webpack_require__("0JpG");

// EXTERNAL MODULE: ./src/utils/ple-utils/handleInvalidToken.js
var handleInvalidToken = __webpack_require__("bJ4E");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner-handler/SpinnerHandler.jsx
var SpinnerHandler = __webpack_require__("2Kkq");

// CONCATENATED MODULE: ./src/client/views/great-members/GreatMembersView.queries.js
var getLoyaltyQuery = function getLoyaltyQuery() {
  return "query\n{\n  profile {\n    loyaltyProgram {\n      isPlatinumForLife\n      points\n      status\n    }\n  }\n}";
};
var getLoyaltyProgramQuery = function getLoyaltyProgramQuery() {
  return "\n  query {\n    loyaltyProgram {\n      status\n      threshold\n    }\n    loyaltyProgramSimulation {\n      currency\n    }\n  }";
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("7xRU");

// EXTERNAL MODULE: /opt/webapp/node_modules/next/head.js
var head = __webpack_require__("vpUC");
var head_default = /*#__PURE__*/__webpack_require__.n(head);

// EXTERNAL MODULE: /opt/webapp/node_modules/next/router.js
var router = __webpack_require__("Bkb1");

// EXTERNAL MODULE: /opt/webapp/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: ./src/client/components/utils/scroll/scrollToElement.js + 1 modules
var scrollToElement = __webpack_require__("RUiN");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/tracking/track-page/TrackPage.jsx
var TrackPage = __webpack_require__("tZiC");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// EXTERNAL MODULE: ./src/client/components/widgets/event-animation/EventAnimation.jsx + 3 modules
var EventAnimation = __webpack_require__("PwF2");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: ./src/client/components/frameworks/card/Card.jsx + 11 modules
var Card = __webpack_require__("786X");

// EXTERNAL MODULE: ./src/client/components/frameworks/card/Card.constants.js
var Card_constants = __webpack_require__("syQ6");

// CONCATENATED MODULE: ./src/client/components/widgets/great-members-exclusivity/GreatMembersExclusivity.jsx

var __jsx = react_default.a.createElement;





var GreatMembersExclusivity_GreatMembersExclusivity = function GreatMembersExclusivity() {
  var steps = Object(i18n["e" /* getListValue */])('customerAccount.greatMember.stepsSection.steps');
  var stepsEnabled = Object(i18n["d" /* getKeyValue */])('customerAccount.greatMember.stepsSection.stepsEnabled');
  var articleEnabled = Object(i18n["d" /* getKeyValue */])('customerAccount.greatMember.stepsSection.article.enabled');
  return __jsx(react["Fragment"], null, articleEnabled && stepsEnabled && __jsx(Title["a" /* Title */], {
    className: "mb-40",
    hLevel: 2,
    theme: "title-brand-n0"
  }, Object(i18n["h" /* t */])('customerAccount.greatMember.stepsSection.title')), stepsEnabled && __jsx("ul", {
    className: "mb-80 grid grid-cols-2 sm:mb-120 sm:grid-cols-3 sm:divide-x"
  }, (steps || []).map(function (item, i) {
    return __jsx("li", {
      className: "flex flex-col items-center gap-20 p-20 text-center text-16 font-semibold text-black",
      key: item
    }, __jsx("span", {
      className: "flex aspect-square size-48 items-center justify-center rounded-full bg-black font-bold leading-1 text-white"
    }, i + 1), item);
  })), articleEnabled && __jsx(Card["a" /* Card */], {
    heading: {
      hLevel: 3,
      title: Object(i18n["h" /* t */])('customerAccount.greatMember.stepsSection.article.title')
    },
    layout: Card_constants["e" /* INLINE_2 */],
    media: {
      url: Object(i18n["h" /* t */])('customerAccount.greatMember.stepsSection.article.imageUrl')
    },
    text: {
      text: Object(i18n["h" /* t */])('customerAccount.greatMember.stepsSection.article.text')
    }
  }));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.values.js
var es_object_values = __webpack_require__("1IsZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: ./src/client/components/utils/customer-account/ca.constants.js
var ca_constants = __webpack_require__("oJuH");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find-index.js
var es_array_find_index = __webpack_require__("vfdX");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/upperFirst.js
var upperFirst = __webpack_require__("TYRa");
var upperFirst_default = /*#__PURE__*/__webpack_require__.n(upperFirst);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/frameworks/progress-bar/ProgressBar.jsx + 1 modules
var ProgressBar = __webpack_require__("woxT");

// EXTERNAL MODULE: ./src/client/components/frameworks/template-string/TemplateString.jsx
var TemplateString = __webpack_require__("Ohju");

// EXTERNAL MODULE: ./src/client/components/widgets/great-members-icon/GreatMembersIcon.jsx
var GreatMembersIcon = __webpack_require__("A6++");

// CONCATENATED MODULE: ./src/client/components/widgets/great-member-status/GreatMemberStatus.jsx


var GreatMemberStatus_jsx = react_default.a.createElement;






var GreatMemberStatus_GreatMemberStatus = function GreatMemberStatus(_ref) {
  var className = _ref.className,
      loyaltyProgram = _ref.loyaltyProgram,
      profile = _ref.profile;

  if (!profile) {
    return null;
  }

  var isPlatinumForLife = profile.isPlatinumForLife;
  var currentProgramIndex = loyaltyProgram.findIndex(function (_ref2) {
    var status = _ref2.status;
    return status === profile.status;
  });
  var currentProgram = loyaltyProgram[currentProgramIndex];
  var nextProgram = loyaltyProgram[currentProgramIndex + 1] || loyaltyProgram[loyaltyProgram.length - 1];

  if (!currentProgram) {
    return null;
  }

  var showProgressBar = !isPlatinumForLife && nextProgram.status !== currentProgram.status;
  return GreatMemberStatus_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('flex-wrap overflow-hidden rounded-12 bg-white shadow sm:flex', className)
  }, GreatMemberStatus_jsx("div", {
    className: "flex w-full flex-col items-center justify-center bg-lightSand p-20 text-black md:py-40"
  }, GreatMemberStatus_jsx(GreatMembersIcon["a" /* GreatMembersIcon */], {
    className: "text-black",
    status: profile.status,
    width: "20rem"
  }), isPlatinumForLife ? GreatMemberStatus_jsx("p", {
    className: "mt-15 font-brand text-18"
  }, Object(i18n["h" /* t */])('customerAccount.greatMember.platinumForLife')) : GreatMemberStatus_jsx("p", {
    className: "mt-15 font-brand text-18"
  }, Object(i18n["h" /* t */])('customerAccount.profile.GMPointsLabel', {
    currentPoints: profile.points
  }))), showProgressBar && GreatMemberStatus_jsx("div", {
    className: "w-full p-20"
  }, GreatMemberStatus_jsx("p", {
    className: "flex justify-between font-brand text-14 sm:text-16"
  }, GreatMemberStatus_jsx("span", {
    className: "text-gm-".concat(currentProgram.status)
  }, upperFirst_default()(currentProgram.status)), ' ', GreatMemberStatus_jsx("span", {
    className: "text-gm-".concat(nextProgram.status)
  }, upperFirst_default()(nextProgram.status))), GreatMemberStatus_jsx(ProgressBar["a" /* ProgressBar */], {
    color: "gm-".concat(profile.status),
    max: nextProgram.threshold,
    theme: "rounded",
    value: profile.points
  }), GreatMemberStatus_jsx("p", {
    className: "mt-10 text-center text-12 sm:text-14"
  }, GreatMemberStatus_jsx(TemplateString["a" /* TemplateString */], {
    template: Object(i18n["h" /* t */])('customerAccount.greatMember.introduction.userStatus.missingPointsLabel'),
    values: {
      missingPoints: nextProgram.threshold - profile.points,
      nextStatus: nextProgram.status
    },
    valuesClassName: {
      missingPoints: 'font-brand text-16 sm:text-18'
    }
  }))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/great-members-introduction/GreatMembersIntroduction.jsx



var GreatMembersIntroduction_jsx = react_default.a.createElement;






var GreatMembersIntroduction_GreatMembersIntroduction = function GreatMembersIntroduction(_ref) {
  var loyaltyProgram = _ref.loyaltyProgram,
      profile = _ref.profile;
  var userStatus = (profile === null || profile === void 0 ? void 0 : profile.status) || '';
  var hasStatus = Object.values(ca_constants["a" /* GMStatuses */]).includes(userStatus);

  if (!hasStatus) {
    return null;
  }

  return GreatMembersIntroduction_jsx("div", {
    className: "grid grid-cols-1 gap-20 md:grid-cols-2"
  }, GreatMembersIntroduction_jsx("div", null, GreatMembersIntroduction_jsx(Title["a" /* Title */], {
    className: "mb-10 text-".concat(userStatus),
    theme: "title-brand-n2"
  }, Object(i18n["h" /* t */])("customerAccount.greatMember.introduction.".concat(userStatus, ".title"))), GreatMembersIntroduction_jsx(Text["a" /* Text */], {
    text: Object(i18n["h" /* t */])("customerAccount.greatMember.introduction.".concat(userStatus, ".text")),
    theme: "text-sans-n3"
  })), GreatMembersIntroduction_jsx(GreatMemberStatus_GreatMemberStatus, {
    loyaltyProgram: loyaltyProgram,
    profile: profile
  }));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__("hCOa");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__("87if");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("3yYM");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("QsI/");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("VtSi");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: /opt/webapp/node_modules/accounting/accounting.js
var accounting = __webpack_require__("fCLy");
var accounting_default = /*#__PURE__*/__webpack_require__.n(accounting);

// EXTERNAL MODULE: /opt/webapp/node_modules/formik/dist/formik.esm.js + 78 modules
var formik_esm = __webpack_require__("ljKo");

// EXTERNAL MODULE: ./logger/index.js
var logger = __webpack_require__("m0zD");
var logger_default = /*#__PURE__*/__webpack_require__.n(logger);

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTrackEvent.js
var useTrackEvent = __webpack_require__("DqI1");

// EXTERNAL MODULE: ./src/utils/currency-config-for-locale/currencyConfigForLocale.js
var currencyConfigForLocale = __webpack_require__("wz9x");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/formik/FormikInput.jsx + 14 modules
var FormikInput = __webpack_require__("/HC4");

// EXTERNAL MODULE: ./src/client/components/frameworks/formik/formik-input/Legend.jsx
var Legend = __webpack_require__("hUUf");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// CONCATENATED MODULE: ./src/client/components/widgets/great-members-points-simulator/form/GreatMembersPointsSimulatorForm.utils.js



var GreatMembersPointsSimulatorForm_utils_getPointsFromAmount = function getPointsFromAmount(_ref) {
  var amount = _ref.amount,
      appContext = _ref.appContext,
      duration = _ref.duration;
  var query = "\n      query {\n        loyaltyProgramSimulation {\n          points(spentAmount: ".concat(amount, ", durationInNights: ").concat(duration, ")\n        }\n      }\n    ");
  return graphqlClient["a" /* default */].runNoCacheQuery(query, appContext, {
    requestName: requestDictionary["G" /* CUSTOMER_ACCOUNT_GM_GET_POINTS */]
  });
};
// EXTERNAL MODULE: /opt/webapp/node_modules/yup/lib/index.js
var lib = __webpack_require__("luEP");

// CONCATENATED MODULE: ./src/client/components/widgets/great-members-points-simulator/form/GreatMembersPointsSimulatorForm.validationSchema.js


var GreatMembersPointsSimulatorForm_validationSchema_getValidationSchema = function getValidationSchema() {
  return lib["object"]().shape({
    amount: lib["number"]().positive().integer().min(1).required(Object(i18n["h" /* t */])('common.form.errors.requiredField')),
    duration: lib["string"]().required(Object(i18n["h" /* t */])('common.form.errors.requiredField'))
  });
};
// CONCATENATED MODULE: ./src/client/components/widgets/great-members-points-simulator/form/GreatMembersPointsSimulatorForm.jsx


var GreatMembersPointsSimulatorForm_jsx = react_default.a.createElement;















var GreatMembersPointsSimulatorForm_GreatMembersPointsSimulatorForm = function GreatMembersPointsSimulatorForm(_ref) {
  var currencyCode = _ref.currencyCode,
      onSubmit = _ref.onSubmit;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  var _getCurrency = Object(currencyConfigForLocale["c" /* getCurrency */])(appContext.locale, currencyCode),
      decimal = _getCurrency.decimal,
      symbol = _getCurrency.symbol,
      thousand = _getCurrency.thousand;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var onSubmitForm = /*#__PURE__*/function () {
    var _ref3 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(_ref2) {
      var amount, duration, _data$loyaltyProgramS, data, _points, formattedPoints;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              amount = _ref2.amount, duration = _ref2.duration;
              _context.prev = 1;
              _context.next = 4;
              return GreatMembersPointsSimulatorForm_utils_getPointsFromAmount({
                amount: amount,
                appContext: appContext,
                duration: duration
              });

            case 4:
              data = _context.sent;
              _points = (data === null || data === void 0 ? void 0 : (_data$loyaltyProgramS = data.loyaltyProgramSimulation) === null || _data$loyaltyProgramS === void 0 ? void 0 : _data$loyaltyProgramS.points) || 0;
              formattedPoints = accounting_default.a.formatNumber(_points, {
                decimal: decimal,
                thousand: thousand
              });
              trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_CA_GM, {
                detail_click: 'see_results'
              });
              onSubmit(formattedPoints);
              _context.next = 14;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](1);
              logger_default.a.error(_context.t0);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 11]]);
    }));

    return function onSubmitForm(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  return GreatMembersPointsSimulatorForm_jsx(formik_esm["d" /* Formik */], {
    initialValues: {
      amount: 0,
      duration: '7'
    },
    onSubmit: onSubmitForm,
    validationSchema: GreatMembersPointsSimulatorForm_validationSchema_getValidationSchema()
  }, GreatMembersPointsSimulatorForm_jsx(formik_esm["c" /* Form */], {
    className: "flex flex-col"
  }, GreatMembersPointsSimulatorForm_jsx("div", {
    className: "flex flex-col gap-20 lg:flex-row"
  }, GreatMembersPointsSimulatorForm_jsx("div", {
    className: "lg:min-w-340"
  }, GreatMembersPointsSimulatorForm_jsx(FormikInput["a" /* FormikInput */], {
    hideErrorMessage: true,
    label: Object(i18n["h" /* t */])('customerAccount.greatMember.pointsSection.simulator.totalCostLabel'),
    labelAdditionalInfo: "(".concat(symbol, ")"),
    placeholder: "800",
    name: "amount",
    type: "number"
  })), GreatMembersPointsSimulatorForm_jsx("fieldset", {
    className: "flex flex-1 flex-col justify-start gap-x-10 lg:flex-row"
  }, GreatMembersPointsSimulatorForm_jsx(Legend["a" /* Legend */], {
    className: "mb-5 w-full flex-none",
    label: Object(i18n["h" /* t */])('common.durationLabel')
  }), GreatMembersPointsSimulatorForm_jsx(FormikInput["a" /* FormikInput */], {
    hideErrorMessage: true,
    label: Object(i18n["h" /* t */])('customerAccount.greatMember.pointsSection.simulator.oneNightLabel'),
    name: "duration",
    type: "radio",
    value: "1"
  }), GreatMembersPointsSimulatorForm_jsx(FormikInput["a" /* FormikInput */], {
    hideErrorMessage: true,
    label: Object(i18n["h" /* t */])('customerAccount.greatMember.pointsSection.simulator.up7NightsLabel'),
    name: "duration",
    type: "radio",
    value: "7"
  }), GreatMembersPointsSimulatorForm_jsx(FormikInput["a" /* FormikInput */], {
    hideErrorMessage: true,
    label: Object(i18n["h" /* t */])('customerAccount.greatMember.pointsSection.simulator.more7NightsLabel'),
    name: "duration",
    type: "radio",
    value: "8"
  }))), GreatMembersPointsSimulatorForm_jsx(Button["a" /* Button */], {
    className: "self-center md:self-end",
    type: "submit"
  }, Object(i18n["h" /* t */])('common.seeResult'))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/great-members-points-simulator/result/GreatMembersPointsSimulatorResult.jsx
var GreatMembersPointsSimulatorResult_jsx = react_default.a.createElement;






var GreatMembersPointsSimulatorResult_GreatMembersPointsSimulatorResult = function GreatMembersPointsSimulatorResult(_ref) {
  var onRecalculate = _ref.onRecalculate,
      total = _ref.total;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  return GreatMembersPointsSimulatorResult_jsx("div", {
    className: "sm:flex"
  }, GreatMembersPointsSimulatorResult_jsx("div", {
    className: "mb-20 flex flex-1 flex-col items-center justify-between text-center sm:mb-0 sm:items-start"
  }, GreatMembersPointsSimulatorResult_jsx("p", {
    className: "font-brand text-18 text-black sm:text-24"
  }, Object(i18n["h" /* t */])('customerAccount.greatMember.pointsSection.simulator.totalPointsLabel'), ' ', GreatMembersPointsSimulatorResult_jsx("span", {
    className: "block text-24 text-sienna sm:ms-20 sm:inline sm:text-32"
  }, Object(i18n["h" /* t */])('common.currentPoints', {
    currentPoints: total
  }))), GreatMembersPointsSimulatorResult_jsx("p", {
    className: "mt-10 text-10"
  }, Object(i18n["h" /* t */])('customerAccount.greatMember.pointsSection.simulator.totalPointsNotesLabel'))), GreatMembersPointsSimulatorResult_jsx("div", {
    className: "flex flex-col items-center justify-between"
  }, GreatMembersPointsSimulatorResult_jsx(Button["a" /* Button */], {
    url: constants["y" /* SEARCH_PAGE_URL */]
  }, Object(i18n["h" /* t */])('common.searchStay')), GreatMembersPointsSimulatorResult_jsx(Button["a" /* Button */], {
    onClick: function onClick() {
      onRecalculate();
      trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_CA_GM, {
        detail_click: 'replay_point_simulator'
      });
    },
    theme: "link"
  }, Object(i18n["h" /* t */])('common.recalculate'))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/great-members-points-simulator/GreatMembersPointsSimulator.jsx
var GreatMembersPointsSimulator_jsx = react_default.a.createElement;






var GreatMembersPointsSimulator_GreatMembersPointsSimulator = function GreatMembersPointsSimulator(_ref) {
  var className = _ref.className,
      currencyCode = _ref.currencyCode,
      id = _ref.id;

  var _useState = Object(react["useState"])(null),
      total = _useState[0],
      setTotal = _useState[1];

  return GreatMembersPointsSimulator_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('relative overflow-hidden rounded-12 bg-white shadow sm:flex', className),
    id: id
  }, GreatMembersPointsSimulator_jsx("div", {
    className: "flex items-center justify-center bg-lightSand p-20"
  }, GreatMembersPointsSimulator_jsx(Icon["a" /* Icon */], {
    className: "text-black",
    isNotMonoChrome: true,
    isNotSquare: true,
    name: icons["a" /* ICONS */].CLUBMED_GREAT_MEMBERS_INTRO,
    width: "12.5rem"
  })), GreatMembersPointsSimulator_jsx("div", {
    className: "flex-1 p-20"
  }, !total ? GreatMembersPointsSimulator_jsx(GreatMembersPointsSimulatorForm_GreatMembersPointsSimulatorForm, {
    currencyCode: currencyCode,
    onSubmit: function onSubmit(points) {
      return setTotal(points);
    }
  }) : GreatMembersPointsSimulator_jsx(GreatMembersPointsSimulatorResult_GreatMembersPointsSimulatorResult, {
    onRecalculate: function onRecalculate() {
      return setTotal(null);
    },
    total: total
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/great-members-simulator/GreatMembersSimulator.jsx
var GreatMembersSimulator_jsx = react_default.a.createElement;




var GreatMembersSimulator_GreatMembersSimulator = function GreatMembersSimulator(_ref) {
  var className = _ref.className,
      loyaltyProgramSimulation = _ref.loyaltyProgramSimulation;
  var loyaltyProgramCurrency = loyaltyProgramSimulation.currency;
  return GreatMembersSimulator_jsx("div", {
    className: className
  }, GreatMembersSimulator_jsx(Title["a" /* Title */], {
    hLevel: 2,
    theme: "title-brand-n2"
  }, Object(i18n["h" /* t */])('customerAccount.greatMember.pointsSection.simulator.title')), GreatMembersSimulator_jsx(Title["a" /* Title */], {
    className: "text-sienna",
    hLevel: 3,
    theme: "title-sans-n2"
  }, Object(i18n["h" /* t */])('customerAccount.greatMember.pointsSection.simulator.subtitle')), GreatMembersSimulator_jsx(GreatMembersPointsSimulator_GreatMembersPointsSimulator, {
    className: "mt-20",
    currencyCode: loyaltyProgramCurrency,
    id: "simulator"
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/great-members-points-section/GreatMembersPointsSection.jsx




var GreatMembersPointsSection_jsx = react_default.a.createElement;






var GreatMembersPointsSection_GreatMembersPointsSection = function GreatMembersPointsSection(_ref) {
  var loyaltyProgramSimulation = _ref.loyaltyProgramSimulation;
  var pushs = Array.from({
    length: 6
  }, function (_, i) {
    return Object(i18n["f" /* has */])("customerAccount.greatMember.pointsSection.pushs.".concat(i, ".label")) ? {
      icon: Object(i18n["h" /* t */])("customerAccount.greatMember.pointsSection.pushs.".concat(i, ".icon")),
      label: Object(i18n["h" /* t */])("customerAccount.greatMember.pointsSection.pushs.".concat(i, ".label")),
      subLabel: Object(i18n["h" /* t */])("customerAccount.greatMember.pointsSection.pushs.".concat(i, ".subLabel"))
    } : null;
  }).filter(Boolean);
  var articleEnabled = Object(i18n["d" /* getKeyValue */])('customerAccount.greatMember.pointsSection.article.enabled');
  var pushsEnabled = Object(i18n["d" /* getKeyValue */])('customerAccount.greatMember.pointsSection.pushsEnabled');
  var simulatorEnabled = Object(i18n["d" /* getKeyValue */])('customerAccount.greatMember.pointsSection.simulator.enabled');
  return GreatMembersPointsSection_jsx(react["Fragment"], null, articleEnabled && pushsEnabled && simulatorEnabled && GreatMembersPointsSection_jsx(Title["a" /* Title */], {
    className: "mb-40",
    hLevel: 2,
    theme: "title-brand-n0"
  }, Object(i18n["h" /* t */])('customerAccount.greatMember.pointsSection.title')), GreatMembersPointsSection_jsx("div", {
    className: "space-y-60"
  }, pushsEnabled && Boolean(pushs.length) && GreatMembersPointsSection_jsx("ul", {
    className: "grid grid-cols-2 gap-y-40 sm:grid-cols-3"
  }, pushs.map(function (push) {
    return GreatMembersPointsSection_jsx("li", {
      className: "flex flex-col items-center justify-center p-20 text-center odd:max-sm:border-r-1 sm:[&:nth-child(3n+2)]:border-x-1",
      key: push.label
    }, GreatMembersPointsSection_jsx(Icon["a" /* Icon */], {
      className: "mb-20",
      name: push.icon,
      width: "60px"
    }), GreatMembersPointsSection_jsx("p", {
      className: "text-16 font-semibold"
    }, push.label), GreatMembersPointsSection_jsx("p", {
      className: "text-14"
    }, push.subLabel));
  })), articleEnabled && GreatMembersPointsSection_jsx(Card["a" /* Card */], {
    heading: {
      hLevel: 3,
      title: Object(i18n["h" /* t */])('customerAccount.greatMember.pointsSection.article.title')
    },
    media: {
      url: Object(i18n["h" /* t */])('customerAccount.greatMember.pointsSection.article.imageUrl')
    },
    text: {
      text: Object(i18n["h" /* t */])('customerAccount.greatMember.pointsSection.article.text')
    }
  }), simulatorEnabled && GreatMembersPointsSection_jsx(GreatMembersSimulator_GreatMembersSimulator, {
    loyaltyProgramSimulation: loyaltyProgramSimulation
  })));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__("vrRf");

// EXTERNAL MODULE: ./src/client/components/frameworks/responsive-tabs/ResponsiveTabs.jsx + 1 modules
var ResponsiveTabs = __webpack_require__("QPCF");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("jQ/y");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: ./src/client/components/frameworks/text-link/TextLink.jsx + 1 modules
var TextLink = __webpack_require__("jD8k");

// CONCATENATED MODULE: ./src/client/components/widgets/great-members-accordion/GreatMembersAccordionContent.jsx






var GreatMembersAccordionContent_jsx = react_default.a.createElement;







var GreatMembersAccordionContent_GreatMembersAccordionContent = function GreatMembersAccordionContent(_ref) {
  var status = _ref.status;
  var links = ['downloadAdvantages', 'seeConditions'];

  var bulletPoints = Object(toConsumableArray["a" /* default */])(new Array(10)).map(function (_, i) {
    return Object(i18n["f" /* has */])("customerAccount.greatMember.stasusesSection.tabs.".concat(status, ".bulletPoints.").concat(i, ".title")) ? {
      description: Object(i18n["h" /* t */])("customerAccount.greatMember.stasusesSection.tabs.".concat(status, ".bulletPoints.").concat(i, ".description")),
      linkLabel: Object(i18n["h" /* t */])("customerAccount.greatMember.stasusesSection.tabs.".concat(status, ".bulletPoints.").concat(i, ".link.label")),
      linkUrl: Object(i18n["h" /* t */])("customerAccount.greatMember.stasusesSection.tabs.".concat(status, ".bulletPoints.").concat(i, ".link.url")),
      title: Object(i18n["h" /* t */])("customerAccount.greatMember.stasusesSection.tabs.".concat(status, ".bulletPoints.").concat(i, ".title"))
    } : null;
  }).filter(Boolean);

  return GreatMembersAccordionContent_jsx("div", {
    className: "py-20 sm:flex md:py-40"
  }, GreatMembersAccordionContent_jsx("div", {
    className: "flex justify-center sm:w-1/2"
  }, GreatMembersAccordionContent_jsx("div", {
    className: "py-20 text-center text-12 sm:pb-0 sm:pt-60 sm:text-16 text-gm-".concat(status)
  }, GreatMembersAccordionContent_jsx(Icon["a" /* Icon */], {
    className: "text-black",
    isNotMonoChrome: true,
    isNotSquare: true,
    name: icons["a" /* ICONS */]["CLUBMED_GREAT_MEMBERS_".concat(status.toUpperCase())],
    width: "20em"
  }), GreatMembersAccordionContent_jsx("div", {
    className: "mt-5 text-14 sm:text-16",
    "data-testid": "GreatMembersAccordionContent-pointsNeeded"
  }, Object(i18n["h" /* t */])("customerAccount.greatMember.stasusesSection.tabs.".concat(status, ".pointsToReachStatus"))))), GreatMembersAccordionContent_jsx("div", {
    className: "sm:w-1/2"
  }, GreatMembersAccordionContent_jsx(Title["a" /* Title */], {
    hLevel: 2,
    theme: "title-brand-n2"
  }, Object(i18n["h" /* t */])("customerAccount.greatMember.stasusesSection.tabs.".concat(status, ".title"))), GreatMembersAccordionContent_jsx(Title["a" /* Title */], {
    className: "text-".concat(status),
    hLevel: 3,
    theme: "title-sans-n2"
  }, Object(i18n["h" /* t */])("customerAccount.greatMember.stasusesSection.tabs.".concat(status, ".subtitle"))), GreatMembersAccordionContent_jsx(Text["a" /* Text */], {
    className: "my-20",
    text: Object(i18n["h" /* t */])("customerAccount.greatMember.stasusesSection.tabs.".concat(status, ".description"))
  }), bulletPoints.map(function (b) {
    return GreatMembersAccordionContent_jsx("div", {
      className: "relative pb-20 ps-25",
      key: b.title
    }, GreatMembersAccordionContent_jsx("span", {
      className: "absolute start-0 mt-5 text-32 font-bold leading-0 text-gm-".concat(status, " top-[3px]")
    }, "\u2022"), GreatMembersAccordionContent_jsx("span", {
      className: "font-bold text-gm-".concat(status)
    }, b.title), GreatMembersAccordionContent_jsx(Text["a" /* Text */], {
      text: b.description
    }), GreatMembersAccordionContent_jsx(TextLink["a" /* TextLink */], {
      label: b.linkLabel,
      target: "_blank",
      url: b.linkUrl
    }));
  }), links.map(function (link) {
    return GreatMembersAccordionContent_jsx("div", {
      className: "mt-10 text-end",
      "data-testid": "GreatMembersAccordionContent-links",
      key: link
    }, GreatMembersAccordionContent_jsx(TextLink["a" /* TextLink */], {
      className: "underline",
      iconName: icons["a" /* ICONS */].ARROW_TAIL_RIGHT,
      label: Object(i18n["h" /* t */])("customerAccount.greatMember.stasusesSection.tabs.links.".concat(link, ".label")),
      target: "_blank",
      url: Object(i18n["h" /* t */])("customerAccount.greatMember.stasusesSection.tabs.links.".concat(link, ".url"))
    }));
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/great-members-accordion/GreatMembersAccordion.jsx


var GreatMembersAccordion_jsx = react_default.a.createElement;






var GreatMembersAccordion_getTabsItems = function getTabsItems() {
  return ca_constants["a" /* GMStatuses */].map(function (st) {
    return {
      header: {
        color: "gm-".concat(st),
        title: Object(i18n["h" /* t */])("customerAccount.greatMember.stasusesSection.tabs.".concat(st, ".label"))
      },
      headerId: st.substring(0, 1),
      content: [GreatMembersAccordion_jsx(GreatMembersAccordionContent_GreatMembersAccordionContent, {
        key: st,
        status: st
      })]
    };
  });
};

var GreatMembersAccordion_getTabToOpenFromUserStatus = function getTabToOpenFromUserStatus(status) {
  var lowerCaseUserStatus = status && status.toLowerCase();
  var index = ca_constants["a" /* GMStatuses */].indexOf(lowerCaseUserStatus);
  return index > 0 ? index : 0;
};

var GreatMembersAccordion_GreatMembersAccordion = function GreatMembersAccordion(_ref) {
  var status = _ref.status;
  return GreatMembersAccordion_jsx(ResponsiveTabs["a" /* ResponsiveTabs */], {
    areAllCollapsable: true,
    hasBackground: true,
    initialSelectedItems: [GreatMembersAccordion_getTabToOpenFromUserStatus(status)],
    items: GreatMembersAccordion_getTabsItems()
  });
};
// CONCATENATED MODULE: ./src/client/components/widgets/great-members-stasuses-section/GreatMembersStasusesSection.jsx

var GreatMembersStasusesSection_jsx = react_default.a.createElement;













var GreatMembersStasusesSection_GreatMembersStasusesSection = function GreatMembersStasusesSection(_ref) {
  var className = _ref.className,
      loyaltyProgram = _ref.loyaltyProgram,
      loyaltyStatus = _ref.loyaltyStatus;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var loyaltyEnabled = Object(i18n["d" /* getKeyValue */])('customerAccount.greatMember.stasusesSection.loyalty.enabled');
  var articleEnabled = Object(i18n["d" /* getKeyValue */])('customerAccount.greatMember.stasusesSection.article.enabled');
  var tabsEnabled = Object(i18n["d" /* getKeyValue */])('customerAccount.greatMember.stasusesSection.tabs.enabled');
  var faqEnabled = Object(i18n["d" /* getKeyValue */])('customerAccount.greatMember.stasusesSection.faq.enabled');
  var allEnabled = articleEnabled && faqEnabled && loyaltyEnabled && tabsEnabled;
  return GreatMembersStasusesSection_jsx("section", {
    className: Object(classnames_utils["a" /* classnames */])('space-y-60', className)
  }, GreatMembersStasusesSection_jsx(SiteContainer["a" /* SiteContainer */], {
    id: "stasuses"
  }, allEnabled && GreatMembersStasusesSection_jsx(Title["a" /* Title */], {
    className: "mb-40",
    hLevel: 2,
    theme: "title-brand-n0"
  }, Object(i18n["h" /* t */])('customerAccount.greatMember.stasusesSection.title')), loyaltyEnabled && GreatMembersStasusesSection_jsx("ul", {
    className: "grid grid-cols-2 gap-y-40 sm:grid-cols-4"
  }, loyaltyProgram.map(function (_ref2) {
    var status = _ref2.status,
        threshold = _ref2.threshold;
    return GreatMembersStasusesSection_jsx("li", {
      className: "flex flex-col items-center justify-center p-20 text-center odd:max-sm:border-r-1 sm:border-l-1 sm:first:border-l-0",
      key: threshold
    }, GreatMembersStasusesSection_jsx(Icon["a" /* Icon */], {
      className: "mb-15 text-black",
      isNotMonoChrome: true,
      name: icons["a" /* ICONS */]["CLUBMED_GREAT_MEMBERS_".concat(status.toUpperCase(), "_TRIDENT")],
      width: "5.625rem"
    }), GreatMembersStasusesSection_jsx("p", {
      className: "sr-only"
    }, status), GreatMembersStasusesSection_jsx("p", {
      className: "text-16 font-semibold"
    }, threshold > 0 ? Object(i18n["h" /* t */])("customerAccount.greatMember.stasusesSection.tabs.".concat(status, ".pointsToReachStatus")) : Object(i18n["h" /* t */])('customerAccount.greatMember.stasusesSection.loyalty.noPointsLabel')));
  })), articleEnabled && GreatMembersStasusesSection_jsx(Card["a" /* Card */], {
    className: "mt-60",
    heading: {
      hLevel: 3,
      title: Object(i18n["h" /* t */])('customerAccount.greatMember.stasusesSection.article.title')
    },
    layout: Card_constants["e" /* INLINE_2 */],
    media: {
      url: Object(i18n["h" /* t */])('customerAccount.greatMember.stasusesSection.article.imageUrl')
    },
    text: {
      text: Object(i18n["h" /* t */])('customerAccount.greatMember.stasusesSection.article.text')
    }
  })), tabsEnabled && GreatMembersStasusesSection_jsx("section", {
    id: "advantages"
  }, GreatMembersStasusesSection_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "mb-40"
  }, GreatMembersStasusesSection_jsx(Title["a" /* Title */], {
    hLevel: 3,
    theme: "title-brand-n2"
  }, Object(i18n["h" /* t */])('customerAccount.greatMember.stasusesSection.tabs.title')), GreatMembersStasusesSection_jsx(Title["a" /* Title */], {
    className: "text-sienna",
    hLevel: 4,
    theme: "title-sans-n2"
  }, Object(i18n["h" /* t */])('customerAccount.greatMember.stasusesSection.tabs.subtitle'))), GreatMembersStasusesSection_jsx(GreatMembersAccordion_GreatMembersAccordion, {
    status: loyaltyStatus
  })), faqEnabled && GreatMembersStasusesSection_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "text-center",
    id: "faq"
  }, GreatMembersStasusesSection_jsx("p", {
    className: "mb-15 font-brand text-24 font-bold"
  }, Object(i18n["h" /* t */])('customerAccount.greatMember.stasusesSection.faq.label')), GreatMembersStasusesSection_jsx(Button["a" /* Button */], {
    onClick: function onClick() {
      return trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_CA_GM, {
        detail_click: 'see_the_faq'
      });
    },
    target: "_blank",
    url: Object(i18n["h" /* t */])('customerAccount.faq.link')
  }, Object(i18n["h" /* t */])('customerAccount.greatMember.stasusesSection.faq.cta'))));
};
// EXTERNAL MODULE: ./src/client/components/widgets/hero/Hero.jsx
var Hero = __webpack_require__("2B1m");

// EXTERNAL MODULE: ./src/client/components/frameworks/breadcrumb/Breadcrumb.jsx
var Breadcrumb = __webpack_require__("gbpH");

// EXTERNAL MODULE: ./src/routes/routeBuilder.js + 1 modules
var routeBuilder = __webpack_require__("U2CP");

// EXTERNAL MODULE: ./src/hooks/use-authentication/useAuthentication.js
var useAuthentication = __webpack_require__("Iev9");

// CONCATENATED MODULE: ./src/client/views/great-members/GreatMembersView.jsx

var GreatMembersView_jsx = react_default.a.createElement;



















var GreatMembersView_GreatMembersView = function GreatMembersView(_ref) {
  var _profile$loyaltyProgr;

  var _ref$animation = _ref.animation,
      animation = _ref$animation === void 0 ? [] : _ref$animation,
      loyaltyProgram = _ref.loyaltyProgram,
      loyaltyProgramSimulation = _ref.loyaltyProgramSimulation,
      profile = _ref.profile;

  var _useRouter = Object(router["useRouter"])(),
      asPath = _useRouter.asPath;

  var hash = new URI_default.a(asPath).hash();
  Object(react["useEffect"])(function () {
    // unfortunetely we do not get the hash on no spa navigation don't know why
    if (hash || window.location.hash) {
      setTimeout(function () {
        Object(scrollToElement["a" /* scrollToElement */])(hash || window.location.hash);
      }, 600);
    }
  }, [hash]);
  var pageTitle = Object(i18n["h" /* t */])('customerAccount.greatMember.pageTitle');
  var loyaltyStatus = (profile === null || profile === void 0 ? void 0 : (_profile$loyaltyProgr = profile.loyaltyProgram) === null || _profile$loyaltyProgr === void 0 ? void 0 : _profile$loyaltyProgr.status) || hash.substring(1, hash.length);

  var _useAuthentication = Object(useAuthentication["a" /* useAuthentication */])(),
      isQuickLogged = _useAuthentication.isQuickLogged,
      isLogged = _useAuthentication.isLogged;

  return GreatMembersView_jsx(react["Fragment"], null, GreatMembersView_jsx(head_default.a, null, GreatMembersView_jsx("title", {
    key: "title"
  }, pageTitle)), GreatMembersView_jsx(TrackPage["a" /* TrackPage */], {
    pageName: tracking_constants["H" /* TRACK_PAGE_NAMES */].CA_GREAT_MEMBERS
  }), GreatMembersView_jsx("header", {
    className: "Line Line-Immersive",
    role: "banner"
  }, GreatMembersView_jsx(Hero["a" /* Hero */], {
    title: (Object(i18n["e" /* getListValue */])('customerAccount.greatMember.titles') || []).join(' '),
    url: Object(i18n["h" /* t */])('customerAccount.greatMember.imageUrl')
  })), GreatMembersView_jsx("main", {
    className: "space-y-80 pb-100 pt-40 sm:space-y-120",
    role: "main"
  }, (isLogged || isQuickLogged) && GreatMembersView_jsx(SiteContainer["a" /* SiteContainer */], null, GreatMembersView_jsx(Breadcrumb["a" /* Breadcrumb */], {
    items: [{
      label: isQuickLogged ? Object(i18n["h" /* t */])('account.authenticated.dashboard') : Object(i18n["h" /* t */])('customerAccount.home.pageTitle'),
      url: Object(routeBuilder["b" /* urlPattern */])('account')
    }, {
      label: Object(i18n["h" /* t */])('customerAccount.greatMember.pageTitle')
    }]
  })), animation.length > 0 && GreatMembersView_jsx(SiteContainer["a" /* SiteContainer */], {
    id: "animation"
  }, GreatMembersView_jsx(Title["a" /* Title */], {
    className: "mb-40",
    hLevel: 2,
    theme: "title-brand-n0"
  }, Object(i18n["h" /* t */])('customerAccount.greatMember.animation.title')), GreatMembersView_jsx(EventAnimation["a" /* EventAnimation */], {
    events: animation
  })), (profile === null || profile === void 0 ? void 0 : profile.loyaltyProgram) && Object(i18n["d" /* getKeyValue */])('customerAccount.greatMember.introduction.enabled') && GreatMembersView_jsx(SiteContainer["a" /* SiteContainer */], {
    id: "introduction"
  }, GreatMembersView_jsx(GreatMembersIntroduction_GreatMembersIntroduction, {
    loyaltyProgram: loyaltyProgram,
    profile: profile.loyaltyProgram
  })), Object(i18n["d" /* getKeyValue */])('customerAccount.greatMember.stepsSection.enabled') && GreatMembersView_jsx(SiteContainer["a" /* SiteContainer */], {
    id: "exclusivity"
  }, GreatMembersView_jsx(GreatMembersExclusivity_GreatMembersExclusivity, null)), Object(i18n["d" /* getKeyValue */])('customerAccount.greatMember.pointsSection.enabled') && GreatMembersView_jsx(SiteContainer["a" /* SiteContainer */], {
    id: "points"
  }, GreatMembersView_jsx(GreatMembersPointsSection_GreatMembersPointsSection, {
    loyaltyProgramSimulation: loyaltyProgramSimulation
  })), Object(i18n["d" /* getKeyValue */])('customerAccount.greatMember.stasusesSection.enabled') && GreatMembersView_jsx(GreatMembersStasusesSection_GreatMembersStasusesSection, {
    loyaltyProgram: loyaltyProgram,
    loyaltyStatus: loyaltyStatus
  })));
};
// CONCATENATED MODULE: ./src/client/views/great-members/GreatMembersView.container.js
var GreatMembersView_container_jsx = react_default.a.createElement;












var GreatMembersView_container_GreatMemberViewContainer = function GreatMemberViewContainer() {
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var userInfo = Object(es["e" /* useSelector */])(userInfo_selectors["a" /* userInfoSelector */]);

  var _useGQL = Object(useGQL["a" /* useGQL */])({
    query: '',
    queryOptions: {
      requestName: requestDictionary["o" /* CUSTOMER_ACCOUNT_GET_CMS_DATA_GREATMEMBERS */],
      queryId: requestDictionary["o" /* CUSTOMER_ACCOUNT_GET_CMS_DATA_GREATMEMBERS */]
    },
    cache: true,
    map: function map(_ref) {
      var _config$customerAccou, _config$customerAccou2, _config$customerAccou3;

      var config = _ref.config;
      return {
        animation: ((_config$customerAccou = config.customerAccount) === null || _config$customerAccou === void 0 ? void 0 : (_config$customerAccou2 = _config$customerAccou.greatMember) === null || _config$customerAccou2 === void 0 ? void 0 : (_config$customerAccou3 = _config$customerAccou2.animation) === null || _config$customerAccou3 === void 0 ? void 0 : _config$customerAccou3.items) || []
      };
    }
  }, {
    query: getLoyaltyProgramQuery(),
    queryOptions: {
      requestName: requestDictionary["x" /* CUSTOMER_ACCOUNT_GET_LOYALTY_PROGRAM */]
    },
    cache: true
  }, {
    query: getLoyaltyQuery(),
    queryOptions: {
      requestName: requestDictionary["w" /* CUSTOMER_ACCOUNT_GET_LOYALTY_DETAILS */]
    },
    cache: false,
    "catch": function _catch() {},
    ignore: !appContext.isUserLogged || !Object(handleInvalidToken["b" /* isTokenValid */])(userInfo)
  }),
      isLoading = _useGQL.isLoading,
      data = _useGQL.data;

  return GreatMembersView_container_jsx(SpinnerHandler["a" /* SpinnerHandler */], {
    isLoading: isLoading
  }, data && GreatMembersView_container_jsx(GreatMembersView_GreatMembersView, {
    animation: data.animation,
    loyaltyProgram: data.loyaltyProgram,
    loyaltyProgramSimulation: data.loyaltyProgramSimulation,
    profile: data.profile
  }));
};
GreatMembersView_container_GreatMemberViewContainer.pageId = constants["p" /* PLE_GREAT_MEMBERS_PAGE_ID */];
GreatMembersView_container_GreatMemberViewContainer.pageType = tracking_constants["C" /* STATIC_PAGE_TYPES */].PLE;
// CONCATENATED MODULE: ./pages/great-members.js

/* harmony default export */ var great_members = __webpack_exports__["default"] = (GreatMembersView_container_GreatMemberViewContainer);

/***/ }),

/***/ "aPQG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sendErrorToSentry; });
/* unused harmony export shouldIgnore */
/* unused harmony export processError */
/* unused harmony export handleBrowserError */
/* unused harmony export handlePromiseError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handleComponentError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return start; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("5BYb");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("tVqn");
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("rOcY");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("m0zD");
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_logger__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _errors__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("wNDy");









/* eslint-env browser */





var sanitize = function sanitize() {
  var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return s && s.trim().toLowerCase();
};

var sendErrorToSentry = function sendErrorToSentry(_ref) {
  var error = _ref.error,
      _ref$errorInfo = _ref.errorInfo,
      errorInfo = _ref$errorInfo === void 0 ? {} : _ref$errorInfo;

  if ( true && _config__WEBPACK_IMPORTED_MODULE_9___default.a.get('clientError.sentry.enabled')) {
    var _window$Sentry;

    (_window$Sentry = window.Sentry) === null || _window$Sentry === void 0 ? void 0 : _window$Sentry.withScope(function (scope) {
      var _window$Sentry2;

      Object.keys(errorInfo).forEach(function (key) {
        scope.setExtra(key, errorInfo[key]);
      });
      (_window$Sentry2 = window.Sentry) === null || _window$Sentry2 === void 0 ? void 0 : _window$Sentry2.captureException(error);
    });
  }
};
var shouldIgnore = function shouldIgnore(error) {
  var errorMessagesToIgnore = [].concat(_config__WEBPACK_IMPORTED_MODULE_9___default.a.get('clientError.ignore.descriptions'));
  var errorMessage = sanitize(error.message);
  var errorStack = sanitize(error.stack);
  return errorMessagesToIgnore.some(function (messageToIgnore) {
    var msg = sanitize(messageToIgnore);
    var isIgnored = !!msg && (!!errorMessage.includes(msg) || !!errorStack.includes(msg));
    return isIgnored;
  });
};
var processError = function processError(_ref2) {
  var error = _ref2.error,
      errorInfo = _ref2.errorInfo;
  _logger__WEBPACK_IMPORTED_MODULE_10___default.a.error({
    err: error,
    info: errorInfo
  });

  if (!shouldIgnore(error)) {
    sendErrorToSentry({
      error: error,
      errorInfo: errorInfo
    });
  }

  return error;
}; // eslint-disable-next-line max-params

var handleBrowserError = function handleBrowserError(message, file, line, col, error) {
  return processError({
    error: error || new _errors__WEBPACK_IMPORTED_MODULE_11__[/* ClientSideError */ "c"]({
      name: 'Unknown error name',
      message: message || 'Unknown error message',
      stack: 'Unknown stack'
    }),
    errorInfo: {
      message: message,
      file: file,
      line: line,
      col: col
    }
  });
};
var handlePromiseError = function handlePromiseError(domCustomEvent) {
  return processError({
    error: lodash_get__WEBPACK_IMPORTED_MODULE_8___default()(domCustomEvent, 'detail.reason', lodash_get__WEBPACK_IMPORTED_MODULE_8___default()(domCustomEvent, 'reason', new _errors__WEBPACK_IMPORTED_MODULE_11__[/* ClientSideError */ "c"]({
      name: 'Unknown rejected promise name',
      message: 'Unknown rejected promise message',
      stack: ['Unknown stack']
    })))
  });
};
var handleComponentError = function handleComponentError(error, errorInfo) {
  return processError({
    error: error || new _errors__WEBPACK_IMPORTED_MODULE_11__[/* ClientSideError */ "c"]({
      name: 'Unknown component error name',
      message: 'Unknown component error message',
      stack: ['Unknown stack']
    }),
    errorInfo: errorInfo
  });
};
var start = function start() {
  window.onerror = handleBrowserError;
  window.addEventListener('unhandledrejection', handlePromiseError);
  window.addEventListener('rejectionhandled', handlePromiseError);
};

/***/ }),

/***/ "aURW":
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ "akds":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Video; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("C/y5");
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("pKEY");
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_lazyload__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("u/u4");
/* harmony import */ var _image_placeholder_ImagePlaceholder__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("D0nZ");
/* harmony import */ var _Video_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("JhHq");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;






function Video(props) {
  var className = props.className,
      iFrameClassName = props.iFrameClassName,
      _props$ratioKey = props.ratioKey,
      ratioKey = _props$ratioKey === void 0 ? _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_3__[/* default */ "c"].L : _props$ratioKey,
      url = props.url;

  if (!Object(_Video_utils__WEBPACK_IMPORTED_MODULE_5__[/* isVideoUrl */ "b"])(url)) {
    return null;
  }

  return __jsx(_image_placeholder_ImagePlaceholder__WEBPACK_IMPORTED_MODULE_4__[/* ImagePlaceholder */ "a"], {
    aspectRatio: 100 * _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_3__[/* default */ "c"].VALUES[ratioKey],
    className: className
  }, __jsx(react_lazyload__WEBPACK_IMPORTED_MODULE_2___default.a, {
    className: "bg-no-repeat bg-center bg-cover leading-0 flex h-full items-center justify-center overflow-hidden rounded-12",
    once: true,
    offset: 100
  }, __jsx("iframe", {
    loading: "lazy",
    title: "Video iframe",
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__[/* classnames */ "a"])(iFrameClassName, 'border-0 animate-fadeIn animation-duration-500 h-[54vw] w-[96vw] max-h-full lazy'),
    src: Object(_Video_utils__WEBPACK_IMPORTED_MODULE_5__[/* getVideoUrl */ "a"])(url),
    allowFullScreen: true
  })));
}

/***/ }),

/***/ "bJ4E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isTokenValid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handleInvalidToken; });
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("L7OA");
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("6jSF");








var isTokenValid = function isTokenValid(userInfo) {
  return userInfo && moment__WEBPACK_IMPORTED_MODULE_4___default()(userInfo.expirationDate, 'X').startOf('second').isAfter();
};
var handleInvalidToken = function handleInvalidToken(_ref) {
  var appContext = _ref.appContext,
      currentUri = _ref.currentUri,
      res = _ref.res,
      userInfo = _ref.userInfo;
  var locale = appContext.locale,
      isSeller = appContext.isSeller,
      isCmta = appContext.isCmta,
      isUserLogged = appContext.isUserLogged,
      isUserQuickLogged = appContext.isUserQuickLogged,
      isSellerLogged = appContext.isSellerLogged;
  var redirectUri = isSeller ? Object(_index__WEBPACK_IMPORTED_MODULE_7__[/* buildSellerSigninUrl */ "e"])({
    isCmta: isCmta,
    locale: locale,
    redirectUri: currentUri.toString(),
    redirectURIError: Object(_index__WEBPACK_IMPORTED_MODULE_7__[/* buildErrorUrl */ "c"])(currentUri.toString(), locale)
  }) : Object(_index__WEBPACK_IMPORTED_MODULE_7__[/* buildSigninUrl */ "f"])({
    locale: locale,
    redirectUri: currentUri.toString(),
    redirectURIError: Object(_index__WEBPACK_IMPORTED_MODULE_7__[/* buildErrorUrl */ "c"])(currentUri.toString(), locale),
    isQuickLoginFirst: currentUri.toString().includes("provider=".concat(_index__WEBPACK_IMPORTED_MODULE_7__[/* QUICK_LOGIN_QUERY_PARAM */ "a"])) || Object(_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_6__[/* isFeatureFlipped */ "a"])(appContext)('memberSpace.isQuickLoginFirst')
  }); // not filled because the cookie is httpOnly
  // if (!appContext.authenticationToken) {

  if (!isUserLogged && !isUserQuickLogged && !isSellerLogged) {
    if (res) {
      res.redirect(302, redirectUri);
    } else {
      _clubmed_utils__WEBPACK_IMPORTED_MODULE_5__["windowWrapper"].setLocation(redirectUri);
    }
  } else if ((isUserLogged || isUserQuickLogged) && !isTokenValid(userInfo)) {
    _clubmed_utils__WEBPACK_IMPORTED_MODULE_5__["windowWrapper"].setLocation(redirectUri);
  }
};

/***/ }),

/***/ "bOkD":
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__("cHE3");

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}

module.exports = _arrayWithoutHoles;

/***/ }),

/***/ "c8jO":
/***/ (function(module, exports) {

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}
module.exports = _taggedTemplateLiteralLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "cMav":
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__("i2RQ");

var assertThisInitialized = __webpack_require__("N7I1");

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn;

/***/ }),

/***/ "dFUt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */


function Cache(maxSize) {
  this._maxSize = maxSize
  this.clear()
}
Cache.prototype.clear = function() {
  this._size = 0
  this._values = {}
}
Cache.prototype.get = function(key) {
  return this._values[key]
}
Cache.prototype.set = function(key, value) {
  this._size >= this._maxSize && this.clear()
  if (!this._values.hasOwnProperty(key)) {
    this._size++
  }
  return this._values[key] = value
}

var SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g,
  DIGIT_REGEX = /^\d+$/,
  LEAD_DIGIT_REGEX = /^\d/,
  SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g,
  CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/,
  MAX_CACHE_SIZE = 512

var contentSecurityPolicy = false,
  pathCache = new Cache(MAX_CACHE_SIZE),
  setCache = new Cache(MAX_CACHE_SIZE),
  getCache = new Cache(MAX_CACHE_SIZE)

try {
  new Function('')
} catch (error) {
  contentSecurityPolicy = true
}

module.exports = {
  Cache: Cache,

  expr: expr,

  split: split,

  normalizePath: normalizePath,

  setter: contentSecurityPolicy
    ? function(path) {
      var parts = normalizePath(path)
      return function(data, value) {
        return setterFallback(parts, data, value)
      }
    }
    : function(path) {
      return setCache.get(path) || setCache.set(
        path,
        new Function(
          'data, value',
          expr(path, 'data') + ' = value'
        )
      )
    },

  getter: contentSecurityPolicy
    ? function(path, safe) {
      var parts = normalizePath(path)
      return function(data) {
        return getterFallback(parts, safe, data)
      }
    }
    : function(path, safe) {
      var key = path + '_' + safe
      return getCache.get(key) || getCache.set(
        key,
        new Function('data', 'return ' + expr(path, safe, 'data'))
      )
    },

  join: function(segments) {
    return segments.reduce(function(path, part) {
      return (
        path +
        (isQuoted(part) || DIGIT_REGEX.test(part)
          ? '[' + part + ']'
          : (path ? '.' : '') + part)
      )
    }, '')
  },

  forEach: function(path, cb, thisArg) {
    forEach(split(path), cb, thisArg)
  }
}

function setterFallback(parts, data, value) {
  var index = 0,
    len = parts.length
  while (index < len - 1) {
    data = data[parts[index++]]
  }
  data[parts[index]] = value
}

function getterFallback(parts, safe, data) {
  var index = 0,
    len = parts.length
  while (index < len) {
    if (data != null || !safe) {
      data = data[parts[index++]]
    } else {
      return
    }
  }
  return data
}

function normalizePath(path) {
  return pathCache.get(path) || pathCache.set(
    path,
    split(path).map(function(part) {
      return part.replace(CLEAN_QUOTES_REGEX, '$2')
    })
  )
}

function split(path) {
  return path.match(SPLIT_REGEX)
}

function expr(expression, safe, param) {
  expression = expression || ''

  if (typeof safe === 'string') {
    param = safe
    safe = false
  }

  param = param || 'data'

  if (expression && expression.charAt(0) !== '[') expression = '.' + expression

  return safe ? makeSafe(expression, param) : param + expression
}

function forEach(parts, iter, thisArg) {
  var len = parts.length,
    part,
    idx,
    isArray,
    isBracket

  for (idx = 0; idx < len; idx++) {
    part = parts[idx]

    if (part) {
      if (shouldBeQuoted(part)) {
        part = '"' + part + '"'
      }

      isBracket = isQuoted(part)
      isArray = !isBracket && /^\d+$/.test(part)

      iter.call(thisArg, part, isBracket, isArray, idx, parts)
    }
  }
}

function isQuoted(str) {
  return (
    typeof str === 'string' && str && ["'", '"'].indexOf(str.charAt(0)) !== -1
  )
}

function makeSafe(path, param) {
  var result = param,
    parts = split(path),
    isLast

  forEach(parts, function(part, isBracket, isArray, idx, parts) {
    isLast = idx === parts.length - 1

    part = isBracket || isArray ? '[' + part + ']' : '.' + part

    result += part + (!isLast ? ' || {})' : ')')
  })

  return new Array(parts.length + 1).join('(') + result
}

function hasLeadingNumber(part) {
  return part.match(LEAD_DIGIT_REGEX) && !part.match(DIGIT_REGEX)
}

function hasSpecialChars(part) {
  return SPEC_CHAR_REGEX.test(part)
}

function shouldBeQuoted(part) {
  return !isQuoted(part) && (hasLeadingNumber(part) || hasSpecialChars(part))
}


/***/ }),

/***/ "dq4L":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.isInAmpMode = isInAmpMode;
exports.useAmp = useAmp;

var _react = _interopRequireDefault(__webpack_require__("ERkP"));

var _ampContext = __webpack_require__("TZT2");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function isInAmpMode() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$ampFirst = _ref.ampFirst,
      ampFirst = _ref$ampFirst === void 0 ? false : _ref$ampFirst,
      _ref$hybrid = _ref.hybrid,
      hybrid = _ref$hybrid === void 0 ? false : _ref$hybrid,
      _ref$hasQuery = _ref.hasQuery,
      hasQuery = _ref$hasQuery === void 0 ? false : _ref$hasQuery;

  return ampFirst || hybrid && hasQuery;
}

function useAmp() {
  // Don't assign the context value to a variable to save bytes
  return isInAmpMode(_react.default.useContext(_ampContext.AmpStateContext));
}

/***/ }),

/***/ "fnDY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.default = ValidationError;

var _printValue = _interopRequireDefault(__webpack_require__("i0Sy"));

var strReg = /\$\{\s*(\w+)\s*\}/g;

var replace = function replace(str) {
  return function (params) {
    return str.replace(strReg, function (_, key) {
      return (0, _printValue.default)(params[key]);
    });
  };
};

function ValidationError(errors, value, field, type) {
  var _this = this;

  this.name = 'ValidationError';
  this.value = value;
  this.path = field;
  this.type = type;
  this.errors = [];
  this.inner = [];
  if (errors) [].concat(errors).forEach(function (err) {
    _this.errors = _this.errors.concat(err.errors || err);
    if (err.inner) _this.inner = _this.inner.concat(err.inner.length ? err.inner : err);
  });
  this.message = this.errors.length > 1 ? this.errors.length + " errors occurred" : this.errors[0];
  if (Error.captureStackTrace) Error.captureStackTrace(this, ValidationError);
}

ValidationError.prototype = Object.create(Error.prototype);
ValidationError.prototype.constructor = ValidationError;

ValidationError.isError = function (err) {
  return err && err.name === 'ValidationError';
};

ValidationError.formatError = function (message, params) {
  if (typeof message === 'string') message = replace(message);

  var fn = function fn(params) {
    params.path = params.label || params.path || 'this';
    return typeof message === 'function' ? message(params) : message;
  };

  return arguments.length === 1 ? fn : fn(params);
};

module.exports = exports["default"];

/***/ }),

/***/ "fw2E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _freeGlobal_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("kq48");


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),

/***/ "gbpH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Breadcrumb; });
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("C/y5");
/* harmony import */ var _dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("i5Mr");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;



var Breadcrumb = function Breadcrumb(_ref) {
  var className = _ref.className,
      items = _ref.items;
  return items.length > 1 ? __jsx("ul", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_3__[/* classnames */ "a"])('scroll-x scrollbar-hidden flex gap-10 text-14', className)
  }, items.filter(function (_ref2) {
    var label = _ref2.label;
    return Boolean(label);
  }).map(function (item, i) {
    return __jsx("li", {
      className: "whitespace-nowrap",
      key: item.label
    }, i < items.length - 1 ? __jsx(react__WEBPACK_IMPORTED_MODULE_2__["Fragment"], null, __jsx(_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"], {
      className: "text-black hocus:text-black-active",
      "data-testid": item.dataTestId,
      onClick: item.onClick,
      url: item.url
    }, item.label), __jsx("span", {
      className: "ms-10"
    }, ">")) : __jsx("span", {
      className: "font-bold text-sienna"
    }, item.label));
  })) : null;
};

/***/ }),

/***/ "gqH2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.default = void 0;

var _isSchema = _interopRequireDefault(__webpack_require__("kZEO"));

var Lazy =
/*#__PURE__*/
function () {
  function Lazy(mapFn) {
    this._resolve = function (value, options) {
      var schema = mapFn(value, options);
      if (!(0, _isSchema.default)(schema)) throw new TypeError('lazy() functions must return a valid schema');
      return schema.resolve(options);
    };
  }

  var _proto = Lazy.prototype;

  _proto.resolve = function resolve(options) {
    return this._resolve(options.value, options);
  };

  _proto.cast = function cast(value, options) {
    return this._resolve(value, options).cast(value, options);
  };

  _proto.validate = function validate(value, options) {
    return this._resolve(value, options).validate(value, options);
  };

  _proto.validateSync = function validateSync(value, options) {
    return this._resolve(value, options).validateSync(value, options);
  };

  _proto.validateAt = function validateAt(path, value, options) {
    return this._resolve(value, options).validateAt(path, value, options);
  };

  _proto.validateSyncAt = function validateSyncAt(path, value, options) {
    return this._resolve(value, options).validateSyncAt(path, value, options);
  };

  return Lazy;
}();

Lazy.prototype.__isYupSchema__ = true;
var _default = Lazy;
exports.default = _default;
module.exports = exports["default"];

/***/ }),

/***/ "hCAA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.default = void 0;

var _has = _interopRequireDefault(__webpack_require__("1mr4"));

var _isSchema = _interopRequireDefault(__webpack_require__("kZEO"));

var Condition =
/*#__PURE__*/
function () {
  function Condition(refs, options) {
    this.refs = refs;

    if (typeof options === 'function') {
      this.fn = options;
      return;
    }

    if (!(0, _has.default)(options, 'is')) throw new TypeError('`is:` is required for `when()` conditions');
    if (!options.then && !options.otherwise) throw new TypeError('either `then:` or `otherwise:` is required for `when()` conditions');
    var is = options.is,
        then = options.then,
        otherwise = options.otherwise;
    var check = typeof is === 'function' ? is : function () {
      for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
        values[_key] = arguments[_key];
      }

      return values.every(function (value) {
        return value === is;
      });
    };

    this.fn = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      var options = args.pop();
      var schema = args.pop();
      var branch = check.apply(void 0, args) ? then : otherwise;
      if (!branch) return undefined;
      if (typeof branch === 'function') return branch(schema);
      return schema.concat(branch.resolve(options));
    };
  }

  var _proto = Condition.prototype;

  _proto.resolve = function resolve(base, options) {
    var values = this.refs.map(function (ref) {
      return ref.getValue(options);
    });
    var schema = this.fn.apply(base, values.concat(base, options));
    if (schema === undefined || schema === base) return base;
    if (!(0, _isSchema.default)(schema)) throw new TypeError('conditions must return a schema object');
    return schema.resolve(options);
  };

  return Condition;
}();

var _default = Condition;
exports.default = _default;
module.exports = exports["default"];

/***/ }),

/***/ "hLcx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__("97Jx"));

var _propertyExpr = __webpack_require__("dFUt");

var prefixes = {
  context: '$',
  value: '.'
};

var Reference =
/*#__PURE__*/
function () {
  function Reference(key, options) {
    if (options === void 0) {
      options = {};
    }

    if (typeof key !== 'string') throw new TypeError('ref must be a string, got: ' + key);
    this.key = key.trim();
    if (key === '') throw new TypeError('ref must be a non-empty string');
    this.isContext = this.key[0] === prefixes.context;
    this.isValue = this.key[0] === prefixes.value;
    this.isSibling = !this.isContext && !this.isValue;
    var prefix = this.isContext ? prefixes.context : this.isValue ? prefixes.value : '';
    this.path = this.key.slice(prefix.length);
    this.getter = this.path && (0, _propertyExpr.getter)(this.path, true);
    this.map = options.map;
  }

  var _proto = Reference.prototype;

  _proto.getValue = function getValue(options) {
    var result = this.isContext ? options.context : this.isValue ? options.value : options.parent;
    if (this.getter) result = this.getter(result || {});
    if (this.map) result = this.map(result);
    return result;
  };

  _proto.cast = function cast(value, options) {
    return this.getValue((0, _extends2.default)({}, options, {
      value: value
    }));
  };

  _proto.resolve = function resolve() {
    return this;
  };

  _proto.describe = function describe() {
    return {
      type: 'ref',
      key: this.key
    };
  };

  _proto.toString = function toString() {
    return "Ref(" + this.key + ")";
  };

  Reference.isRef = function isRef(value) {
    return value && value.__isYupRef;
  };

  return Reference;
}();

exports.default = Reference;
Reference.prototype.__isYupRef = true;
module.exports = exports["default"];

/***/ }),

/***/ "hUUf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Legend; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("C/y5");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;


var Legend = function Legend(_ref) {
  var className = _ref.className,
      isRequired = _ref.isRequired,
      label = _ref.label,
      labelAdditionalInfo = _ref.labelAdditionalInfo;
  return __jsx("legend", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__[/* classnames */ "a"])('font-bold inline-block text-14 text-black', className)
  }, label, isRequired && '*', labelAdditionalInfo && __jsx("span", {
    className: "font-normal ms-10 text-12 text-grey"
  }, labelAdditionalInfo));
};

/***/ }),

/***/ "i0Sy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = printValue;
var toString = Object.prototype.toString;
var errorToString = Error.prototype.toString;
var regExpToString = RegExp.prototype.toString;
var symbolToString = typeof Symbol !== 'undefined' ? Symbol.prototype.toString : function () {
  return '';
};
var SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;

function printNumber(val) {
  if (val != +val) return 'NaN';
  var isNegativeZero = val === 0 && 1 / val < 0;
  return isNegativeZero ? '-0' : '' + val;
}

function printSimpleValue(val, quoteStrings) {
  if (quoteStrings === void 0) {
    quoteStrings = false;
  }

  if (val == null || val === true || val === false) return '' + val;
  var typeOf = typeof val;
  if (typeOf === 'number') return printNumber(val);
  if (typeOf === 'string') return quoteStrings ? "\"" + val + "\"" : val;
  if (typeOf === 'function') return '[Function ' + (val.name || 'anonymous') + ']';
  if (typeOf === 'symbol') return symbolToString.call(val).replace(SYMBOL_REGEXP, 'Symbol($1)');
  var tag = toString.call(val).slice(8, -1);
  if (tag === 'Date') return isNaN(val.getTime()) ? '' + val : val.toISOString(val);
  if (tag === 'Error' || val instanceof Error) return '[' + errorToString.call(val) + ']';
  if (tag === 'RegExp') return regExpToString.call(val);
  return null;
}

function printValue(value, quoteStrings) {
  var result = printSimpleValue(value, quoteStrings);
  if (result !== null) return result;
  return JSON.stringify(value, function (key, value) {
    var result = printSimpleValue(this[key], quoteStrings);
    if (result !== null) return result;
    return value;
  }, 2);
}

module.exports = exports["default"];

/***/ }),

/***/ "iN+R":
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__("bOkD");

var iterableToArray = __webpack_require__("DSo7");

var unsupportedIterableToArray = __webpack_require__("D7XE");

var nonIterableSpread = __webpack_require__("uYlf");

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray;

/***/ }),

/***/ "kMkq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _default = function _default(value) {
  return value == null;
};

exports.default = _default;
module.exports = exports["default"];

/***/ }),

/***/ "kZEO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _default = function _default(obj) {
  return obj && obj.__isYupSchema__;
};

exports.default = _default;
module.exports = exports["default"];

/***/ }),

/***/ "kq48":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("lpmq")))

/***/ }),

/***/ "ljKo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ FastField; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ Field; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ Form; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ Formik; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* binding */ useFormikContext; });

// UNUSED EXPORTS: ErrorMessage, FieldArray, FormikConsumer, FormikContext, FormikProvider, connect, getActiveElement, getIn, insert, isEmptyArray, isEmptyChildren, isFunction, isInputEvent, isInteger, isNaN, isObject, isPromise, isString, move, prepareDataForValidation, replace, setIn, setNestedObjectValues, swap, useField, useFormik, validateYupSchema, withFormik, yupToFormErrors

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-fast-compare/index.js
var react_fast_compare = __webpack_require__("F0GY");
var react_fast_compare_default = /*#__PURE__*/__webpack_require__.n(react_fast_compare);

// CONCATENATED MODULE: /opt/webapp/node_modules/formik/node_modules/deepmerge/dist/es.js
var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		Object.keys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	Object.keys(source).forEach(function(key) {
		if (!options.isMergeableObject(source[key]) || !target[key]) {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		} else {
			destination[key] = deepmerge(target[key], source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

/* harmony default export */ var es = (deepmerge_1);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_baseGetTag.js
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ var _baseGetTag = (objectToString);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_overArg.js
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ var _overArg = (overArg);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_getPrototype.js


/** Built-in value references. */
var getPrototype = _overArg(Object.getPrototypeOf, Object);

/* harmony default export */ var _getPrototype = (getPrototype);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/isObjectLike.js
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ var lodash_es_isObjectLike = (isObjectLike);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/isPlainObject.js




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    isPlainObject_objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var isPlainObject_hasOwnProperty = isPlainObject_objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!lodash_es_isObjectLike(value) || _baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = _getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = isPlainObject_hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ var lodash_es_isPlainObject = (isPlainObject);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_listCacheClear.js
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/* harmony default export */ var _listCacheClear = (listCacheClear);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/eq.js
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/* harmony default export */ var lodash_es_eq = (eq);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_assocIndexOf.js


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (lodash_es_eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/* harmony default export */ var _assocIndexOf = (assocIndexOf);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_listCacheDelete.js


/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/* harmony default export */ var _listCacheDelete = (listCacheDelete);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_listCacheGet.js


/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/* harmony default export */ var _listCacheGet = (listCacheGet);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_listCacheHas.js


/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return _assocIndexOf(this.__data__, key) > -1;
}

/* harmony default export */ var _listCacheHas = (listCacheHas);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_listCacheSet.js


/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

/* harmony default export */ var _listCacheSet = (listCacheSet);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_ListCache.js






/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = _listCacheClear;
ListCache.prototype['delete'] = _listCacheDelete;
ListCache.prototype.get = _listCacheGet;
ListCache.prototype.has = _listCacheHas;
ListCache.prototype.set = _listCacheSet;

/* harmony default export */ var _ListCache = (ListCache);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_stackClear.js


/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new _ListCache;
  this.size = 0;
}

/* harmony default export */ var _stackClear = (stackClear);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_stackDelete.js
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/* harmony default export */ var _stackDelete = (stackDelete);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_stackGet.js
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/* harmony default export */ var _stackGet = (stackGet);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_stackHas.js
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/* harmony default export */ var _stackHas = (stackHas);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_getNative.js
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/* harmony default export */ var _getNative = (getValue);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash-es/_root.js
var _root = __webpack_require__("fw2E");

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_Map.js



/* Built-in method references that are verified to be native. */
var Map = _getNative(_root["a" /* default */], 'Map');

/* harmony default export */ var _Map = (Map);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_nativeCreate.js


/* Built-in method references that are verified to be native. */
var nativeCreate = _getNative(Object, 'create');

/* harmony default export */ var _nativeCreate = (nativeCreate);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_hashClear.js


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
  this.size = 0;
}

/* harmony default export */ var _hashClear = (hashClear);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_hashDelete.js
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/* harmony default export */ var _hashDelete = (hashDelete);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_hashGet.js


/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var _hashGet_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _hashGet_hasOwnProperty = _hashGet_objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (_nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return _hashGet_hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/* harmony default export */ var _hashGet = (hashGet);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_hashHas.js


/** Used for built-in method references. */
var _hashHas_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _hashHas_hasOwnProperty = _hashHas_objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return _nativeCreate ? (data[key] !== undefined) : _hashHas_hasOwnProperty.call(data, key);
}

/* harmony default export */ var _hashHas = (hashHas);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_hashSet.js


/** Used to stand-in for `undefined` hash values. */
var _hashSet_HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (_nativeCreate && value === undefined) ? _hashSet_HASH_UNDEFINED : value;
  return this;
}

/* harmony default export */ var _hashSet = (hashSet);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_Hash.js






/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = _hashClear;
Hash.prototype['delete'] = _hashDelete;
Hash.prototype.get = _hashGet;
Hash.prototype.has = _hashHas;
Hash.prototype.set = _hashSet;

/* harmony default export */ var _Hash = (Hash);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_mapCacheClear.js




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new _Hash,
    'map': new (_Map || _ListCache),
    'string': new _Hash
  };
}

/* harmony default export */ var _mapCacheClear = (mapCacheClear);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_isKeyable.js
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/* harmony default export */ var _isKeyable = (isKeyable);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_getMapData.js


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return _isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/* harmony default export */ var _getMapData = (getMapData);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_mapCacheDelete.js


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = _getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/* harmony default export */ var _mapCacheDelete = (mapCacheDelete);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_mapCacheGet.js


/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return _getMapData(this, key).get(key);
}

/* harmony default export */ var _mapCacheGet = (mapCacheGet);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_mapCacheHas.js


/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return _getMapData(this, key).has(key);
}

/* harmony default export */ var _mapCacheHas = (mapCacheHas);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_mapCacheSet.js


/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = _getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/* harmony default export */ var _mapCacheSet = (mapCacheSet);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_MapCache.js






/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = _mapCacheClear;
MapCache.prototype['delete'] = _mapCacheDelete;
MapCache.prototype.get = _mapCacheGet;
MapCache.prototype.has = _mapCacheHas;
MapCache.prototype.set = _mapCacheSet;

/* harmony default export */ var _MapCache = (MapCache);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_stackSet.js




/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof _ListCache) {
    var pairs = data.__data__;
    if (!_Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new _MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

/* harmony default export */ var _stackSet = (stackSet);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_Stack.js







/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new _ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = _stackClear;
Stack.prototype['delete'] = _stackDelete;
Stack.prototype.get = _stackGet;
Stack.prototype.has = _stackHas;
Stack.prototype.set = _stackSet;

/* harmony default export */ var _Stack = (Stack);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_arrayEach.js
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/* harmony default export */ var _arrayEach = (arrayEach);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_defineProperty.js


var defineProperty = (function() {
  try {
    var func = _getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

/* harmony default export */ var _defineProperty = (defineProperty);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_baseAssignValue.js


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && _defineProperty) {
    _defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/* harmony default export */ var _baseAssignValue = (baseAssignValue);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_assignValue.js



/** Used for built-in method references. */
var _assignValue_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _assignValue_hasOwnProperty = _assignValue_objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(_assignValue_hasOwnProperty.call(object, key) && lodash_es_eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    _baseAssignValue(object, key, value);
  }
}

/* harmony default export */ var _assignValue = (assignValue);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_copyObject.js



/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      _baseAssignValue(object, key, newValue);
    } else {
      _assignValue(object, key, newValue);
    }
  }
  return object;
}

/* harmony default export */ var _copyObject = (copyObject);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/keys.js


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = _overArg(Object.keys, Object);

/* harmony default export */ var keys = (nativeKeys);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_baseAssign.js



/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && _copyObject(source, keys(source), object);
}

/* harmony default export */ var _baseAssign = (baseAssign);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/keysIn.js
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ var keysIn = (nativeKeysIn);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_baseAssignIn.js



/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && _copyObject(source, keysIn(source), object);
}

/* harmony default export */ var _baseAssignIn = (baseAssignIn);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash-es/_cloneBuffer.js
var _cloneBuffer = __webpack_require__("1vCq");

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_copyArray.js
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/* harmony default export */ var _copyArray = (copyArray);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_getSymbols.js
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/* harmony default export */ var _getSymbols = (stubArray);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_copySymbols.js



/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return _copyObject(source, _getSymbols(source), object);
}

/* harmony default export */ var _copySymbols = (copySymbols);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_getSymbolsIn.js
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function _getSymbolsIn_stubArray() {
  return [];
}

/* harmony default export */ var _getSymbolsIn = (_getSymbolsIn_stubArray);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_copySymbolsIn.js



/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return _copyObject(source, _getSymbolsIn(source), object);
}

/* harmony default export */ var _copySymbolsIn = (copySymbolsIn);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_getAllKeys.js


/* Built-in method references for those with the same name as other `lodash` methods. */
var _getAllKeys_nativeKeys = _overArg(Object.keys, Object);

/* harmony default export */ var _getAllKeys = (_getAllKeys_nativeKeys);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_getAllKeysIn.js
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function _getAllKeysIn_nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ var _getAllKeysIn = (_getAllKeysIn_nativeKeysIn);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_getTag.js
/** Used for built-in method references. */
var _getTag_objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var _getTag_nativeObjectToString = _getTag_objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function _getTag_objectToString(value) {
  return _getTag_nativeObjectToString.call(value);
}

/* harmony default export */ var _getTag = (_getTag_objectToString);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_initCloneArray.js
/** Used for built-in method references. */
var _initCloneArray_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _initCloneArray_hasOwnProperty = _initCloneArray_objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && _initCloneArray_hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/* harmony default export */ var _initCloneArray = (initCloneArray);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_initCloneByTag.js
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/* harmony default export */ var _initCloneByTag = (identity);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/isObject.js
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/* harmony default export */ var lodash_es_isObject = (isObject);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_baseCreate.js


/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!lodash_es_isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

/* harmony default export */ var _baseCreate = (baseCreate);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_isPrototype.js
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/* harmony default export */ var _isPrototype = (stubFalse);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_initCloneObject.js




/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !_isPrototype(object))
    ? _baseCreate(_getPrototype(object))
    : {};
}

/* harmony default export */ var _initCloneObject = (initCloneObject);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/isArray.js
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/* harmony default export */ var lodash_es_isArray = (isArray);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/isBuffer.js
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function isBuffer_stubFalse() {
  return false;
}

/* harmony default export */ var isBuffer = (isBuffer_stubFalse);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/isMap.js
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function isMap_stubFalse() {
  return false;
}

/* harmony default export */ var isMap = (isMap_stubFalse);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/isSet.js
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function isSet_stubFalse() {
  return false;
}

/* harmony default export */ var isSet = (isSet_stubFalse);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_baseClone.js























/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    _baseClone_objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[_baseClone_objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!lodash_es_isObject(value)) {
    return value;
  }
  var isArr = lodash_es_isArray(value);
  if (isArr) {
    result = _initCloneArray(value);
    if (!isDeep) {
      return _copyArray(value, result);
    }
  } else {
    var tag = _getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return Object(_cloneBuffer["a" /* default */])(value, isDeep);
    }
    if (tag == _baseClone_objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : _initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? _copySymbolsIn(value, _baseAssignIn(result, value))
          : _copySymbols(value, _baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = _initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new _Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? _getAllKeysIn : _getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  _arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    _assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

/* harmony default export */ var _baseClone = (baseClone);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/clone.js


/** Used to compose bitmasks for cloning. */
var clone_CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return _baseClone(value, clone_CLONE_SYMBOLS_FLAG);
}

/* harmony default export */ var lodash_es_clone = (clone);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_arrayMap.js
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/* harmony default export */ var _arrayMap = (arrayMap);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/isSymbol.js
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function isSymbol_stubFalse() {
  return false;
}

/* harmony default export */ var isSymbol = (isSymbol_stubFalse);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/memoize.js


/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || _MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = _MapCache;

/* harmony default export */ var lodash_es_memoize = (memoize);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_memoizeCapped.js


/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = lodash_es_memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

/* harmony default export */ var _memoizeCapped = (memoizeCapped);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_stringToPath.js


/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = _memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/* harmony default export */ var _stringToPath = (stringToPath);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_toKey.js


/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/* harmony default export */ var _toKey = (toKey);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_Symbol.js


/** Built-in value references. */
var _Symbol_Symbol = _root["a" /* default */].Symbol;

/* harmony default export */ var _Symbol = (_Symbol_Symbol);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_baseToString.js





/** Used as references for various `Number` constants. */
var _baseToString_INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (lodash_es_isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return _arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -_baseToString_INFINITY) ? '-0' : result;
}

/* harmony default export */ var _baseToString = (baseToString);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/toString.js


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString_toString(value) {
  return value == null ? '' : _baseToString(value);
}

/* harmony default export */ var lodash_es_toString = (toString_toString);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/toPath.js








/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (lodash_es_isArray(value)) {
    return _arrayMap(value, _toKey);
  }
  return isSymbol(value) ? [value] : _copyArray(_stringToPath(lodash_es_toString(value)));
}

/* harmony default export */ var lodash_es_toPath = (toPath);

// CONCATENATED MODULE: /opt/webapp/node_modules/tiny-warning/dist/tiny-warning.esm.js
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* harmony default export */ var tiny_warning_esm = (warning);

// EXTERNAL MODULE: /opt/webapp/node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__("oXkQ");
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/cloneDeep.js


/** Used to compose bitmasks for cloning. */
var cloneDeep_CLONE_DEEP_FLAG = 1,
    cloneDeep_CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return _baseClone(value, cloneDeep_CLONE_DEEP_FLAG | cloneDeep_CLONE_SYMBOLS_FLAG);
}

/* harmony default export */ var lodash_es_cloneDeep = (cloneDeep);

// CONCATENATED MODULE: /opt/webapp/node_modules/formik/dist/formik.esm.js










function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/** @private is the value an empty array? */

var isEmptyArray = function isEmptyArray(value) {
  return Array.isArray(value) && value.length === 0;
};
/** @private is the given object a Function? */

var isFunction = function isFunction(obj) {
  return typeof obj === 'function';
};
/** @private is the given object an Object? */

var formik_esm_isObject = function isObject(obj) {
  return obj !== null && typeof obj === 'object';
};
/** @private is the given object an integer? */

var isInteger = function isInteger(obj) {
  return String(Math.floor(Number(obj))) === obj;
};
/** @private is the given object a string? */

var isString = function isString(obj) {
  return Object.prototype.toString.call(obj) === '[object String]';
};
/** @private is the given object a NaN? */
// eslint-disable-next-line no-self-compare

var isNaN$1 = function isNaN(obj) {
  return obj !== obj;
};
/** @private Does a React component have exactly 0 children? */

var formik_esm_isEmptyChildren = function isEmptyChildren(children) {
  return react["Children"].count(children) === 0;
};
/** @private is the given object/value a promise? */

var isPromise = function isPromise(value) {
  return formik_esm_isObject(value) && isFunction(value.then);
};
/** @private is the given object/value a type of synthetic event? */

var isInputEvent = function isInputEvent(value) {
  return value && formik_esm_isObject(value) && formik_esm_isObject(value.target);
};
/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?Document} doc Defaults to current document.
 * @return {Element | null}
 * @see https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/dom/getActiveElement.js
 */

function getActiveElement(doc) {
  doc = doc || (typeof document !== 'undefined' ? document : undefined);

  if (typeof doc === 'undefined') {
    return null;
  }

  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}
/**
 * Deeply get a value from an object via its path.
 */

function getIn(obj, key, def, p) {
  if (p === void 0) {
    p = 0;
  }

  var path = lodash_es_toPath(key);

  while (obj && p < path.length) {
    obj = obj[path[p++]];
  }

  return obj === undefined ? def : obj;
}
/**
 * Deeply set a value from in object via it's path. If the value at `path`
 * has changed, return a shallow copy of obj with `value` set at `path`.
 * If `value` has not changed, return the original `obj`.
 *
 * Existing objects / arrays along `path` are also shallow copied. Sibling
 * objects along path retain the same internal js reference. Since new
 * objects / arrays are only created along `path`, we can test if anything
 * changed in a nested structure by comparing the object's reference in
 * the old and new object, similar to how russian doll cache invalidation
 * works.
 *
 * In earlier versions of this function, which used cloneDeep, there were
 * issues whereby settings a nested value would mutate the parent
 * instead of creating a new object. `clone` avoids that bug making a
 * shallow copy of the objects along the update path
 * so no object is mutated in place.
 *
 * Before changing this function, please read through the following
 * discussions.
 *
 * @see https://github.com/developit/linkstate
 * @see https://github.com/jaredpalmer/formik/pull/123
 */

function setIn(obj, path, value) {
  var res = lodash_es_clone(obj); // this keeps inheritance when obj is a class

  var resVal = res;
  var i = 0;
  var pathArray = lodash_es_toPath(path);

  for (; i < pathArray.length - 1; i++) {
    var currentPath = pathArray[i];
    var currentObj = getIn(obj, pathArray.slice(0, i + 1));

    if (currentObj && (formik_esm_isObject(currentObj) || Array.isArray(currentObj))) {
      resVal = resVal[currentPath] = lodash_es_clone(currentObj);
    } else {
      var nextPath = pathArray[i + 1];
      resVal = resVal[currentPath] = isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
    }
  } // Return original object if new value is the same as current


  if ((i === 0 ? obj : resVal)[pathArray[i]] === value) {
    return obj;
  }

  if (value === undefined) {
    delete resVal[pathArray[i]];
  } else {
    resVal[pathArray[i]] = value;
  } // If the path array has a single element, the loop did not run.
  // Deleting on `resVal` had no effect in this scenario, so we delete on the result instead.


  if (i === 0 && value === undefined) {
    delete res[pathArray[i]];
  }

  return res;
}
/**
 * Recursively a set the same value for all keys and arrays nested object, cloning
 * @param object
 * @param value
 * @param visited
 * @param response
 */

function setNestedObjectValues(object, value, visited, response) {
  if (visited === void 0) {
    visited = new WeakMap();
  }

  if (response === void 0) {
    response = {};
  }

  for (var _i = 0, _Object$keys = Object.keys(object); _i < _Object$keys.length; _i++) {
    var k = _Object$keys[_i];
    var val = object[k];

    if (formik_esm_isObject(val)) {
      if (!visited.get(val)) {
        visited.set(val, true); // In order to keep array values consistent for both dot path  and
        // bracket syntax, we need to check if this is an array so that
        // this will output  { friends: [true] } and not { friends: { "0": true } }

        response[k] = Array.isArray(val) ? [] : {};
        setNestedObjectValues(val, value, visited, response[k]);
      }
    } else {
      response[k] = value;
    }
  }

  return response;
}

var FormikContext = /*#__PURE__*/Object(react["createContext"])(undefined);
FormikContext.displayName = 'FormikContext';
var FormikProvider = FormikContext.Provider;
var FormikConsumer = FormikContext.Consumer;
function useFormikContext() {
  var formik = Object(react["useContext"])(FormikContext);
  !!!formik ?  false ? undefined : tiny_warning_esm(false) : void 0;
  return formik;
}

function formikReducer(state, msg) {
  switch (msg.type) {
    case 'SET_VALUES':
      return _extends({}, state, {
        values: msg.payload
      });

    case 'SET_TOUCHED':
      return _extends({}, state, {
        touched: msg.payload
      });

    case 'SET_ERRORS':
      if (react_fast_compare_default()(state.errors, msg.payload)) {
        return state;
      }

      return _extends({}, state, {
        errors: msg.payload
      });

    case 'SET_STATUS':
      return _extends({}, state, {
        status: msg.payload
      });

    case 'SET_ISSUBMITTING':
      return _extends({}, state, {
        isSubmitting: msg.payload
      });

    case 'SET_ISVALIDATING':
      return _extends({}, state, {
        isValidating: msg.payload
      });

    case 'SET_FIELD_VALUE':
      return _extends({}, state, {
        values: setIn(state.values, msg.payload.field, msg.payload.value)
      });

    case 'SET_FIELD_TOUCHED':
      return _extends({}, state, {
        touched: setIn(state.touched, msg.payload.field, msg.payload.value)
      });

    case 'SET_FIELD_ERROR':
      return _extends({}, state, {
        errors: setIn(state.errors, msg.payload.field, msg.payload.value)
      });

    case 'RESET_FORM':
      return _extends({}, state, msg.payload);

    case 'SET_FORMIK_STATE':
      return msg.payload(state);

    case 'SUBMIT_ATTEMPT':
      return _extends({}, state, {
        touched: setNestedObjectValues(state.values, true),
        isSubmitting: true,
        submitCount: state.submitCount + 1
      });

    case 'SUBMIT_FAILURE':
      return _extends({}, state, {
        isSubmitting: false
      });

    case 'SUBMIT_SUCCESS':
      return _extends({}, state, {
        isSubmitting: false
      });

    default:
      return state;
  }
} // Initial empty states // objects


var emptyErrors = {};
var emptyTouched = {};
function useFormik(_ref) {
  var _ref$validateOnChange = _ref.validateOnChange,
      validateOnChange = _ref$validateOnChange === void 0 ? true : _ref$validateOnChange,
      _ref$validateOnBlur = _ref.validateOnBlur,
      validateOnBlur = _ref$validateOnBlur === void 0 ? true : _ref$validateOnBlur,
      _ref$validateOnMount = _ref.validateOnMount,
      validateOnMount = _ref$validateOnMount === void 0 ? false : _ref$validateOnMount,
      isInitialValid = _ref.isInitialValid,
      _ref$enableReinitiali = _ref.enableReinitialize,
      enableReinitialize = _ref$enableReinitiali === void 0 ? false : _ref$enableReinitiali,
      onSubmit = _ref.onSubmit,
      rest = _objectWithoutPropertiesLoose(_ref, ["validateOnChange", "validateOnBlur", "validateOnMount", "isInitialValid", "enableReinitialize", "onSubmit"]);

  var props = _extends({
    validateOnChange: validateOnChange,
    validateOnBlur: validateOnBlur,
    validateOnMount: validateOnMount,
    onSubmit: onSubmit
  }, rest);

  var initialValues = Object(react["useRef"])(props.initialValues);
  var initialErrors = Object(react["useRef"])(props.initialErrors || emptyErrors);
  var initialTouched = Object(react["useRef"])(props.initialTouched || emptyTouched);
  var initialStatus = Object(react["useRef"])(props.initialStatus);
  var isMounted = Object(react["useRef"])(false);
  var fieldRegistry = Object(react["useRef"])({});

  if (false) {}

  Object(react["useEffect"])(function () {
    isMounted.current = true;
    return function () {
      isMounted.current = false;
    };
  }, []);

  var _React$useReducer = Object(react["useReducer"])(formikReducer, {
    values: props.initialValues,
    errors: props.initialErrors || emptyErrors,
    touched: props.initialTouched || emptyTouched,
    status: props.initialStatus,
    isSubmitting: false,
    isValidating: false,
    submitCount: 0
  }),
      state = _React$useReducer[0],
      dispatch = _React$useReducer[1];

  var runValidateHandler = Object(react["useCallback"])(function (values, field) {
    return new Promise(function (resolve, reject) {
      var maybePromisedErrors = props.validate(values, field);

      if (maybePromisedErrors == null) {
        // use loose null check here on purpose
        resolve(emptyErrors);
      } else if (isPromise(maybePromisedErrors)) {
        maybePromisedErrors.then(function (errors) {
          resolve(errors || emptyErrors);
        }, function (actualException) {
          if (false) {}

          reject(actualException);
        });
      } else {
        resolve(maybePromisedErrors);
      }
    });
  }, [props.validate]);
  /**
   * Run validation against a Yup schema and optionally run a function if successful
   */

  var runValidationSchema = Object(react["useCallback"])(function (values, field) {
    var validationSchema = props.validationSchema;
    var schema = isFunction(validationSchema) ? validationSchema(field) : validationSchema;
    var promise = field && schema.validateAt ? schema.validateAt(field, values) : validateYupSchema(values, schema);
    return new Promise(function (resolve, reject) {
      promise.then(function () {
        resolve(emptyErrors);
      }, function (err) {
        // Yup will throw a validation error if validation fails. We catch those and
        // resolve them into Formik errors. We can sniff if something is a Yup error
        // by checking error.name.
        // @see https://github.com/jquense/yup#validationerrorerrors-string--arraystring-value-any-path-string
        if (err.name === 'ValidationError') {
          resolve(yupToFormErrors(err));
        } else {
          // We throw any other errors
          if (false) {}

          reject(err);
        }
      });
    });
  }, [props.validationSchema]);
  var runSingleFieldLevelValidation = Object(react["useCallback"])(function (field, value) {
    return new Promise(function (resolve) {
      return resolve(fieldRegistry.current[field].validate(value));
    });
  }, []);
  var runFieldLevelValidations = Object(react["useCallback"])(function (values) {
    var fieldKeysWithValidation = Object.keys(fieldRegistry.current).filter(function (f) {
      return isFunction(fieldRegistry.current[f].validate);
    }); // Construct an array with all of the field validation functions

    var fieldValidations = fieldKeysWithValidation.length > 0 ? fieldKeysWithValidation.map(function (f) {
      return runSingleFieldLevelValidation(f, getIn(values, f));
    }) : [Promise.resolve('DO_NOT_DELETE_YOU_WILL_BE_FIRED')]; // use special case ;)

    return Promise.all(fieldValidations).then(function (fieldErrorsList) {
      return fieldErrorsList.reduce(function (prev, curr, index) {
        if (curr === 'DO_NOT_DELETE_YOU_WILL_BE_FIRED') {
          return prev;
        }

        if (curr) {
          prev = setIn(prev, fieldKeysWithValidation[index], curr);
        }

        return prev;
      }, {});
    });
  }, [runSingleFieldLevelValidation]); // Run all validations and return the result

  var runAllValidations = Object(react["useCallback"])(function (values) {
    return Promise.all([runFieldLevelValidations(values), props.validationSchema ? runValidationSchema(values) : {}, props.validate ? runValidateHandler(values) : {}]).then(function (_ref2) {
      var fieldErrors = _ref2[0],
          schemaErrors = _ref2[1],
          validateErrors = _ref2[2];
      var combinedErrors = es.all([fieldErrors, schemaErrors, validateErrors], {
        arrayMerge: arrayMerge
      });
      return combinedErrors;
    });
  }, [props.validate, props.validationSchema, runFieldLevelValidations, runValidateHandler, runValidationSchema]); // Run all validations methods and update state accordingly

  var validateFormWithHighPriority = useEventCallback(function (values) {
    if (values === void 0) {
      values = state.values;
    }

    dispatch({
      type: 'SET_ISVALIDATING',
      payload: true
    });
    return runAllValidations(values).then(function (combinedErrors) {
      if (!!isMounted.current) {
        dispatch({
          type: 'SET_ISVALIDATING',
          payload: false
        });
        dispatch({
          type: 'SET_ERRORS',
          payload: combinedErrors
        });
      }

      return combinedErrors;
    });
  });
  Object(react["useEffect"])(function () {
    if (validateOnMount && isMounted.current === true && react_fast_compare_default()(initialValues.current, props.initialValues)) {
      validateFormWithHighPriority(initialValues.current);
    }
  }, [validateOnMount, validateFormWithHighPriority]);
  var resetForm = Object(react["useCallback"])(function (nextState) {
    var values = nextState && nextState.values ? nextState.values : initialValues.current;
    var errors = nextState && nextState.errors ? nextState.errors : initialErrors.current ? initialErrors.current : props.initialErrors || {};
    var touched = nextState && nextState.touched ? nextState.touched : initialTouched.current ? initialTouched.current : props.initialTouched || {};
    var status = nextState && nextState.status ? nextState.status : initialStatus.current ? initialStatus.current : props.initialStatus;
    initialValues.current = values;
    initialErrors.current = errors;
    initialTouched.current = touched;
    initialStatus.current = status;

    var dispatchFn = function dispatchFn() {
      dispatch({
        type: 'RESET_FORM',
        payload: {
          isSubmitting: !!nextState && !!nextState.isSubmitting,
          errors: errors,
          touched: touched,
          status: status,
          values: values,
          isValidating: !!nextState && !!nextState.isValidating,
          submitCount: !!nextState && !!nextState.submitCount && typeof nextState.submitCount === 'number' ? nextState.submitCount : 0
        }
      });
    };

    if (props.onReset) {
      var maybePromisedOnReset = props.onReset(state.values, imperativeMethods);

      if (isPromise(maybePromisedOnReset)) {
        maybePromisedOnReset.then(dispatchFn);
      } else {
        dispatchFn();
      }
    } else {
      dispatchFn();
    }
  }, [props.initialErrors, props.initialStatus, props.initialTouched]);
  Object(react["useEffect"])(function () {
    if (isMounted.current === true && !react_fast_compare_default()(initialValues.current, props.initialValues)) {
      if (enableReinitialize) {
        initialValues.current = props.initialValues;
        resetForm();
      }

      if (validateOnMount) {
        validateFormWithHighPriority(initialValues.current);
      }
    }
  }, [enableReinitialize, props.initialValues, resetForm, validateOnMount, validateFormWithHighPriority]);
  Object(react["useEffect"])(function () {
    if (enableReinitialize && isMounted.current === true && !react_fast_compare_default()(initialErrors.current, props.initialErrors)) {
      initialErrors.current = props.initialErrors || emptyErrors;
      dispatch({
        type: 'SET_ERRORS',
        payload: props.initialErrors || emptyErrors
      });
    }
  }, [enableReinitialize, props.initialErrors]);
  Object(react["useEffect"])(function () {
    if (enableReinitialize && isMounted.current === true && !react_fast_compare_default()(initialTouched.current, props.initialTouched)) {
      initialTouched.current = props.initialTouched || emptyTouched;
      dispatch({
        type: 'SET_TOUCHED',
        payload: props.initialTouched || emptyTouched
      });
    }
  }, [enableReinitialize, props.initialTouched]);
  Object(react["useEffect"])(function () {
    if (enableReinitialize && isMounted.current === true && !react_fast_compare_default()(initialStatus.current, props.initialStatus)) {
      initialStatus.current = props.initialStatus;
      dispatch({
        type: 'SET_STATUS',
        payload: props.initialStatus
      });
    }
  }, [enableReinitialize, props.initialStatus, props.initialTouched]);
  var validateField = useEventCallback(function (name) {
    // This will efficiently validate a single field by avoiding state
    // changes if the validation function is synchronous. It's different from
    // what is called when using validateForm.
    if (fieldRegistry.current[name] && isFunction(fieldRegistry.current[name].validate)) {
      var value = getIn(state.values, name);
      var maybePromise = fieldRegistry.current[name].validate(value);

      if (isPromise(maybePromise)) {
        // Only flip isValidating if the function is async.
        dispatch({
          type: 'SET_ISVALIDATING',
          payload: true
        });
        return maybePromise.then(function (x) {
          return x;
        }).then(function (error) {
          dispatch({
            type: 'SET_FIELD_ERROR',
            payload: {
              field: name,
              value: error
            }
          });
          dispatch({
            type: 'SET_ISVALIDATING',
            payload: false
          });
        });
      } else {
        dispatch({
          type: 'SET_FIELD_ERROR',
          payload: {
            field: name,
            value: maybePromise
          }
        });
        return Promise.resolve(maybePromise);
      }
    } else if (props.validationSchema) {
      dispatch({
        type: 'SET_ISVALIDATING',
        payload: true
      });
      return runValidationSchema(state.values, name).then(function (x) {
        return x;
      }).then(function (error) {
        dispatch({
          type: 'SET_FIELD_ERROR',
          payload: {
            field: name,
            value: error[name]
          }
        });
        dispatch({
          type: 'SET_ISVALIDATING',
          payload: false
        });
      });
    }

    return Promise.resolve();
  });
  var registerField = Object(react["useCallback"])(function (name, _ref3) {
    var validate = _ref3.validate;
    fieldRegistry.current[name] = {
      validate: validate
    };
  }, []);
  var unregisterField = Object(react["useCallback"])(function (name) {
    delete fieldRegistry.current[name];
  }, []);
  var setTouched = useEventCallback(function (touched, shouldValidate) {
    dispatch({
      type: 'SET_TOUCHED',
      payload: touched
    });
    var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
    return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
  });
  var setErrors = Object(react["useCallback"])(function (errors) {
    dispatch({
      type: 'SET_ERRORS',
      payload: errors
    });
  }, []);
  var setValues = useEventCallback(function (values, shouldValidate) {
    var resolvedValues = isFunction(values) ? values(state.values) : values;
    dispatch({
      type: 'SET_VALUES',
      payload: resolvedValues
    });
    var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
    return willValidate ? validateFormWithHighPriority(resolvedValues) : Promise.resolve();
  });
  var setFieldError = Object(react["useCallback"])(function (field, value) {
    dispatch({
      type: 'SET_FIELD_ERROR',
      payload: {
        field: field,
        value: value
      }
    });
  }, []);
  var setFieldValue = useEventCallback(function (field, value, shouldValidate) {
    dispatch({
      type: 'SET_FIELD_VALUE',
      payload: {
        field: field,
        value: value
      }
    });
    var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
    return willValidate ? validateFormWithHighPriority(setIn(state.values, field, value)) : Promise.resolve();
  });
  var executeChange = Object(react["useCallback"])(function (eventOrTextValue, maybePath) {
    // By default, assume that the first argument is a string. This allows us to use
    // handleChange with React Native and React Native Web's onChangeText prop which
    // provides just the value of the input.
    var field = maybePath;
    var val = eventOrTextValue;
    var parsed; // If the first argument is not a string though, it has to be a synthetic React Event (or a fake one),
    // so we handle like we would a normal HTML change event.

    if (!isString(eventOrTextValue)) {
      // If we can, persist the event
      // @see https://reactjs.org/docs/events.html#event-pooling
      if (eventOrTextValue.persist) {
        eventOrTextValue.persist();
      }

      var target = eventOrTextValue.target ? eventOrTextValue.target : eventOrTextValue.currentTarget;
      var type = target.type,
          name = target.name,
          id = target.id,
          value = target.value,
          checked = target.checked,
          outerHTML = target.outerHTML,
          options = target.options,
          multiple = target.multiple;
      field = maybePath ? maybePath : name ? name : id;

      if (!field && "production" !== "production") {
        warnAboutMissingIdentifier({
          htmlContent: outerHTML,
          documentationAnchorLink: 'handlechange-e-reactchangeeventany--void',
          handlerName: 'handleChange'
        });
      }

      val = /number|range/.test(type) ? (parsed = parseFloat(value), isNaN(parsed) ? '' : parsed) : /checkbox/.test(type) // checkboxes
      ? getValueForCheckbox(getIn(state.values, field), checked, value) : options && multiple // <select multiple>
      ? getSelectedValues(options) : value;
    }

    if (field) {
      // Set form fields by name
      setFieldValue(field, val);
    }
  }, [setFieldValue, state.values]);
  var handleChange = useEventCallback(function (eventOrPath) {
    if (isString(eventOrPath)) {
      return function (event) {
        return executeChange(event, eventOrPath);
      };
    } else {
      executeChange(eventOrPath);
    }
  });
  var setFieldTouched = useEventCallback(function (field, touched, shouldValidate) {
    if (touched === void 0) {
      touched = true;
    }

    dispatch({
      type: 'SET_FIELD_TOUCHED',
      payload: {
        field: field,
        value: touched
      }
    });
    var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
    return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
  });
  var executeBlur = Object(react["useCallback"])(function (e, path) {
    if (e.persist) {
      e.persist();
    }

    var _e$target = e.target,
        name = _e$target.name,
        id = _e$target.id,
        outerHTML = _e$target.outerHTML;
    var field = path ? path : name ? name : id;

    if (!field && "production" !== "production") {
      warnAboutMissingIdentifier({
        htmlContent: outerHTML,
        documentationAnchorLink: 'handleblur-e-any--void',
        handlerName: 'handleBlur'
      });
    }

    setFieldTouched(field, true);
  }, [setFieldTouched]);
  var handleBlur = useEventCallback(function (eventOrString) {
    if (isString(eventOrString)) {
      return function (event) {
        return executeBlur(event, eventOrString);
      };
    } else {
      executeBlur(eventOrString);
    }
  });
  var setFormikState = Object(react["useCallback"])(function (stateOrCb) {
    if (isFunction(stateOrCb)) {
      dispatch({
        type: 'SET_FORMIK_STATE',
        payload: stateOrCb
      });
    } else {
      dispatch({
        type: 'SET_FORMIK_STATE',
        payload: function payload() {
          return stateOrCb;
        }
      });
    }
  }, []);
  var setStatus = Object(react["useCallback"])(function (status) {
    dispatch({
      type: 'SET_STATUS',
      payload: status
    });
  }, []);
  var setSubmitting = Object(react["useCallback"])(function (isSubmitting) {
    dispatch({
      type: 'SET_ISSUBMITTING',
      payload: isSubmitting
    });
  }, []);
  var submitForm = useEventCallback(function () {
    dispatch({
      type: 'SUBMIT_ATTEMPT'
    });
    return validateFormWithHighPriority().then(function (combinedErrors) {
      // In case an error was thrown and passed to the resolved Promise,
      // `combinedErrors` can be an instance of an Error. We need to check
      // that and abort the submit.
      // If we don't do that, calling `Object.keys(new Error())` yields an
      // empty array, which causes the validation to pass and the form
      // to be submitted.
      var isInstanceOfError = combinedErrors instanceof Error;
      var isActuallyValid = !isInstanceOfError && Object.keys(combinedErrors).length === 0;

      if (isActuallyValid) {
        // Proceed with submit...
        //
        // To respect sync submit fns, we can't simply wrap executeSubmit in a promise and
        // _always_ dispatch SUBMIT_SUCCESS because isSubmitting would then always be false.
        // This would be fine in simple cases, but make it impossible to disable submit
        // buttons where people use callbacks or promises as side effects (which is basically
        // all of v1 Formik code). Instead, recall that we are inside of a promise chain already,
        //  so we can try/catch executeSubmit(), if it returns undefined, then just bail.
        // If there are errors, throw em. Otherwise, wrap executeSubmit in a promise and handle
        // cleanup of isSubmitting on behalf of the consumer.
        var promiseOrUndefined;

        try {
          promiseOrUndefined = executeSubmit(); // Bail if it's sync, consumer is responsible for cleaning up
          // via setSubmitting(false)

          if (promiseOrUndefined === undefined) {
            return;
          }
        } catch (error) {
          throw error;
        }

        return Promise.resolve(promiseOrUndefined).then(function (result) {
          if (!!isMounted.current) {
            dispatch({
              type: 'SUBMIT_SUCCESS'
            });
          }

          return result;
        })["catch"](function (_errors) {
          if (!!isMounted.current) {
            dispatch({
              type: 'SUBMIT_FAILURE'
            }); // This is a legit error rejected by the onSubmit fn
            // so we don't want to break the promise chain

            throw _errors;
          }
        });
      } else if (!!isMounted.current) {
        // ^^^ Make sure Formik is still mounted before updating state
        dispatch({
          type: 'SUBMIT_FAILURE'
        }); // throw combinedErrors;

        if (isInstanceOfError) {
          throw combinedErrors;
        }
      }

      return;
    });
  });
  var handleSubmit = useEventCallback(function (e) {
    if (e && e.preventDefault && isFunction(e.preventDefault)) {
      e.preventDefault();
    }

    if (e && e.stopPropagation && isFunction(e.stopPropagation)) {
      e.stopPropagation();
    } // Warn if form submission is triggered by a <button> without a
    // specified `type` attribute during development. This mitigates
    // a common gotcha in forms with both reset and submit buttons,
    // where the dev forgets to add type="button" to the reset button.


    if (false) { var activeElement; }

    submitForm()["catch"](function (reason) {
      console.warn("Warning: An unhandled error was caught from submitForm()", reason);
    });
  });
  var imperativeMethods = {
    resetForm: resetForm,
    validateForm: validateFormWithHighPriority,
    validateField: validateField,
    setErrors: setErrors,
    setFieldError: setFieldError,
    setFieldTouched: setFieldTouched,
    setFieldValue: setFieldValue,
    setStatus: setStatus,
    setSubmitting: setSubmitting,
    setTouched: setTouched,
    setValues: setValues,
    setFormikState: setFormikState,
    submitForm: submitForm
  };
  var executeSubmit = useEventCallback(function () {
    return onSubmit(state.values, imperativeMethods);
  });
  var handleReset = useEventCallback(function (e) {
    if (e && e.preventDefault && isFunction(e.preventDefault)) {
      e.preventDefault();
    }

    if (e && e.stopPropagation && isFunction(e.stopPropagation)) {
      e.stopPropagation();
    }

    resetForm();
  });
  var getFieldMeta = Object(react["useCallback"])(function (name) {
    return {
      value: getIn(state.values, name),
      error: getIn(state.errors, name),
      touched: !!getIn(state.touched, name),
      initialValue: getIn(initialValues.current, name),
      initialTouched: !!getIn(initialTouched.current, name),
      initialError: getIn(initialErrors.current, name)
    };
  }, [state.errors, state.touched, state.values]);
  var getFieldHelpers = Object(react["useCallback"])(function (name) {
    return {
      setValue: function setValue(value, shouldValidate) {
        return setFieldValue(name, value, shouldValidate);
      },
      setTouched: function setTouched(value, shouldValidate) {
        return setFieldTouched(name, value, shouldValidate);
      },
      setError: function setError(value) {
        return setFieldError(name, value);
      }
    };
  }, [setFieldValue, setFieldTouched, setFieldError]);
  var getFieldProps = Object(react["useCallback"])(function (nameOrOptions) {
    var isAnObject = formik_esm_isObject(nameOrOptions);
    var name = isAnObject ? nameOrOptions.name : nameOrOptions;
    var valueState = getIn(state.values, name);
    var field = {
      name: name,
      value: valueState,
      onChange: handleChange,
      onBlur: handleBlur
    };

    if (isAnObject) {
      var type = nameOrOptions.type,
          valueProp = nameOrOptions.value,
          is = nameOrOptions.as,
          multiple = nameOrOptions.multiple;

      if (type === 'checkbox') {
        if (valueProp === undefined) {
          field.checked = !!valueState;
        } else {
          field.checked = !!(Array.isArray(valueState) && ~valueState.indexOf(valueProp));
          field.value = valueProp;
        }
      } else if (type === 'radio') {
        field.checked = valueState === valueProp;
        field.value = valueProp;
      } else if (is === 'select' && multiple) {
        field.value = field.value || [];
        field.multiple = true;
      }
    }

    return field;
  }, [handleBlur, handleChange, state.values]);
  var dirty = Object(react["useMemo"])(function () {
    return !react_fast_compare_default()(initialValues.current, state.values);
  }, [initialValues.current, state.values]);
  var isValid = Object(react["useMemo"])(function () {
    return typeof isInitialValid !== 'undefined' ? dirty ? state.errors && Object.keys(state.errors).length === 0 : isInitialValid !== false && isFunction(isInitialValid) ? isInitialValid(props) : isInitialValid : state.errors && Object.keys(state.errors).length === 0;
  }, [isInitialValid, dirty, state.errors, props]);

  var ctx = _extends({}, state, {
    initialValues: initialValues.current,
    initialErrors: initialErrors.current,
    initialTouched: initialTouched.current,
    initialStatus: initialStatus.current,
    handleBlur: handleBlur,
    handleChange: handleChange,
    handleReset: handleReset,
    handleSubmit: handleSubmit,
    resetForm: resetForm,
    setErrors: setErrors,
    setFormikState: setFormikState,
    setFieldTouched: setFieldTouched,
    setFieldValue: setFieldValue,
    setFieldError: setFieldError,
    setStatus: setStatus,
    setSubmitting: setSubmitting,
    setTouched: setTouched,
    setValues: setValues,
    submitForm: submitForm,
    validateForm: validateFormWithHighPriority,
    validateField: validateField,
    isValid: isValid,
    dirty: dirty,
    unregisterField: unregisterField,
    registerField: registerField,
    getFieldProps: getFieldProps,
    getFieldMeta: getFieldMeta,
    getFieldHelpers: getFieldHelpers,
    validateOnBlur: validateOnBlur,
    validateOnChange: validateOnChange,
    validateOnMount: validateOnMount
  });

  return ctx;
}
function Formik(props) {
  var formikbag = useFormik(props);
  var component = props.component,
      children = props.children,
      render = props.render,
      innerRef = props.innerRef; // This allows folks to pass a ref to <Formik />

  Object(react["useImperativeHandle"])(innerRef, function () {
    return formikbag;
  });

  if (false) {}

  return Object(react["createElement"])(FormikProvider, {
    value: formikbag
  }, component ? Object(react["createElement"])(component, formikbag) : render ? render(formikbag) : children // children come last, always called
  ? isFunction(children) ? children(formikbag) : !formik_esm_isEmptyChildren(children) ? react["Children"].only(children) : null : null);
}

function warnAboutMissingIdentifier(_ref4) {
  var htmlContent = _ref4.htmlContent,
      documentationAnchorLink = _ref4.documentationAnchorLink,
      handlerName = _ref4.handlerName;
  console.warn("Warning: Formik called `" + handlerName + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + htmlContent + "\n    Formik cannot determine which value to update. For more info see https://formik.org/docs/api/formik#" + documentationAnchorLink + "\n  ");
}
/**
 * Transform Yup ValidationError to a more usable object
 */


function yupToFormErrors(yupError) {
  var errors = {};

  if (yupError.inner) {
    if (yupError.inner.length === 0) {
      return setIn(errors, yupError.path, yupError.message);
    }

    for (var _iterator = yupError.inner, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref5;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref5 = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref5 = _i.value;
      }

      var err = _ref5;

      if (!getIn(errors, err.path)) {
        errors = setIn(errors, err.path, err.message);
      }
    }
  }

  return errors;
}
/**
 * Validate a yup schema.
 */

function validateYupSchema(values, schema, sync, context) {
  if (sync === void 0) {
    sync = false;
  }

  if (context === void 0) {
    context = {};
  }

  var validateData = prepareDataForValidation(values);
  return schema[sync ? 'validateSync' : 'validate'](validateData, {
    abortEarly: false,
    context: context
  });
}
/**
 * Recursively prepare values.
 */

function prepareDataForValidation(values) {
  var data = Array.isArray(values) ? [] : {};

  for (var k in values) {
    if (Object.prototype.hasOwnProperty.call(values, k)) {
      var key = String(k);

      if (Array.isArray(values[key]) === true) {
        data[key] = values[key].map(function (value) {
          if (Array.isArray(value) === true || lodash_es_isPlainObject(value)) {
            return prepareDataForValidation(value);
          } else {
            return value !== '' ? value : undefined;
          }
        });
      } else if (lodash_es_isPlainObject(values[key])) {
        data[key] = prepareDataForValidation(values[key]);
      } else {
        data[key] = values[key] !== '' ? values[key] : undefined;
      }
    }
  }

  return data;
}
/**
 * deepmerge array merging algorithm
 * https://github.com/KyleAMathews/deepmerge#combine-array
 */

function arrayMerge(target, source, options) {
  var destination = target.slice();
  source.forEach(function merge(e, i) {
    if (typeof destination[i] === 'undefined') {
      var cloneRequested = options.clone !== false;
      var shouldClone = cloneRequested && options.isMergeableObject(e);
      destination[i] = shouldClone ? es(Array.isArray(e) ? [] : {}, e, options) : e;
    } else if (options.isMergeableObject(e)) {
      destination[i] = es(target[i], e, options);
    } else if (target.indexOf(e) === -1) {
      destination.push(e);
    }
  });
  return destination;
}
/** Return multi select values based on an array of options */


function getSelectedValues(options) {
  return Array.from(options).filter(function (el) {
    return el.selected;
  }).map(function (el) {
    return el.value;
  });
}
/** Return the next value for a checkbox */


function getValueForCheckbox(currentValue, checked, valueProp) {
  // If the current value was a boolean, return a boolean
  if (typeof currentValue === 'boolean') {
    return Boolean(checked);
  } // If the currentValue was not a boolean we want to return an array


  var currentArrayOfValues = [];
  var isValueInArray = false;
  var index = -1;

  if (!Array.isArray(currentValue)) {
    // eslint-disable-next-line eqeqeq
    if (!valueProp || valueProp == 'true' || valueProp == 'false') {
      return Boolean(checked);
    }
  } else {
    // If the current value is already an array, use it
    currentArrayOfValues = currentValue;
    index = currentValue.indexOf(valueProp);
    isValueInArray = index >= 0;
  } // If the checkbox was checked and the value is not already present in the aray we want to add the new value to the array of values


  if (checked && valueProp && !isValueInArray) {
    return currentArrayOfValues.concat(valueProp);
  } // If the checkbox was unchecked and the value is not in the array, simply return the already existing array of values


  if (!isValueInArray) {
    return currentArrayOfValues;
  } // If the checkbox was unchecked and the value is in the array, remove the value and return the array


  return currentArrayOfValues.slice(0, index).concat(currentArrayOfValues.slice(index + 1));
} // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
// @see https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85


var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? react["useLayoutEffect"] : react["useEffect"];

function useEventCallback(fn) {
  var ref = Object(react["useRef"])(fn); // we copy a ref to the callback scoped to the current state/props on each render

  useIsomorphicLayoutEffect(function () {
    ref.current = fn;
  });
  return Object(react["useCallback"])(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return ref.current.apply(void 0, args);
  }, []);
}

function useField(propsOrFieldName) {
  var formik = useFormikContext();
  var getFieldProps = formik.getFieldProps,
      getFieldMeta = formik.getFieldMeta,
      getFieldHelpers = formik.getFieldHelpers,
      registerField = formik.registerField,
      unregisterField = formik.unregisterField;
  var isAnObject = formik_esm_isObject(propsOrFieldName); // Normalize propsOrFieldName to FieldHookConfig<Val>

  var props = isAnObject ? propsOrFieldName : {
    name: propsOrFieldName
  };
  var fieldName = props.name,
      validateFn = props.validate;
  Object(react["useEffect"])(function () {
    if (fieldName) {
      registerField(fieldName, {
        validate: validateFn
      });
    }

    return function () {
      if (fieldName) {
        unregisterField(fieldName);
      }
    };
  }, [registerField, unregisterField, fieldName, validateFn]);

  if (false) {}

  !fieldName ?  false ? undefined : tiny_warning_esm(false) : void 0;
  return [getFieldProps(props), getFieldMeta(fieldName), getFieldHelpers(fieldName)];
}
function Field(_ref) {
  var validate = _ref.validate,
      name = _ref.name,
      render = _ref.render,
      children = _ref.children,
      is = _ref.as,
      component = _ref.component,
      props = _objectWithoutPropertiesLoose(_ref, ["validate", "name", "render", "children", "as", "component"]);

  var _useFormikContext = useFormikContext(),
      formik = _objectWithoutPropertiesLoose(_useFormikContext, ["validate", "validationSchema"]);

  if (false) {} // Register field and field-level validation with parent <Formik>


  var registerField = formik.registerField,
      unregisterField = formik.unregisterField;
  Object(react["useEffect"])(function () {
    registerField(name, {
      validate: validate
    });
    return function () {
      unregisterField(name);
    };
  }, [registerField, unregisterField, name, validate]);
  var field = formik.getFieldProps(_extends({
    name: name
  }, props));
  var meta = formik.getFieldMeta(name);
  var legacyBag = {
    field: field,
    form: formik
  };

  if (render) {
    return render(_extends({}, legacyBag, {
      meta: meta
    }));
  }

  if (isFunction(children)) {
    return children(_extends({}, legacyBag, {
      meta: meta
    }));
  }

  if (component) {
    // This behavior is backwards compat with earlier Formik 0.9 to 1.x
    if (typeof component === 'string') {
      var innerRef = props.innerRef,
          rest = _objectWithoutPropertiesLoose(props, ["innerRef"]);

      return Object(react["createElement"])(component, _extends({
        ref: innerRef
      }, field, rest), children);
    } // We don't pass `meta` for backwards compat


    return Object(react["createElement"])(component, _extends({
      field: field,
      form: formik
    }, props), children);
  } // default to input here so we can check for both `as` and `children` above


  var asElement = is || 'input';

  if (typeof asElement === 'string') {
    var _innerRef = props.innerRef,
        _rest = _objectWithoutPropertiesLoose(props, ["innerRef"]);

    return Object(react["createElement"])(asElement, _extends({
      ref: _innerRef
    }, field, _rest), children);
  }

  return Object(react["createElement"])(asElement, _extends({}, field, props), children);
}

var Form = /*#__PURE__*/Object(react["forwardRef"])(function (props, ref) {
  // iOS needs an "action" attribute for nice input: https://stackoverflow.com/a/39485162/406725
  // We default the action to "#" in case the preventDefault fails (just updates the URL hash)
  var action = props.action,
      rest = _objectWithoutPropertiesLoose(props, ["action"]);

  var _action = action != null ? action : '#';

  var _useFormikContext = useFormikContext(),
      handleReset = _useFormikContext.handleReset,
      handleSubmit = _useFormikContext.handleSubmit;

  return Object(react["createElement"])("form", Object.assign({
    onSubmit: handleSubmit,
    ref: ref,
    onReset: handleReset,
    action: _action
  }, rest));
});
Form.displayName = 'Form';

/**
 * A public higher-order component to access the imperative API
 */

function withFormik(_ref) {
  var _ref$mapPropsToValues = _ref.mapPropsToValues,
      mapPropsToValues = _ref$mapPropsToValues === void 0 ? function (vanillaProps) {
    var val = {};

    for (var k in vanillaProps) {
      if (vanillaProps.hasOwnProperty(k) && typeof vanillaProps[k] !== 'function') {
        // @todo TypeScript fix
        val[k] = vanillaProps[k];
      }
    }

    return val;
  } : _ref$mapPropsToValues,
      config = _objectWithoutPropertiesLoose(_ref, ["mapPropsToValues"]);

  return function createFormik(Component$1) {
    var componentDisplayName = Component$1.displayName || Component$1.name || Component$1.constructor && Component$1.constructor.name || 'Component';
    /**
     * We need to use closures here for to provide the wrapped component's props to
     * the respective withFormik config methods.
     */

    var C = /*#__PURE__*/function (_React$Component) {
      _inheritsLoose(C, _React$Component);

      function C() {
        var _this;

        _this = _React$Component.apply(this, arguments) || this;

        _this.validate = function (values) {
          return config.validate(values, _this.props);
        };

        _this.validationSchema = function () {
          return isFunction(config.validationSchema) ? config.validationSchema(_this.props) : config.validationSchema;
        };

        _this.handleSubmit = function (values, actions) {
          return config.handleSubmit(values, _extends({}, actions, {
            props: _this.props
          }));
        };
        /**
         * Just avoiding a render callback for perf here
         */


        _this.renderFormComponent = function (formikProps) {
          return Object(react["createElement"])(Component$1, Object.assign({}, _this.props, formikProps));
        };

        return _this;
      }

      var _proto = C.prototype;

      _proto.render = function render() {
        var _this$props = this.props,
            props = _objectWithoutPropertiesLoose(_this$props, ["children"]);

        return Object(react["createElement"])(Formik, Object.assign({}, props, config, {
          validate: config.validate && this.validate,
          validationSchema: config.validationSchema && this.validationSchema,
          initialValues: mapPropsToValues(this.props),
          initialStatus: config.mapPropsToStatus && config.mapPropsToStatus(this.props),
          initialErrors: config.mapPropsToErrors && config.mapPropsToErrors(this.props),
          initialTouched: config.mapPropsToTouched && config.mapPropsToTouched(this.props),
          onSubmit: this.handleSubmit,
          children: this.renderFormComponent
        }));
      };

      return C;
    }(react["Component"]);

    C.displayName = "WithFormik(" + componentDisplayName + ")";
    return hoist_non_react_statics_cjs_default()(C, Component$1 // cast type to ComponentClass (even if SFC)
    );
  };
}

/**
 * Connect any component to Formik context, and inject as a prop called `formik`;
 * @param Comp React Component
 */

function connect(Comp) {
  var C = function C(props) {
    return Object(react["createElement"])(FormikConsumer, null, function (formik) {
      !!!formik ?  false ? undefined : tiny_warning_esm(false) : void 0;
      return Object(react["createElement"])(Comp, Object.assign({}, props, {
        formik: formik
      }));
    });
  };

  var componentDisplayName = Comp.displayName || Comp.name || Comp.constructor && Comp.constructor.name || 'Component'; // Assign Comp to C.WrappedComponent so we can access the inner component in tests
  // For example, <Field.WrappedComponent /> gets us <FieldInner/>

  C.WrappedComponent = Comp;
  C.displayName = "FormikConnect(" + componentDisplayName + ")";
  return hoist_non_react_statics_cjs_default()(C, Comp // cast type to ComponentClass (even if SFC)
  );
}

/**
 * Some array helpers!
 */

var move = function move(array, from, to) {
  var copy = copyArrayLike(array);
  var value = copy[from];
  copy.splice(from, 1);
  copy.splice(to, 0, value);
  return copy;
};
var swap = function swap(arrayLike, indexA, indexB) {
  var copy = copyArrayLike(arrayLike);
  var a = copy[indexA];
  copy[indexA] = copy[indexB];
  copy[indexB] = a;
  return copy;
};
var insert = function insert(arrayLike, index, value) {
  var copy = copyArrayLike(arrayLike);
  copy.splice(index, 0, value);
  return copy;
};
var replace = function replace(arrayLike, index, value) {
  var copy = copyArrayLike(arrayLike);
  copy[index] = value;
  return copy;
};

var copyArrayLike = function copyArrayLike(arrayLike) {
  if (!arrayLike) {
    return [];
  } else if (Array.isArray(arrayLike)) {
    return [].concat(arrayLike);
  } else {
    var maxIndex = Object.keys(arrayLike).map(function (key) {
      return parseInt(key);
    }).reduce(function (max, el) {
      return el > max ? el : max;
    }, 0);
    return Array.from(_extends({}, arrayLike, {
      length: maxIndex + 1
    }));
  }
};

var formik_esm_FieldArrayInner = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(FieldArrayInner, _React$Component);

  function FieldArrayInner(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.updateArrayField = function (fn, alterTouched, alterErrors) {
      var _this$props = _this.props,
          name = _this$props.name,
          setFormikState = _this$props.formik.setFormikState;
      setFormikState(function (prevState) {
        var updateErrors = typeof alterErrors === 'function' ? alterErrors : fn;
        var updateTouched = typeof alterTouched === 'function' ? alterTouched : fn; // values fn should be executed before updateErrors and updateTouched,
        // otherwise it causes an error with unshift.

        var values = setIn(prevState.values, name, fn(getIn(prevState.values, name)));
        var fieldError = alterErrors ? updateErrors(getIn(prevState.errors, name)) : undefined;
        var fieldTouched = alterTouched ? updateTouched(getIn(prevState.touched, name)) : undefined;

        if (isEmptyArray(fieldError)) {
          fieldError = undefined;
        }

        if (isEmptyArray(fieldTouched)) {
          fieldTouched = undefined;
        }

        return _extends({}, prevState, {
          values: values,
          errors: alterErrors ? setIn(prevState.errors, name, fieldError) : prevState.errors,
          touched: alterTouched ? setIn(prevState.touched, name, fieldTouched) : prevState.touched
        });
      });
    };

    _this.push = function (value) {
      return _this.updateArrayField(function (arrayLike) {
        return [].concat(copyArrayLike(arrayLike), [lodash_es_cloneDeep(value)]);
      }, false, false);
    };

    _this.handlePush = function (value) {
      return function () {
        return _this.push(value);
      };
    };

    _this.swap = function (indexA, indexB) {
      return _this.updateArrayField(function (array) {
        return swap(array, indexA, indexB);
      }, true, true);
    };

    _this.handleSwap = function (indexA, indexB) {
      return function () {
        return _this.swap(indexA, indexB);
      };
    };

    _this.move = function (from, to) {
      return _this.updateArrayField(function (array) {
        return move(array, from, to);
      }, true, true);
    };

    _this.handleMove = function (from, to) {
      return function () {
        return _this.move(from, to);
      };
    };

    _this.insert = function (index, value) {
      return _this.updateArrayField(function (array) {
        return insert(array, index, value);
      }, function (array) {
        return insert(array, index, null);
      }, function (array) {
        return insert(array, index, null);
      });
    };

    _this.handleInsert = function (index, value) {
      return function () {
        return _this.insert(index, value);
      };
    };

    _this.replace = function (index, value) {
      return _this.updateArrayField(function (array) {
        return replace(array, index, value);
      }, false, false);
    };

    _this.handleReplace = function (index, value) {
      return function () {
        return _this.replace(index, value);
      };
    };

    _this.unshift = function (value) {
      var length = -1;

      _this.updateArrayField(function (array) {
        var arr = array ? [value].concat(array) : [value];

        if (length < 0) {
          length = arr.length;
        }

        return arr;
      }, function (array) {
        var arr = array ? [null].concat(array) : [null];

        if (length < 0) {
          length = arr.length;
        }

        return arr;
      }, function (array) {
        var arr = array ? [null].concat(array) : [null];

        if (length < 0) {
          length = arr.length;
        }

        return arr;
      });

      return length;
    };

    _this.handleUnshift = function (value) {
      return function () {
        return _this.unshift(value);
      };
    };

    _this.handleRemove = function (index) {
      return function () {
        return _this.remove(index);
      };
    };

    _this.handlePop = function () {
      return function () {
        return _this.pop();
      };
    }; // We need TypeScript generics on these, so we'll bind them in the constructor
    // @todo Fix TS 3.2.1


    _this.remove = _this.remove.bind(_assertThisInitialized(_this));
    _this.pop = _this.pop.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = FieldArrayInner.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.validateOnChange && this.props.formik.validateOnChange && !react_fast_compare_default()(getIn(prevProps.formik.values, prevProps.name), getIn(this.props.formik.values, this.props.name))) {
      this.props.formik.validateForm(this.props.formik.values);
    }
  };

  _proto.remove = function remove(index) {
    // We need to make sure we also remove relevant pieces of `touched` and `errors`
    var result;
    this.updateArrayField( // so this gets call 3 times
    function (array) {
      var copy = array ? copyArrayLike(array) : [];

      if (!result) {
        result = copy[index];
      }

      if (isFunction(copy.splice)) {
        copy.splice(index, 1);
      }

      return copy;
    }, true, true);
    return result;
  };

  _proto.pop = function pop() {
    // Remove relevant pieces of `touched` and `errors` too!
    var result;
    this.updateArrayField( // so this gets call 3 times
    function (array) {
      var tmp = array;

      if (!result) {
        result = tmp && tmp.pop && tmp.pop();
      }

      return tmp;
    }, true, true);
    return result;
  };

  _proto.render = function render() {
    var arrayHelpers = {
      push: this.push,
      pop: this.pop,
      swap: this.swap,
      move: this.move,
      insert: this.insert,
      replace: this.replace,
      unshift: this.unshift,
      remove: this.remove,
      handlePush: this.handlePush,
      handlePop: this.handlePop,
      handleSwap: this.handleSwap,
      handleMove: this.handleMove,
      handleInsert: this.handleInsert,
      handleReplace: this.handleReplace,
      handleUnshift: this.handleUnshift,
      handleRemove: this.handleRemove
    };

    var _this$props2 = this.props,
        component = _this$props2.component,
        render = _this$props2.render,
        children = _this$props2.children,
        name = _this$props2.name,
        _this$props2$formik = _this$props2.formik,
        restOfFormik = _objectWithoutPropertiesLoose(_this$props2$formik, ["validate", "validationSchema"]);

    var props = _extends({}, arrayHelpers, {
      form: restOfFormik,
      name: name
    });

    return component ? Object(react["createElement"])(component, props) : render ? render(props) : children // children come last, always called
    ? typeof children === 'function' ? children(props) : !formik_esm_isEmptyChildren(children) ? react["Children"].only(children) : null : null;
  };

  return FieldArrayInner;
}(react["Component"]);

formik_esm_FieldArrayInner.defaultProps = {
  validateOnChange: true
};
var FieldArray = /*#__PURE__*/connect(formik_esm_FieldArrayInner);

var formik_esm_ErrorMessageImpl = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ErrorMessageImpl, _React$Component);

  function ErrorMessageImpl() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ErrorMessageImpl.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
    if (getIn(this.props.formik.errors, this.props.name) !== getIn(props.formik.errors, this.props.name) || getIn(this.props.formik.touched, this.props.name) !== getIn(props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length) {
      return true;
    } else {
      return false;
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        component = _this$props.component,
        formik = _this$props.formik,
        render = _this$props.render,
        children = _this$props.children,
        name = _this$props.name,
        rest = _objectWithoutPropertiesLoose(_this$props, ["component", "formik", "render", "children", "name"]);

    var touch = getIn(formik.touched, name);
    var error = getIn(formik.errors, name);
    return !!touch && !!error ? render ? isFunction(render) ? render(error) : null : children ? isFunction(children) ? children(error) : null : component ? Object(react["createElement"])(component, rest, error) : error : null;
  };

  return ErrorMessageImpl;
}(react["Component"]);

var ErrorMessage = /*#__PURE__*/connect(formik_esm_ErrorMessageImpl);

/**
 * Custom Field component for quickly hooking into Formik
 * context and wiring up forms.
 */

var formik_esm_FastFieldInner = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(FastFieldInner, _React$Component);

  function FastFieldInner(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    var render = props.render,
        children = props.children,
        component = props.component,
        is = props.as,
        name = props.name;
    !!render ?  false ? undefined : tiny_warning_esm(false) : void 0;
    !!(component && render) ?  false ? undefined : tiny_warning_esm(false) : void 0;
    !!(is && children && isFunction(children)) ?  false ? undefined : tiny_warning_esm(false) : void 0;
    !!(component && children && isFunction(children)) ?  false ? undefined : tiny_warning_esm(false) : void 0;
    !!(render && children && !formik_esm_isEmptyChildren(children)) ?  false ? undefined : tiny_warning_esm(false) : void 0;
    return _this;
  }

  var _proto = FastFieldInner.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
    if (this.props.shouldUpdate) {
      return this.props.shouldUpdate(props, this.props);
    } else if (props.name !== this.props.name || getIn(props.formik.values, this.props.name) !== getIn(this.props.formik.values, this.props.name) || getIn(props.formik.errors, this.props.name) !== getIn(this.props.formik.errors, this.props.name) || getIn(props.formik.touched, this.props.name) !== getIn(this.props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length || props.formik.isSubmitting !== this.props.formik.isSubmitting) {
      return true;
    } else {
      return false;
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    // Register the Field with the parent Formik. Parent will cycle through
    // registered Field's validate fns right prior to submit
    this.props.formik.registerField(this.props.name, {
      validate: this.props.validate
    });
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.name !== prevProps.name) {
      this.props.formik.unregisterField(prevProps.name);
      this.props.formik.registerField(this.props.name, {
        validate: this.props.validate
      });
    }

    if (this.props.validate !== prevProps.validate) {
      this.props.formik.registerField(this.props.name, {
        validate: this.props.validate
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.props.formik.unregisterField(this.props.name);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        name = _this$props.name,
        render = _this$props.render,
        is = _this$props.as,
        children = _this$props.children,
        component = _this$props.component,
        formik = _this$props.formik,
        props = _objectWithoutPropertiesLoose(_this$props, ["validate", "name", "render", "as", "children", "component", "shouldUpdate", "formik"]);

    var restOfFormik = _objectWithoutPropertiesLoose(formik, ["validate", "validationSchema"]);

    var field = formik.getFieldProps(_extends({
      name: name
    }, props));
    var meta = {
      value: getIn(formik.values, name),
      error: getIn(formik.errors, name),
      touched: !!getIn(formik.touched, name),
      initialValue: getIn(formik.initialValues, name),
      initialTouched: !!getIn(formik.initialTouched, name),
      initialError: getIn(formik.initialErrors, name)
    };
    var bag = {
      field: field,
      meta: meta,
      form: restOfFormik
    };

    if (render) {
      return render(bag);
    }

    if (isFunction(children)) {
      return children(bag);
    }

    if (component) {
      // This behavior is backwards compat with earlier Formik 0.9 to 1.x
      if (typeof component === 'string') {
        var innerRef = props.innerRef,
            rest = _objectWithoutPropertiesLoose(props, ["innerRef"]);

        return Object(react["createElement"])(component, _extends({
          ref: innerRef
        }, field, rest), children);
      } // We don't pass `meta` for backwards compat


      return Object(react["createElement"])(component, _extends({
        field: field,
        form: formik
      }, props), children);
    } // default to input here so we can check for both `as` and `children` above


    var asElement = is || 'input';

    if (typeof asElement === 'string') {
      var _innerRef = props.innerRef,
          _rest = _objectWithoutPropertiesLoose(props, ["innerRef"]);

      return Object(react["createElement"])(asElement, _extends({
        ref: _innerRef
      }, field, _rest), children);
    }

    return Object(react["createElement"])(asElement, _extends({}, field, props), children);
  };

  return FastFieldInner;
}(react["Component"]);

var FastField = /*#__PURE__*/connect(formik_esm_FastFieldInner);


//# sourceMappingURL=formik.esm.js.map


/***/ }),

/***/ "luEP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.addMethod = addMethod;
exports.lazy = exports.ref = exports.boolean = void 0;

var _mixed = _interopRequireDefault(__webpack_require__("tNma"));

exports.mixed = _mixed.default;

var _boolean = _interopRequireDefault(__webpack_require__("+Mso"));

exports.bool = _boolean.default;

var _string = _interopRequireDefault(__webpack_require__("E8R/"));

exports.string = _string.default;

var _number = _interopRequireDefault(__webpack_require__("4XSA"));

exports.number = _number.default;

var _date = _interopRequireDefault(__webpack_require__("+VQP"));

exports.date = _date.default;

var _object = _interopRequireDefault(__webpack_require__("5r8v"));

exports.object = _object.default;

var _array = _interopRequireDefault(__webpack_require__("AdY7"));

exports.array = _array.default;

var _Reference = _interopRequireDefault(__webpack_require__("hLcx"));

var _Lazy = _interopRequireDefault(__webpack_require__("gqH2"));

var _ValidationError = _interopRequireDefault(__webpack_require__("fnDY"));

exports.ValidationError = _ValidationError.default;

var _reach = _interopRequireDefault(__webpack_require__("zBae"));

exports.reach = _reach.default;

var _isSchema = _interopRequireDefault(__webpack_require__("kZEO"));

exports.isSchema = _isSchema.default;

var _setLocale = _interopRequireDefault(__webpack_require__("Lo6J"));

exports.setLocale = _setLocale.default;
var boolean = _boolean.default;
exports.boolean = boolean;

var ref = function ref(key, options) {
  return new _Reference.default(key, options);
};

exports.ref = ref;

var lazy = function lazy(fn) {
  return new _Lazy.default(fn);
};

exports.lazy = lazy;

function addMethod(schemaType, name, fn) {
  if (!schemaType || !(0, _isSchema.default)(schemaType.prototype)) throw new TypeError('You must provide a yup schema constructor function');
  if (typeof name !== 'string') throw new TypeError('A Method name must be provided');
  if (typeof fn !== 'function') throw new TypeError('Method function must be provided');
  schemaType.prototype[name] = fn;
}

/***/ }),

/***/ "n4a0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.default = prependDeep;

var _has = _interopRequireDefault(__webpack_require__("1mr4"));

var _isSchema = _interopRequireDefault(__webpack_require__("kZEO"));

var isObject = function isObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
};

function prependDeep(target, source) {
  for (var key in source) {
    if ((0, _has.default)(source, key)) {
      var sourceVal = source[key],
          targetVal = target[key];

      if (targetVal === undefined) {
        target[key] = sourceVal;
      } else if (targetVal === sourceVal) {
        continue;
      } else if ((0, _isSchema.default)(targetVal)) {
        if ((0, _isSchema.default)(sourceVal)) target[key] = sourceVal.concat(targetVal);
      } else if (isObject(targetVal)) {
        if (isObject(sourceVal)) target[key] = prependDeep(targetVal, sourceVal);
      } else if (Array.isArray(targetVal)) {
        if (Array.isArray(sourceVal)) target[key] = sourceVal.concat(targetVal);
      }
    }
  }

  return target;
}

module.exports = exports["default"];

/***/ }),

/***/ "oJuH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GMStatuses; });
var GMStatuses = ['turquoise', 'silver', 'gold', 'platinum'];

/***/ }),

/***/ "oNVP":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("F63i")))

/***/ }),

/***/ "op+c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.HeadManagerContext = void 0;

var _react = _interopRequireDefault(__webpack_require__("ERkP"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var HeadManagerContext = /*#__PURE__*/_react.default.createContext({});

exports.HeadManagerContext = HeadManagerContext;

if (false) {}

/***/ }),

/***/ "pSQP":
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;

/***/ }),

/***/ "qr7w":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.default = exports.array = exports.object = exports.boolean = exports.date = exports.number = exports.string = exports.mixed = void 0;

var _printValue = _interopRequireDefault(__webpack_require__("i0Sy"));

var mixed = {
  default: '${path} is invalid',
  required: '${path} is a required field',
  oneOf: '${path} must be one of the following values: ${values}',
  notOneOf: '${path} must not be one of the following values: ${values}',
  notType: function notType(_ref) {
    var path = _ref.path,
        type = _ref.type,
        value = _ref.value,
        originalValue = _ref.originalValue;
    var isCast = originalValue != null && originalValue !== value;
    var msg = path + " must be a `" + type + "` type, " + ("but the final value was: `" + (0, _printValue.default)(value, true) + "`") + (isCast ? " (cast from the value `" + (0, _printValue.default)(originalValue, true) + "`)." : '.');

    if (value === null) {
      msg += "\n If \"null\" is intended as an empty value be sure to mark the schema as `.nullable()`";
    }

    return msg;
  }
};
exports.mixed = mixed;
var string = {
  length: '${path} must be exactly ${length} characters',
  min: '${path} must be at least ${min} characters',
  max: '${path} must be at most ${max} characters',
  matches: '${path} must match the following: "${regex}"',
  email: '${path} must be a valid email',
  url: '${path} must be a valid URL',
  trim: '${path} must be a trimmed string',
  lowercase: '${path} must be a lowercase string',
  uppercase: '${path} must be a upper case string'
};
exports.string = string;
var number = {
  min: '${path} must be greater than or equal to ${min}',
  max: '${path} must be less than or equal to ${max}',
  lessThan: '${path} must be less than ${less}',
  moreThan: '${path} must be greater than ${more}',
  notEqual: '${path} must be not equal to ${notEqual}',
  positive: '${path} must be a positive number',
  negative: '${path} must be a negative number',
  integer: '${path} must be an integer'
};
exports.number = number;
var date = {
  min: '${path} field must be later than ${min}',
  max: '${path} field must be at earlier than ${max}'
};
exports.date = date;
var boolean = {};
exports.boolean = boolean;
var object = {
  noUnknown: '${path} field cannot have keys not specified in the object shape'
};
exports.object = object;
var array = {
  min: '${path} field must have at least ${min} items',
  max: '${path} field must have less than or equal to ${max} items'
};
exports.array = array;
var _default = {
  mixed: mixed,
  string: string,
  number: number,
  date: date,
  object: object,
  array: array,
  boolean: boolean
};
exports.default = _default;

/***/ }),

/***/ "raDx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = makePath;

function makePath(strings) {
  for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  var path = strings.reduce(function (str, next) {
    var value = values.shift();
    return str + (value == null ? '' : value) + next;
  });
  return path.replace(/^\./, '');
}

module.exports = exports["default"];

/***/ }),

/***/ "rokF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.default = inherits;

var _extends2 = _interopRequireDefault(__webpack_require__("97Jx"));

function inherits(ctor, superCtor, spec) {
  ctor.prototype = Object.create(superCtor.prototype, {
    constructor: {
      value: ctor,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  (0, _extends2.default)(ctor.prototype, spec);
}

module.exports = exports["default"];

/***/ }),

/***/ "s2Gj":
/***/ (function(module, exports, __webpack_require__) {

var createCompounder = __webpack_require__("4ygQ");

/**
 * Converts `string` to
 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the kebab cased string.
 * @example
 *
 * _.kebabCase('Foo Bar');
 * // => 'foo-bar'
 *
 * _.kebabCase('fooBar');
 * // => 'foo-bar'
 *
 * _.kebabCase('__FOO_BAR__');
 * // => 'foo-bar'
 */
var kebabCase = createCompounder(function(result, word, index) {
  return result + (index ? '-' : '') + word.toLowerCase();
});

module.exports = kebabCase;


/***/ }),

/***/ "sRHE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _getPrototypeOf; });
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),

/***/ "syQ6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return INLINE_1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return INLINE_2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COLUMN_1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return COLUMN_2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return COMPOSITE_1; });
var INLINE_1 = 'Inline1';
var INLINE_2 = 'Inline2';
var COLUMN_1 = 'Column1';
var COLUMN_2 = 'Column2';
var COMPOSITE_1 = 'Composite1';

/***/ }),

/***/ "tNma":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.default = SchemaType;

var _extends2 = _interopRequireDefault(__webpack_require__("97Jx"));

var _has = _interopRequireDefault(__webpack_require__("1mr4"));

var _cloneDeepWith = _interopRequireDefault(__webpack_require__("NdXQ"));

var _toArray2 = _interopRequireDefault(__webpack_require__("Vk6K"));

var _locale = __webpack_require__("qr7w");

var _Condition = _interopRequireDefault(__webpack_require__("hCAA"));

var _runValidations = _interopRequireDefault(__webpack_require__("wM5X"));

var _prependDeep = _interopRequireDefault(__webpack_require__("n4a0"));

var _isSchema = _interopRequireDefault(__webpack_require__("kZEO"));

var _createValidation = _interopRequireDefault(__webpack_require__("JeoY"));

var _printValue = _interopRequireDefault(__webpack_require__("i0Sy"));

var _Reference = _interopRequireDefault(__webpack_require__("hLcx"));

var _reach = __webpack_require__("zBae");

var RefSet =
/*#__PURE__*/
function () {
  function RefSet() {
    this.list = new Set();
    this.refs = new Map();
  }

  var _proto = RefSet.prototype;

  _proto.toArray = function toArray() {
    return (0, _toArray2.default)(this.list).concat((0, _toArray2.default)(this.refs.values()));
  };

  _proto.add = function add(value) {
    _Reference.default.isRef(value) ? this.refs.set(value.key, value) : this.list.add(value);
  };

  _proto.delete = function _delete(value) {
    _Reference.default.isRef(value) ? this.refs.delete(value.key, value) : this.list.delete(value);
  };

  _proto.has = function has(value, resolve) {
    if (this.list.has(value)) return true;
    var item,
        values = this.refs.values();

    while (item = values.next(), !item.done) {
      if (resolve(item.value) === value) return true;
    }

    return false;
  };

  return RefSet;
}();

function SchemaType(options) {
  var _this = this;

  if (options === void 0) {
    options = {};
  }

  if (!(this instanceof SchemaType)) return new SchemaType();
  this._deps = [];
  this._conditions = [];
  this._options = {
    abortEarly: true,
    recursive: true
  };
  this._exclusive = Object.create(null);
  this._whitelist = new RefSet();
  this._blacklist = new RefSet();
  this.tests = [];
  this.transforms = [];
  this.withMutation(function () {
    _this.typeError(_locale.mixed.notType);
  });
  if ((0, _has.default)(options, 'default')) this._defaultDefault = options.default;
  this._type = options.type || 'mixed';
}

var proto = SchemaType.prototype = {
  __isYupSchema__: true,
  constructor: SchemaType,
  clone: function clone() {
    var _this2 = this;

    if (this._mutate) return this; // if the nested value is a schema we can skip cloning, since
    // they are already immutable

    return (0, _cloneDeepWith.default)(this, function (value) {
      if ((0, _isSchema.default)(value) && value !== _this2) return value;
    });
  },
  label: function label(_label) {
    var next = this.clone();
    next._label = _label;
    return next;
  },
  meta: function meta(obj) {
    if (arguments.length === 0) return this._meta;
    var next = this.clone();
    next._meta = (0, _extends2.default)(next._meta || {}, obj);
    return next;
  },
  withMutation: function withMutation(fn) {
    var before = this._mutate;
    this._mutate = true;
    var result = fn(this);
    this._mutate = before;
    return result;
  },
  concat: function concat(schema) {
    if (!schema || schema === this) return this;
    if (schema._type !== this._type && this._type !== 'mixed') throw new TypeError("You cannot `concat()` schema's of different types: " + this._type + " and " + schema._type);
    var next = (0, _prependDeep.default)(schema.clone(), this); // new undefined default is overriden by old non-undefined one, revert

    if ((0, _has.default)(schema, '_default')) next._default = schema._default;
    next.tests = this.tests;
    next._exclusive = this._exclusive; // manually add the new tests to ensure
    // the deduping logic is consistent

    next.withMutation(function (next) {
      schema.tests.forEach(function (fn) {
        next.test(fn.OPTIONS);
      });
    });
    return next;
  },
  isType: function isType(v) {
    if (this._nullable && v === null) return true;
    return !this._typeCheck || this._typeCheck(v);
  },
  resolve: function resolve(options) {
    var schema = this;

    if (schema._conditions.length) {
      var conditions = schema._conditions;
      schema = schema.clone();
      schema._conditions = [];
      schema = conditions.reduce(function (schema, condition) {
        return condition.resolve(schema, options);
      }, schema);
      schema = schema.resolve(options);
    }

    return schema;
  },
  cast: function cast(value, options) {
    if (options === void 0) {
      options = {};
    }

    var resolvedSchema = this.resolve((0, _extends2.default)({}, options, {
      value: value
    }));

    var result = resolvedSchema._cast(value, options);

    if (value !== undefined && options.assert !== false && resolvedSchema.isType(result) !== true) {
      var formattedValue = (0, _printValue.default)(value);
      var formattedResult = (0, _printValue.default)(result);
      throw new TypeError("The value of " + (options.path || 'field') + " could not be cast to a value " + ("that satisfies the schema type: \"" + resolvedSchema._type + "\". \n\n") + ("attempted value: " + formattedValue + " \n") + (formattedResult !== formattedValue ? "result of cast: " + formattedResult : ''));
    }

    return result;
  },
  _cast: function _cast(rawValue) {
    var _this3 = this;

    var value = rawValue === undefined ? rawValue : this.transforms.reduce(function (value, fn) {
      return fn.call(_this3, value, rawValue);
    }, rawValue);

    if (value === undefined && (0, _has.default)(this, '_default')) {
      value = this.default();
    }

    return value;
  },
  _validate: function _validate(_value, options) {
    var _this4 = this;

    if (options === void 0) {
      options = {};
    }

    var value = _value;
    var originalValue = options.originalValue != null ? options.originalValue : _value;

    var isStrict = this._option('strict', options);

    var endEarly = this._option('abortEarly', options);

    var sync = options.sync;
    var path = options.path;
    var label = this._label;

    if (!isStrict) {
      value = this._cast(value, (0, _extends2.default)({
        assert: false
      }, options));
    } // value is cast, we can check if it meets type requirements


    var validationParams = {
      value: value,
      path: path,
      schema: this,
      options: options,
      label: label,
      originalValue: originalValue,
      sync: sync
    };
    var initialTests = [];
    if (this._typeError) initialTests.push(this._typeError(validationParams));
    if (this._whitelistError) initialTests.push(this._whitelistError(validationParams));
    if (this._blacklistError) initialTests.push(this._blacklistError(validationParams));
    return (0, _runValidations.default)({
      validations: initialTests,
      endEarly: endEarly,
      value: value,
      path: path,
      sync: sync
    }).then(function (value) {
      return (0, _runValidations.default)({
        path: path,
        sync: sync,
        value: value,
        endEarly: endEarly,
        validations: _this4.tests.map(function (fn) {
          return fn(validationParams);
        })
      });
    });
  },
  validate: function validate(value, options) {
    if (options === void 0) {
      options = {};
    }

    var schema = this.resolve((0, _extends2.default)({}, options, {
      value: value
    }));
    return schema._validate(value, options);
  },
  validateSync: function validateSync(value, options) {
    if (options === void 0) {
      options = {};
    }

    var schema = this.resolve((0, _extends2.default)({}, options, {
      value: value
    }));
    var result, err;

    schema._validate(value, (0, _extends2.default)({}, options, {
      sync: true
    })).then(function (r) {
      return result = r;
    }).catch(function (e) {
      return err = e;
    });

    if (err) throw err;
    return result;
  },
  isValid: function isValid(value, options) {
    return this.validate(value, options).then(function () {
      return true;
    }).catch(function (err) {
      if (err.name === 'ValidationError') return false;
      throw err;
    });
  },
  isValidSync: function isValidSync(value, options) {
    try {
      this.validateSync(value, options);
      return true;
    } catch (err) {
      if (err.name === 'ValidationError') return false;
      throw err;
    }
  },
  getDefault: function getDefault(options) {
    if (options === void 0) {
      options = {};
    }

    var schema = this.resolve(options);
    return schema.default();
  },
  default: function _default(def) {
    if (arguments.length === 0) {
      var defaultValue = (0, _has.default)(this, '_default') ? this._default : this._defaultDefault;
      return typeof defaultValue === 'function' ? defaultValue.call(this) : (0, _cloneDeepWith.default)(defaultValue);
    }

    var next = this.clone();
    next._default = def;
    return next;
  },
  strict: function strict(isStrict) {
    if (isStrict === void 0) {
      isStrict = true;
    }

    var next = this.clone();
    next._options.strict = isStrict;
    return next;
  },
  _isPresent: function _isPresent(value) {
    return value != null;
  },
  required: function required(message) {
    if (message === void 0) {
      message = _locale.mixed.required;
    }

    return this.test({
      message: message,
      name: 'required',
      exclusive: true,
      test: function test(value) {
        return this.schema._isPresent(value);
      }
    });
  },
  notRequired: function notRequired() {
    var next = this.clone();
    next.tests = next.tests.filter(function (test) {
      return test.OPTIONS.name !== 'required';
    });
    return next;
  },
  nullable: function nullable(isNullable) {
    if (isNullable === void 0) {
      isNullable = true;
    }

    var next = this.clone();
    next._nullable = isNullable;
    return next;
  },
  transform: function transform(fn) {
    var next = this.clone();
    next.transforms.push(fn);
    return next;
  },

  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */
  test: function test() {
    var opts;

    if (arguments.length === 1) {
      if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'function') {
        opts = {
          test: arguments.length <= 0 ? undefined : arguments[0]
        };
      } else {
        opts = arguments.length <= 0 ? undefined : arguments[0];
      }
    } else if (arguments.length === 2) {
      opts = {
        name: arguments.length <= 0 ? undefined : arguments[0],
        test: arguments.length <= 1 ? undefined : arguments[1]
      };
    } else {
      opts = {
        name: arguments.length <= 0 ? undefined : arguments[0],
        message: arguments.length <= 1 ? undefined : arguments[1],
        test: arguments.length <= 2 ? undefined : arguments[2]
      };
    }

    if (opts.message === undefined) opts.message = _locale.mixed.default;
    if (typeof opts.test !== 'function') throw new TypeError('`test` is a required parameters');
    var next = this.clone();
    var validate = (0, _createValidation.default)(opts);
    var isExclusive = opts.exclusive || opts.name && next._exclusive[opts.name] === true;

    if (opts.exclusive && !opts.name) {
      throw new TypeError('Exclusive tests must provide a unique `name` identifying the test');
    }

    next._exclusive[opts.name] = !!opts.exclusive;
    next.tests = next.tests.filter(function (fn) {
      if (fn.OPTIONS.name === opts.name) {
        if (isExclusive) return false;
        if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
      }

      return true;
    });
    next.tests.push(validate);
    return next;
  },
  when: function when(keys, options) {
    if (arguments.length === 1) {
      options = keys;
      keys = '.';
    }

    var next = this.clone(),
        deps = [].concat(keys).map(function (key) {
      return new _Reference.default(key);
    });
    deps.forEach(function (dep) {
      if (dep.isSibling) next._deps.push(dep.key);
    });

    next._conditions.push(new _Condition.default(deps, options));

    return next;
  },
  typeError: function typeError(message) {
    var next = this.clone();
    next._typeError = (0, _createValidation.default)({
      message: message,
      name: 'typeError',
      test: function test(value) {
        if (value !== undefined && !this.schema.isType(value)) return this.createError({
          params: {
            type: this.schema._type
          }
        });
        return true;
      }
    });
    return next;
  },
  oneOf: function oneOf(enums, message) {
    if (message === void 0) {
      message = _locale.mixed.oneOf;
    }

    var next = this.clone();
    enums.forEach(function (val) {
      next._whitelist.add(val);

      next._blacklist.delete(val);
    });
    next._whitelistError = (0, _createValidation.default)({
      message: message,
      name: 'oneOf',
      test: function test(value) {
        if (value === undefined) return true;
        var valids = this.schema._whitelist;
        return valids.has(value, this.resolve) ? true : this.createError({
          params: {
            values: valids.toArray().join(', ')
          }
        });
      }
    });
    return next;
  },
  notOneOf: function notOneOf(enums, message) {
    if (message === void 0) {
      message = _locale.mixed.notOneOf;
    }

    var next = this.clone();
    enums.forEach(function (val) {
      next._blacklist.add(val);

      next._whitelist.delete(val);
    });
    next._blacklistError = (0, _createValidation.default)({
      message: message,
      name: 'notOneOf',
      test: function test(value) {
        var invalids = this.schema._blacklist;
        if (invalids.has(value, this.resolve)) return this.createError({
          params: {
            values: invalids.toArray().join(', ')
          }
        });
        return true;
      }
    });
    return next;
  },
  strip: function strip(_strip) {
    if (_strip === void 0) {
      _strip = true;
    }

    var next = this.clone();
    next._strip = _strip;
    return next;
  },
  _option: function _option(key, overrides) {
    return (0, _has.default)(overrides, key) ? overrides[key] : this._options[key];
  },
  describe: function describe() {
    var next = this.clone();
    return {
      type: next._type,
      meta: next._meta,
      label: next._label,
      tests: next.tests.map(function (fn) {
        return {
          name: fn.OPTIONS.name,
          params: fn.OPTIONS.params
        };
      }).filter(function (n, idx, list) {
        return list.findIndex(function (c) {
          return c.name === n.name;
        }) === idx;
      })
    };
  }
};
var _arr = ['validate', 'validateSync'];

var _loop = function _loop() {
  var method = _arr[_i];

  proto[method + "At"] = function (path, value, options) {
    if (options === void 0) {
      options = {};
    }

    var _getIn = (0, _reach.getIn)(this, path, value, options.context),
        parent = _getIn.parent,
        parentPath = _getIn.parentPath,
        schema = _getIn.schema;

    return schema[method](parent && parent[parentPath], (0, _extends2.default)({}, options, {
      parent: parent,
      path: path
    }));
  };
};

for (var _i = 0; _i < _arr.length; _i++) {
  _loop();
}

var _arr2 = ['equals', 'is'];

for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
  var alias = _arr2[_i2];
  proto[alias] = proto.oneOf;
}

var _arr3 = ['not', 'nope'];

for (var _i3 = 0; _i3 < _arr3.length; _i3++) {
  var _alias = _arr3[_i3];
  proto[_alias] = proto.notOneOf;
}

proto.optional = proto.notRequired;
module.exports = exports["default"];

/***/ }),

/***/ "tZiC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TrackPage; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tracking_api_useTrackPage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("Vbjg");


var TrackPage = function TrackPage(_ref) {
  var pageName = _ref.pageName,
      payload = _ref.payload;

  var _useTrackPage = Object(_tracking_api_useTrackPage__WEBPACK_IMPORTED_MODULE_1__[/* useTrackPage */ "a"])(),
      trackPage = _useTrackPage.trackPage;

  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    trackPage(pageName, payload);
  }, [pageName]);
  return null;
};

/***/ }),

/***/ "uFXj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("ax0f");
var createHTML = __webpack_require__("gIHd");
var forcedStringHTMLMethod = __webpack_require__("sHxg");

// `String.prototype.small` method
// https://tc39.es/ecma262/#sec-string.prototype.small
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('small') }, {
  small: function small() {
    return createHTML(this, 'small', '', '');
  }
});


/***/ }),

/***/ "uYlf":
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableSpread;

/***/ }),

/***/ "vpUC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("ysqo")


/***/ }),

/***/ "vpua":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getValidationStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getValidateFieldFunction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return focusNextInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getInputClasses; });
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("JtPf");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("QsI/");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("C/y5");
/* harmony import */ var _form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("45yR");
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("luEP");
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(yup__WEBPACK_IMPORTED_MODULE_8__);









var getValidationStatus = function getValidationStatus(_ref, _ref2) {
  var name = _ref.name,
      value = _ref.value;
  var touched = _ref2.touched,
      errors = _ref2.errors,
      submitCount = _ref2.submitCount;
  var isDisabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var hadInteraction = lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(touched, name) || submitCount > 0;
  var validationState = lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(errors, name) ? _form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_7__[/* IS_INVALID */ "a"] : _form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_7__[/* IS_VALID */ "b"];
  var isValidated = hadInteraction && validationState === _form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_7__[/* IS_VALID */ "b"] && value;
  var isErrored = hadInteraction && validationState === _form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_7__[/* IS_INVALID */ "a"];
  return {
    isDefaultState: !isValidated && !isErrored && !isDisabled,
    isErrored: isErrored,
    isTouched: hadInteraction,
    isValidated: isValidated
  };
}; // eslint-disable-next-line no-promise-executor-return

var sleep = function sleep(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
};

var getValidateFieldFunction = function getValidateFieldFunction(validator, context, locale) {
  return /*#__PURE__*/function () {
    var _ref3 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_5___default.a.mark(function _callee2(val) {
      var validationResult;
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_5___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              validationResult = '';

              if (!(locale === 'ja-JP')) {
                _context2.next = 6;
                break;
              }

              _context2.next = 4;
              return sleep(300).then( /*#__PURE__*/Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_5___default.a.mark(function _callee() {
                return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_5___default.a.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.prev = 0;
                        _context.next = 3;
                        return validator.validateSync(val, {
                          context: context
                        });

                      case 3:
                        _context.next = 8;
                        break;

                      case 5:
                        _context.prev = 5;
                        _context.t0 = _context["catch"](0);
                        validationResult = _context.t0.message;

                      case 8:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, null, [[0, 5]]);
              })));

            case 4:
              _context2.next = 14;
              break;

            case 6:
              _context2.prev = 6;
              _context2.next = 9;
              return validator.validateSync(val, {
                context: context
              });

            case 9:
              _context2.next = 14;
              break;

            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](6);
              validationResult = _context2.t0.message;

            case 14:
              return _context2.abrupt("return", validationResult);

            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[6, 11]]);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }();
};
var focusNextInput = function focusNextInput(target) {
  var nextRef = target.nextSibling;

  if (target.value.length === target.maxLength && nextRef) {
    nextRef.focus();
  }
};
var getInputClasses = function getInputClasses(_ref5) {
  var hasHeight = _ref5.hasHeight,
      _ref5$hasRadius = _ref5.hasRadius,
      hasRadius = _ref5$hasRadius === void 0 ? true : _ref5$hasRadius,
      hasValidationStatus = _ref5.hasValidationStatus,
      isDefaultState = _ref5.isDefaultState,
      isDisabled = _ref5.isDisabled,
      isErrored = _ref5.isErrored,
      isValidated = _ref5.isValidated,
      _ref5$hasNoBorder = _ref5.hasNoBorder,
      hasNoBorder = _ref5$hasNoBorder === void 0 ? false : _ref5$hasNoBorder;
  return Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_6__[/* classnames */ "a"])('w-full appearance-none border px-20 py-10 text-14 leading-normal text-black outline-none transition-all duration-250 ease-in', {
    'rounded-pill': hasRadius,
    'h-48': hasHeight,
    'border-lightGrey hocus:border-black': isDefaultState,
    'border-success': isValidated,
    'formik-errored border-red': isErrored,
    'cursor-not-allowed border-grey bg-pearl text-grey': isDisabled,
    'pe-40': hasValidationStatus && (isErrored || isValidated),
    'border-none': hasNoBorder
  });
};

/***/ }),

/***/ "wFPu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("ax0f");
var isArray = __webpack_require__("xt6W");

var nativeReverse = [].reverse;
var test = [1, 2];

// `Array.prototype.reverse` method
// https://tc39.es/ecma262/#sec-array.prototype.reverse
// fix for Safari 12.0 bug
// https://bugs.webkit.org/show_bug.cgi?id=188794
$({ target: 'Array', proto: true, forced: String(test) === String(test.reverse()) }, {
  reverse: function reverse() {
    // eslint-disable-next-line no-self-assign -- dirty hack
    if (isArray(this)) this.length = this.length;
    return nativeReverse.call(this);
  }
});


/***/ }),

/***/ "wM5X":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.propagateErrors = propagateErrors;
exports.settled = settled;
exports.collectErrors = collectErrors;
exports.default = runValidations;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__("LdEA"));

var _synchronousPromise = __webpack_require__("V5RX");

var _ValidationError = _interopRequireDefault(__webpack_require__("fnDY"));

var promise = function promise(sync) {
  return sync ? _synchronousPromise.SynchronousPromise : Promise;
};

var unwrapError = function unwrapError(errors) {
  if (errors === void 0) {
    errors = [];
  }

  return errors.inner && errors.inner.length ? errors.inner : [].concat(errors);
};

function scopeToValue(promises, value, sync) {
  //console.log('scopeToValue', promises, value)
  var p = promise(sync).all(promises); //console.log('scopeToValue B', p)

  var b = p.catch(function (err) {
    if (err.name === 'ValidationError') err.value = value;
    throw err;
  }); //console.log('scopeToValue c', b)

  var c = b.then(function () {
    return value;
  }); //console.log('scopeToValue d', c)

  return c;
}
/**
 * If not failing on the first error, catch the errors
 * and collect them in an array
 */


function propagateErrors(endEarly, errors) {
  return endEarly ? null : function (err) {
    errors.push(err);
    return err.value;
  };
}

function settled(promises, sync) {
  var Promise = promise(sync);
  return Promise.all(promises.map(function (p) {
    return Promise.resolve(p).then(function (value) {
      return {
        fulfilled: true,
        value: value
      };
    }, function (value) {
      return {
        fulfilled: false,
        value: value
      };
    });
  }));
}

function collectErrors(_ref) {
  var validations = _ref.validations,
      value = _ref.value,
      path = _ref.path,
      sync = _ref.sync,
      errors = _ref.errors,
      sort = _ref.sort;
  errors = unwrapError(errors);
  return settled(validations, sync).then(function (results) {
    var nestedErrors = results.filter(function (r) {
      return !r.fulfilled;
    }).reduce(function (arr, _ref2) {
      var error = _ref2.value;

      // we are only collecting validation errors
      if (!_ValidationError.default.isError(error)) {
        throw error;
      }

      return arr.concat(error);
    }, []);
    if (sort) nestedErrors.sort(sort); //show parent errors after the nested ones: name.first, name

    errors = nestedErrors.concat(errors);
    if (errors.length) throw new _ValidationError.default(errors, value, path);
    return value;
  });
}

function runValidations(_ref3) {
  var endEarly = _ref3.endEarly,
      options = (0, _objectWithoutPropertiesLoose2.default)(_ref3, ["endEarly"]);
  if (endEarly) return scopeToValue(options.validations, options.value, options.sync);
  return collectErrors(options);
}

/***/ }),

/***/ "wNDy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ NotFoundError; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ BadRequest; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ ClientSideError; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* binding */ ProposalNotFound; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ errors_ApiException; });

// UNUSED EXPORTS: CmsConfigError, RequestFailed, GraphqlError, OfferNotFound, ZoneNotFound, LandingNotFound, ResortNotFound, PriceNotFound, PageNotFound

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("OZaJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
var setPrototypeOf = __webpack_require__("XcBm");

// CONCATENATED MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/isNativeFunction.js
function _isNativeFunction(fn) {
  try {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  } catch (e) {
    return typeof fn === "function";
  }
}
// CONCATENATED MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
// CONCATENATED MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/construct.js


function construct_construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    construct_construct = Reflect.construct.bind();
  } else {
    construct_construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) Object(setPrototypeOf["a" /* default */])(instance, Class.prototype);
      return instance;
    };
  }
  return construct_construct.apply(null, arguments);
}
// CONCATENATED MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js




function wrapNativeSuper_wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  wrapNativeSuper_wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return construct_construct(Class, arguments, Object(getPrototypeOf["a" /* default */])(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return Object(setPrototypeOf["a" /* default */])(Wrapper, Class);
  };
  return wrapNativeSuper_wrapNativeSuper(Class);
}
// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/error.js/index.js
var error_js = __webpack_require__("x5Ag");
var error_js_default = /*#__PURE__*/__webpack_require__.n(error_js);

// CONCATENATED MODULE: ./src/errors/errors.js












function _createSuper(Derived) {
  var hasNativeReflectConstruct = errors_isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = Object(getPrototypeOf["a" /* default */])(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return Object(possibleConstructorReturn["a" /* default */])(this, result);
  };
}

function errors_isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}


var NotFoundError = error_js_default.a.create({
  name: 'NotFoundError',
  message: 'Content not found',
  statusCode: 404,
  redirect: '/404',
  logLevel: 'warn'
});
var BadRequest = error_js_default.a.create({
  name: 'BadRequest',
  message: 'Bad request',
  statusCode: 400,
  logLevel: 'error'
});
var CmsConfigError = error_js_default.a.create({
  name: 'CmsConfigError',
  message: 'Cms configuration error',
  statusCode: 500,
  logLevel: 'error'
});
var RequestFailed = error_js_default.a.create({
  name: 'RequestFailed',
  message: 'Request failed',
  statusCode: 500,
  logLevel: 'error'
});
var GraphqlError = error_js_default.a.create({
  name: 'GraphqlError',
  message: 'Graphql request failed',
  statusCode: 500,
  logLevel: 'error'
});
var ClientSideError = error_js_default.a.create({
  name: 'ClientSideError',
  message: 'Client side error',
  statusCode: 500,
  logLevel: 'error'
});
var OfferNotFound = error_js_default.a.create({
  name: 'OfferNotFound'
}, NotFoundError);
var ZoneNotFound = error_js_default.a.create({
  name: 'ZoneNotFound'
}, NotFoundError);
var LandingNotFound = error_js_default.a.create({
  name: 'LandingNotFound'
}, NotFoundError);
var ResortNotFound = error_js_default.a.create({
  name: 'ResortNotFound'
}, NotFoundError);
var PriceNotFound = error_js_default.a.create({
  name: 'PriceNotFound'
}, NotFoundError);
var ProposalNotFound = error_js_default.a.create({
  name: 'ProposalNotFound'
}, NotFoundError);
var PageNotFound = error_js_default.a.create({
  name: 'PageNotFound'
}, NotFoundError);
var errors_ApiException = /*#__PURE__*/function (_Error) {
  Object(inherits["a" /* default */])(ApiException, _Error);

  var _super = _createSuper(ApiException);

  function ApiException(errors) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, ApiException);

    _this = _super.call.apply(_super, [this].concat(Object(toConsumableArray["a" /* default */])(errors)));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "apiErrors", void 0);

    _this.name = 'ApiException';
    _this.apiErrors = errors;
    return _this;
  }

  return ApiException;
}( /*#__PURE__*/wrapNativeSuper_wrapNativeSuper(Error));

/***/ }),

/***/ "woxT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ProgressBar_ProgressBar; });

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isInteger.js
var isInteger = __webpack_require__("RYcy");
var isInteger_default = /*#__PURE__*/__webpack_require__.n(isInteger);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/progress-bar/ProgressBar.themes.js
var themes = {
  "default": {
    thRoot: 'bg-darkGrey leading-0 overflow-hidden relative',
    thBar: 'transition-width duration-250 ease-in h-2'
  },
  rounded: {
    thRoot: 'bg-lightSand leading-0 overflow-hidden relative rounded-pill',
    thBar: 'rounded-pill transition-width duration-250 ease-in h-15'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/progress-bar/ProgressBar.jsx

var __jsx = react_default.a.createElement;




var ProgressBar_ProgressBar = function ProgressBar(_ref) {
  var className = _ref.className,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? colors["a" /* COLORS */].SAFFRON : _ref$color,
      _ref$min = _ref.min,
      min = _ref$min === void 0 ? 0 : _ref$min,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? 10 : _ref$max,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      value = _ref.value;

  if (!isInteger_default()(value) || value < 0) {
    return null;
  }

  var stepPercent = 100 / (max - min);
  var currentPercent = stepPercent * (value - min);
  var _themes$theme = themes[theme],
      thBar = _themes$theme.thBar,
      thRoot = _themes$theme.thRoot;
  return __jsx("div", {
    "aria-valuemax": max,
    "aria-valuemin": min,
    "aria-valuenow": value,
    className: Object(classnames_utils["a" /* classnames */])(thRoot, className),
    role: "progressbar"
  }, __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(thBar, "bg-".concat(color)),
    "data-testid": "progress-bar",
    style: {
      width: "".concat(currentPercent, "%")
    }
  }));
};

/***/ }),

/***/ "y/CH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = parseIsoDate;

/* eslint-disable */

/**
 *
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */
//              1 YYYY                 2 MM        3 DD              4 HH     5 mm        6 ss            7 msec         8 Z 9 ±    10 tzHH    11 tzmm
var isoReg = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;

function parseIsoDate(date) {
  var numericKeys = [1, 4, 5, 6, 7, 10, 11],
      minutesOffset = 0,
      timestamp,
      struct;

  if (struct = isoReg.exec(date)) {
    // avoid NaN timestamps caused by “undefined” values being passed to Date.UTC
    for (var i = 0, k; k = numericKeys[i]; ++i) {
      struct[k] = +struct[k] || 0;
    } // allow undefined days and months


    struct[2] = (+struct[2] || 1) - 1;
    struct[3] = +struct[3] || 1; // allow arbitrary sub-second precision beyond milliseconds

    struct[7] = struct[7] ? String(struct[7]).substr(0, 3) : 0; // timestamps without timezone identifiers should be considered local time

    if ((struct[8] === undefined || struct[8] === '') && (struct[9] === undefined || struct[9] === '')) timestamp = +new Date(struct[1], struct[2], struct[3], struct[4], struct[5], struct[6], struct[7]);else {
      if (struct[8] !== 'Z' && struct[9] !== undefined) {
        minutesOffset = struct[10] * 60 + struct[11];
        if (struct[9] === '+') minutesOffset = 0 - minutesOffset;
      }

      timestamp = Date.UTC(struct[1], struct[2], struct[3], struct[4], struct[5] + minutesOffset, struct[6], struct[7]);
    }
  } else timestamp = Date.parse ? Date.parse(date) : NaN;

  return timestamp;
}

module.exports = exports["default"];

/***/ }),

/***/ "y147":
/***/ (function(module) {

module.exports = JSON.parse("[\"ase\",\"art\",\"bmp\",\"blp\",\"cd5\",\"cit\",\"cpt\",\"cr2\",\"cut\",\"dds\",\"dib\",\"djvu\",\"egt\",\"exif\",\"gif\",\"gpl\",\"grf\",\"icns\",\"ico\",\"iff\",\"jng\",\"jpeg\",\"jpg\",\"jfif\",\"jp2\",\"jps\",\"lbm\",\"max\",\"miff\",\"mng\",\"msp\",\"nitf\",\"ota\",\"pbm\",\"pc1\",\"pc2\",\"pc3\",\"pcf\",\"pcx\",\"pdn\",\"pgm\",\"PI1\",\"PI2\",\"PI3\",\"pict\",\"pct\",\"pnm\",\"pns\",\"ppm\",\"psb\",\"psd\",\"pdd\",\"psp\",\"px\",\"pxm\",\"pxr\",\"qfx\",\"raw\",\"rle\",\"sct\",\"sgi\",\"rgb\",\"int\",\"bw\",\"tga\",\"tiff\",\"tif\",\"vtf\",\"xbm\",\"xcf\",\"xpm\",\"3dv\",\"amf\",\"ai\",\"awg\",\"cgm\",\"cdr\",\"cmx\",\"dxf\",\"e2d\",\"egt\",\"eps\",\"fs\",\"gbr\",\"odg\",\"svg\",\"stl\",\"vrml\",\"x3d\",\"sxd\",\"v2d\",\"vnd\",\"wmf\",\"emf\",\"art\",\"xar\",\"png\",\"webp\",\"jxr\",\"hdp\",\"wdp\",\"cur\",\"ecw\",\"iff\",\"lbm\",\"liff\",\"nrrd\",\"pam\",\"pcx\",\"pgf\",\"sgi\",\"rgb\",\"rgba\",\"bw\",\"int\",\"inta\",\"sid\",\"ras\",\"sun\",\"tga\"]");

/***/ }),

/***/ "y2Ah":
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__("wC3K"),
    baseForOwn = __webpack_require__("zKkv"),
    baseIteratee = __webpack_require__("S3pA");

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, key, iteratee(value, key, object));
  });
  return result;
}

module.exports = mapValues;


/***/ }),

/***/ "yWCo":
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__("T0aG")["default"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "yWv5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Radio; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("lTEL");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("kYxP");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("C/y5");
/* harmony import */ var _inputsUtils__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("vpua");
/* harmony import */ var _form_inputs_radio_button_RadioButton__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("zwQs");
















var __jsx = react__WEBPACK_IMPORTED_MODULE_16___default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_14__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var Radio = function Radio(_ref) {
  var className = _ref.className,
      field = _ref.field,
      form = _ref.form,
      isDisabled = _ref.isDisabled,
      isLoading = _ref.isLoading,
      isReadOnly = _ref.isReadOnly,
      isRequired = _ref.isRequired,
      label = _ref.label,
      _onChange = _ref.onChange,
      size = _ref.size,
      _ref$itemsCentered = _ref.itemsCentered,
      itemsCentered = _ref$itemsCentered === void 0 ? true : _ref$itemsCentered;

  var formValue = lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(form.values, field.name, '');

  var _getValidationStatus = Object(_inputsUtils__WEBPACK_IMPORTED_MODULE_18__[/* getValidationStatus */ "d"])(_objectSpread(_objectSpread({}, field), {}, {
    formValue: formValue
  }), form),
      isErrored = _getValidationStatus.isErrored; // values can be integer at form initialize but finally it's always a string, so we ensure it


  var isChecked = formValue.toString() === field.value.toString();
  return __jsx("label", {
    htmlFor: "radio-".concat(field.name, "-").concat(field.value),
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_17__[/* classnames */ "a"])('flex min-h-48 w-full gap-10 text-14', {
      'cursor-pointer': !isDisabled && !isLoading,
      'cursor-wait': isLoading,
      'cursor-not-allowed': isDisabled,
      'formik-errored': isErrored && isRequired,
      'items-center': itemsCentered
    }, className)
  }, __jsx(_form_inputs_radio_button_RadioButton__WEBPACK_IMPORTED_MODULE_19__[/* RadioButton */ "a"], {
    className: size,
    isChecked: isChecked,
    isDisabled: isDisabled || isReadOnly
  }), __jsx("input", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"])({}, field, {
    checked: isChecked,
    className: "sr-only",
    disabled: isDisabled,
    id: "radio-".concat(field.name, "-").concat(field.value),
    type: "radio",
    onChange: function onChange(event) {
      field.onChange(event);

      if (_onChange) {
        _onChange(event);
      }
    }
  })), label && __jsx("span", {
    className: "text-14 leading-normal text-black"
  }, label));
};

/***/ }),

/***/ "ysqo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("1t7P");

__webpack_require__("2G9S");

__webpack_require__("LW0h");

__webpack_require__("jwue");

__webpack_require__("vrRf");

__webpack_require__("lTEL");

__webpack_require__("z84I");

__webpack_require__("KOtZ");

__webpack_require__("wFPu");

__webpack_require__("M+/F");

__webpack_require__("5BYb");

__webpack_require__("daRM");

__webpack_require__("FtHn");

__webpack_require__("+KXO");

__webpack_require__("7x/C");

__webpack_require__("LqLs");

__webpack_require__("87if");

__webpack_require__("3voH");

__webpack_require__("ZUdG");

__webpack_require__("+oxZ");

__webpack_require__("kYxP");

var _defineProperty = __webpack_require__("O5Wi");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

exports.__esModule = true;
exports.defaultHead = defaultHead;
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__("ERkP"));

var _sideEffect = _interopRequireDefault(__webpack_require__("J9Yr"));

var _ampContext = __webpack_require__("TZT2");

var _headManagerContext = __webpack_require__("op+c");

var _amp = __webpack_require__("dq4L");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function defaultHead() {
  var inAmpMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var head = [/*#__PURE__*/_react.default.createElement("meta", {
    charSet: "utf-8"
  })];

  if (!inAmpMode) {
    head.push( /*#__PURE__*/_react.default.createElement("meta", {
      name: "viewport",
      content: "width=device-width"
    }));
  }

  return head;
}

function onlyReactElement(list, child) {
  // React children can be "string" or "number" in this case we ignore them for backwards compat
  if (typeof child === 'string' || typeof child === 'number') {
    return list;
  } // Adds support for React.Fragment


  if (child.type === _react.default.Fragment) {
    return list.concat(_react.default.Children.toArray(child.props.children).reduce(function (fragmentList, fragmentChild) {
      if (typeof fragmentChild === 'string' || typeof fragmentChild === 'number') {
        return fragmentList;
      }

      return fragmentList.concat(fragmentChild);
    }, []));
  }

  return list.concat(child);
}

var METATYPES = ['name', 'httpEquiv', 'charSet', 'itemProp'];
/*
returns a function for filtering head child elements
which shouldn't be duplicated, like <title/>
Also adds support for deduplicated `key` properties
*/

function unique() {
  var keys = new Set();
  var tags = new Set();
  var metaTypes = new Set();
  var metaCategories = {};
  return function (h) {
    var isUnique = true;

    if (h.key && typeof h.key !== 'number' && h.key.indexOf('$') > 0) {
      var key = h.key.slice(h.key.indexOf('$') + 1);

      if (keys.has(key)) {
        isUnique = false;
      } else {
        keys.add(key);
      }
    } // eslint-disable-next-line default-case


    switch (h.type) {
      case 'title':
      case 'base':
        if (tags.has(h.type)) {
          isUnique = false;
        } else {
          tags.add(h.type);
        }

        break;

      case 'meta':
        for (var i = 0, len = METATYPES.length; i < len; i++) {
          var metatype = METATYPES[i];
          if (!h.props.hasOwnProperty(metatype)) continue;

          if (metatype === 'charSet') {
            if (metaTypes.has(metatype)) {
              isUnique = false;
            } else {
              metaTypes.add(metatype);
            }
          } else {
            var category = h.props[metatype];
            var categories = metaCategories[metatype] || new Set();

            if (categories.has(category)) {
              isUnique = false;
            } else {
              categories.add(category);
              metaCategories[metatype] = categories;
            }
          }
        }

        break;
    }

    return isUnique;
  };
}
/**
*
* @param headElements List of multiple <Head> instances
*/


function reduceComponents(headElements, props) {
  return headElements.reduce(function (list, headElement) {
    var headElementChildren = _react.default.Children.toArray(headElement.props.children);

    return list.concat(headElementChildren);
  }, []).reduce(onlyReactElement, []).reverse().concat(defaultHead(props.inAmpMode)).filter(unique()).reverse().map(function (c, i) {
    var key = c.key || i;

    if (false) { var newProps; }

    return /*#__PURE__*/_react.default.cloneElement(c, {
      key: key
    });
  });
}
/**
* This component injects elements to `<head>` of your page.
* To avoid duplicated `tags` in `<head>` you can use the `key` property, which will make sure every tag is only rendered once.
*/


function Head(_ref) {
  var children = _ref.children;
  var ampState = (0, _react.useContext)(_ampContext.AmpStateContext);
  var headManager = (0, _react.useContext)(_headManagerContext.HeadManagerContext);
  return /*#__PURE__*/_react.default.createElement(_sideEffect.default, {
    reduceComponentsToState: reduceComponents,
    headManager: headManager,
    inAmpMode: (0, _amp.isInAmpMode)(ampState)
  }, children);
} // TODO: Remove in the next major release


Head.rewind = function () {};

var _default = Head;
exports.default = _default;

/***/ }),

/***/ "zBae":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.getIn = getIn;
exports.default = void 0;

var _propertyExpr = __webpack_require__("dFUt");

var _has = _interopRequireDefault(__webpack_require__("1mr4"));

var trim = function trim(part) {
  return part.substr(0, part.length - 1).substr(1);
};

function getIn(schema, path, value, context) {
  var parent, lastPart, lastPartDebug; // if only one "value" arg then use it for both

  context = context || value;
  if (!path) return {
    parent: parent,
    parentPath: path,
    schema: schema
  };
  (0, _propertyExpr.forEach)(path, function (_part, isBracket, isArray) {
    var part = isBracket ? trim(_part) : _part;

    if (isArray || (0, _has.default)(schema, '_subType')) {
      // we skipped an array: foo[].bar
      var idx = isArray ? parseInt(part, 10) : 0;
      schema = schema.resolve({
        context: context,
        parent: parent,
        value: value
      })._subType;

      if (value) {
        if (isArray && idx >= value.length) {
          throw new Error("Yup.reach cannot resolve an array item at index: " + _part + ", in the path: " + path + ". " + "because there is no value at that index. ");
        }

        value = value[idx];
      }
    }

    if (!isArray) {
      schema = schema.resolve({
        context: context,
        parent: parent,
        value: value
      });
      if (!(0, _has.default)(schema, 'fields') || !(0, _has.default)(schema.fields, part)) throw new Error("The schema does not contain the path: " + path + ". " + ("(failed at: " + lastPartDebug + " which is a type: \"" + schema._type + "\") "));
      schema = schema.fields[part];
      parent = value;
      value = value && value[part];
      lastPart = part;
      lastPartDebug = isBracket ? '[' + _part + ']' : '.' + _part;
    }
  });
  return {
    schema: schema,
    parent: parent,
    parentPath: lastPart
  };
}

var reach = function reach(obj, path, value, context) {
  return getIn(obj, path, value, context).schema;
};

var _default = reach;
exports.default = _default;

/***/ }),

/***/ "zwQs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RadioButton; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("C/y5");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("SPKZ");
/* harmony import */ var _utils_keyCodes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("05v4");
/* harmony import */ var _icon_Icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("qBqs");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;





var RadioButton = function RadioButton(_ref) {
  var className = _ref.className,
      dataTestid = _ref.dataTestid,
      isChecked = _ref.isChecked,
      isDisabled = _ref.isDisabled,
      onClick = _ref.onClick,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex;

  var _onClick = function _onClick(event) {
    if (!isDisabled && onClick) {
      onClick(event);
    }
  };

  var _onKeyPress = function _onKeyPress(event) {
    if (event.which === _utils_keyCodes__WEBPACK_IMPORTED_MODULE_3__[/* ENTER */ "f"]) {
      _onClick(event);
    }
  };

  return __jsx("span", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__[/* classnames */ "a"])('outline-custom-sibling flex size-24 shrink-0 rounded-full border border-black p-2 text-saffron', {
      'cursor-not-allowed border-grey bg-pearl text-lightGrey': isDisabled
    }, className),
    "data-testid": dataTestid,
    role: "button",
    tabIndex: tabIndex,
    onClick: _onClick,
    onKeyPress: _onKeyPress
  }, __jsx(_icon_Icon__WEBPACK_IMPORTED_MODULE_4__[/* Icon */ "a"], {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__[/* classnames */ "a"])({
      'opacity-0': !isChecked
    }),
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__[/* ICONS */ "a"].FAT_DOT,
    width: "100%"
  }));
};

/***/ })

},[["BDDS",3,4,1,6,0,5,7,8,9,35]]]);